var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessWelcomeBannerTabletOffice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 457.3,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0 0h289v300H0z",
    "data-name": "Rectangle 9435"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M139 11C129 0 108-1 94 1c0 0-15 4-18 11L58 46 34 59l-16 3-13-4c-3 0-6 5-5 7s8 5 12 4c2 2 43-6 47-6s25-28 25-28 1 24 0 34-6 12-5 12 9 5 30 5 30-6 30-6l9-44c1-9 1-13-9-25",
    "data-name": "Path 70626"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M51 1S36 5 33 12L15 46 0 54q5 5 6 12l10-3c4-2 24-28 24-28s2 24 0 34q-3 12-5 12c2 3 2 7 13 8l18-3c20 1 30-6 30-6l8-44c1-9 2-13-8-24S65-1 51 1",
    "data-name": "Path 70637"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5 1Q1 11 4 19c0 2-4 5-4 6l3 1s4 11 6 12 15-5 17-6 2-16-1-21S11-3 5 1",
    "data-name": "Path 70657"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M29 67 14 24V6l-1-2-4-4-2 2-5 3v2L0 9l5 16 10 46q4 12 8 13s5-3 6-7",
    "data-name": "Path 70674"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0 0h289v300H0z",
    "data-name": "Rectangle 9435"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.5,
    x2: 0.5,
    y1: 0.2,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57485",
    transform: "translate(0 -355)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    d: "M1228 669h93",
    "data-name": "Path 71986",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    d: "M755 669h424",
    "data-name": "Path 71987",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    d: "M1707 669h213",
    "data-name": "Path 71988",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    d: "M1233 661h88",
    "data-name": "Path 71986",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    d: "M756 661h420",
    "data-name": "Path 71987",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    d: "M1707 661h213",
    "data-name": "Path 71988",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.3,
    cy: 11.3,
    fill: "#627680",
    stroke: "#707070",
    "data-name": "Ellipse 1402",
    opacity: 0.1,
    rx: 116.3,
    ry: 11.3,
    transform: "translate(1510 734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1594 512",
    "data-name": "Path 70406",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M1733 776h137z",
    "data-name": "Path 70113",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m1756 766 53 26-1 1z",
    "data-name": "Path 71895",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "freepik--Floor--inject-5",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M427 786h137z",
    "data-name": "Path 70113"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "freepik--Floor--inject-5",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M790 766h105z",
    "data-name": "Path 70113"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "freepik--Floor--inject-5",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M1153 722h-105z",
    "data-name": "Path 70113"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m850 759-11 26h1z",
    "data-name": "Path 70113",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m1071 713 21 21v1z",
    "data-name": "Path 71896",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m556 775-52 26v1h1z",
    "data-name": "Path 71894",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57402"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57376",
    opacity: 0.8,
    transform: "translate(1149 558)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.7,
    cy: 5,
    fill: "#627680",
    "data-name": "Ellipse 1416",
    opacity: 0.1,
    rx: 42.7,
    ry: 5,
    transform: "translate(21 117)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#263238",
    "data-name": "Group 57375"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f3f6f6",
    d: "M39 53s-2-6-7-8H20q-10 2-20 6-1-2 15 4l14 4c4 0 10-1 10-6Z",
    "data-name": "Path 71273"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f3f6f6",
    d: "M39 37s0-6-4-9l-11-4-21 1s3 0 12 8l13 7q8 2 11-3Z",
    "data-name": "Path 71274"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f3f6f6",
    d: "M51 58s-4-4-4-9q0-6 3-10 6-8 14-15s-2 2-1 14l-2 14c-2 3-5 8-10 6Z",
    "data-name": "Path 71275"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f3f6f6",
    d: "M68 67s0-6 4-10q4-3 10-4 10-3 21-2s-3 0-12 9l-11 8q-7 4-12-1Z",
    "data-name": "Path 71276"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f3f6f6",
    d: "M67 47s-6-1-9-6q-3-5-2-10 1-10 3-20s-1 3 7 13l6 13c0 3 0 9-5 10Z",
    "data-name": "Path 71277"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f3f6f6",
    d: "M85 36s4 4 10 4l10-5q8-6 15-14s-2 2-15 3l-15 3c-3 2-8 5-5 9Z",
    "data-name": "Path 71278"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f3f6f6",
    d: "M80 32s6 1 10-3l5-10 1-19s0 3-10 11l-8 11c-2 3-3 9 2 10Z",
    "data-name": "Path 71279"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M58 88 47 64 35 36",
    "data-name": "Path 71280"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m60 84 11-34 11-21",
    "data-name": "Path 71281"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m64 70 11-5",
    "data-name": "Line 1710"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m71 50-5-11",
    "data-name": "Line 1711"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m77 39 13-5",
    "data-name": "Line 1712"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m49 68 5-17",
    "data-name": "Line 1713"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m43 55-10-5",
    "data-name": "Line 1714"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m69 121-14 1-15-1-4-44h38Z",
    "data-name": "Path 71872"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f3f6f6",
    d: "m66 75 5-2 6 2 8 8-8-1-7-2q-4-2-4-5Z",
    "data-name": "Path 71911"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m63 75 6 2",
    "data-name": "Line 1724"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f3f6f6",
    d: "M48 70s-5-3-10-1q-4 2-7 6-5 7-9 16s1-2 12-5l11-6q6-4 3-10Z",
    "data-name": "Path 71916"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m49 66-9 7",
    "data-name": "Line 1725"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    d: "M700 669h-74",
    "data-name": "Path 71984",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    d: "M182 669H0",
    "data-name": "Path 73193",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    d: "M607 669h-11",
    "data-name": "Path 71998",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    d: "M700 661h-74",
    "data-name": "Path 71984",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    d: "M182 661H0",
    "data-name": "Path 73192",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    d: "M607 661h-10",
    "data-name": "Path 71997",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57403"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57395",
    opacity: 0.8,
    transform: "translate(670 509)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.9,
    cy: 6.3,
    fill: "#627680",
    "data-name": "Ellipse 1414",
    opacity: 0.1,
    rx: 51.9,
    ry: 6.3,
    transform: "translate(0 171)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "M25 43s-3 6-8 7-13-8-8-13 13 3 16 6",
    "data-name": "Path 70117"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M17 51q-7-1-9-7-2-4 1-7l5-2q7 3 11 8c0 1-2 7-8 7zm-4-15-3 2q-3 3-1 6 3 5 8 6c4-1 7-6 7-7q-3-4-10-7z",
    "data-name": "Path 70118"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "M32 14s-7 16-4 25 21 14 26 3-7-25-11-29-9-2-11 1",
    "data-name": "Path 70119"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M44 48h-1q-12-1-16-9c-3-8 4-25 5-25l4-3 7 2c5 3 17 19 11 29q-3 6-10 6M33 14c-1 1-8 17-5 24q5 8 15 9 6 2 10-5c6-10-6-25-10-28l-7-2z",
    "data-name": "Path 70120"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "M74 21S62 31 61 42s6 15 15 13 13-22 11-31-13-3-13-3",
    "data-name": "Path 70121"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M73 56a14 14 0 0 1-10-3q-4-4-3-11c1-11 14-21 14-21q2-3 9-3l4 5c2 7 0 21-5 28q-3 4-6 5zm2-35c-1 1-13 11-14 21q-1 6 3 10 4 5 12 3l5-4c5-7 7-21 5-27l-3-5q-7 0-8 2",
    "data-name": "Path 70122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "M77 80s-14 0-15 7 6 7 13 2 8-9 2-9",
    "data-name": "Path 70123"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m67 93-3-1-2-6c0-6 14-7 15-7l4 2q2 2-6 8-4 4-8 4m10-13c-1 0-14 1-14 7q0 3 2 4 4 2 10-3 6-6 5-7z",
    "data-name": "Path 70124"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M63 88zl16-6v1z",
    "data-name": "Path 70125"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "M80 121s-10-9-16-5-1 9 8 10 12-1 8-5",
    "data-name": "Path 70126"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M75 126h-3q-8 0-10-5-1-3 2-5c6-5 16 4 16 4l2 4q-1 2-7 2m-7-11-3 1q-3 3-2 5 2 4 9 4 10 1 9-1l-2-3s-6-6-11-6",
    "data-name": "Path 70127"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M79 124c-4-3-16-6-16-7h1z",
    "data-name": "Path 70128"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "M26 118s14-12 21-7 2 13-10 14-16-1-11-7",
    "data-name": "Path 70129"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M33 126q-9 0-10-3-1-2 3-5c0-1 14-13 21-7q4 3 3 8-2 6-13 7zm-7-8-2 5q0 2 13 2 9-1 13-7l-3-6c-7-5-20 6-21 6",
    "data-name": "Path 70130"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M27 123v-1c6-4 21-9 21-9h1c-1 1-16 6-22 10",
    "data-name": "Path 70131"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "M42 93s-1 6-6 9-15-3-10-11 14-1 16 2",
    "data-name": "Path 70132"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m33 103-7-3q-4-4 0-9l6-4q7 1 11 6s-2 7-7 9zm-1-15-6 3q-2 4 1 9 5 6 8 1 7-5 7-8-3-4-10-5",
    "data-name": "Path 70133"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "M30 72s-3-5-13-2-14 9-8 11 21-9 21-9",
    "data-name": "Path 70134"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M11 82H9l-3-3q0-5 11-9c11-4 13 2 14 2l-1 1s-12 9-19 9m13-12-7 1Q7 75 7 79q0 2 3 2c5 2 17-7 19-9q0-1-5-2",
    "data-name": "Path 70135"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M12 78zc6-4 17-5 17-5v1s-11 1-16 5",
    "data-name": "Path 70136"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "M59 7s2 4 5 3 5-6 10-4 10 7 10 4S77 0 69 0 59 3 59 7",
    "data-name": "Path 70137"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m84 11-3-1-7-4q-5 0-6 2l-4 2q-5 1-5-3 0-7 11-7c7 0 15 7 15 10zM72 5h2l7 4 3 1c0-2-7-9-15-9q-9 0-10 6 1 2 5 3l3-2q2-3 5-3",
    "data-name": "Path 70138"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m49 87-2-4c-5-12-16-10-17-10v-1s13-2 18 11z",
    "data-name": "Path 70139"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "M82 60s3-6 13-2 14 9 8 11-21-9-21-9",
    "data-name": "Path 70140"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M101 69c-7 0-19-9-19-9 0-1 3-6 13-3q11 5 11 9 1 1-3 3zm-18-9c2 1 14 10 20 8l2-2q0-3-10-8c-9-3-12 1-12 2",
    "data-name": "Path 70141"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M99 66c-4-6-14-5-14-5l-1-1c1 0 11-1 16 5Z",
    "data-name": "Path 70142"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M74 61zl9-1v1z",
    "data-name": "Path 70143"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M36 50q-10-7-12-6c-2 1-8-2-12 0 3-3 12-1 13-1q1-1 12 7Z",
    "data-name": "Path 70144"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M37 18zv3h-1Z",
    "data-name": "Path 71991"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M53 140h-1V79c-1-14-8-31-8-31l-6-26h1l6 26s6 17 8 31 0 61 0 61",
    "data-name": "Path 70145"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m77 30 2-3v1l-1 2Z",
    "data-name": "Path 71992"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M56 140h-1s0-43 2-55 8-31 8-31l11-22 1 1-11 21s-7 19-8 31z",
    "data-name": "Path 70146"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M58 140zl5-52h1z",
    "data-name": "Path 70147"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M48 140zs1-39-1-44q0-3-2-3h-2s-8 1-10 5h-1c3-4 10-6 11-6h2q3 0 3 4c2 5 1 43 1 44",
    "data-name": "Path 70148"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M50 140zs3-38 0-50h1c2 12 0 50 0 50",
    "data-name": "Path 70149"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M59 140c0-2 0-57 5-70l7-8-6 9c-5 12-5 69-5 69Z",
    "data-name": "Path 70150"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M54 140zc2-8-1-57-8-76l-7-12 1-1 7 13c7 19 10 68 8 76",
    "data-name": "Path 70151"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M56 140h-1V69h1z",
    "data-name": "Path 70152"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M56 66zl4-59q-1-3 11-5v1c-9 0-10 4-11 4v1l-2 19z",
    "data-name": "Path 70153"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "M45 84s-7-6-5-9 21-5 27-1-7 9-11 10-10 1-11 0",
    "data-name": "Path 70154"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m50 85-5-1q-3-1-6-7l1-2c3-4 21-6 27-2l1 3c0 4-9 8-12 9zm-5-1h11c3-1 11-5 11-8l-1-2c-5-4-22-2-25 1l-1 2c0 3 5 6 5 7",
    "data-name": "Path 70155"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M52 81h-1v-2h1z",
    "data-name": "Path 70156"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m53 77-1-1 2-4z",
    "data-name": "Path 70157"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "M45 124s-7-6-5-9 21-6 27-2-7 10-11 11-10 1-11 0",
    "data-name": "Path 70158"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m50 125-5-1q-3-1-6-7l1-3c3-3 21-5 27-1l1 3c0 4-9 7-12 8zm-5-2q3 2 11 0c3-1 11-4 11-7l-1-2c-5-4-22-2-25 1l-1 1c0 3 5 7 5 7",
    "data-name": "Path 70159"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M52 120h-1l3-9v1z",
    "data-name": "Path 70160"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "M50 107s-5-4-3-6 14-4 18-1-4 6-7 7-7 1-8 0",
    "data-name": "Path 70161"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m54 108-4-1-4-5 1-2c2-2 15-3 18 0l1 2c0 2-6 5-8 5zm-4-1h8c2-1 7-3 7-5a1 1 0 0 0 0-2c-4-2-16-1-17 1l-1 1q2 3 3 5",
    "data-name": "Path 70162"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M55 105zl2-7 1 1z",
    "data-name": "Path 70163"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m707 684 15 1 16-1 2-37h-35Z",
    "data-name": "Path 71990"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57398",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57356"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    "data-name": "Mask Group 587",
    transform: "translate(1327 362)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "slider illustration",
    transform: "translate(-310 47)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#627680",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588 146V68h-21v39h-9V81h-15v39h-9V97h-6v24h-5V98h-6v23h-9v-3h-15V88h-23v29h-37V68h-26v22h-16V64h-25v58h-6V92h-23v16h-12v32h-14 14v-33h12V92h23v30h6V64h25v25h15V67h27v50h36V87h25v30h14v4h9V98h7v23h3V96h8v24h8V80h15v26h9V68h22z",
    "data-name": "Path 1702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 116h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1703"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336 116h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1704"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 116h-3v-3h3Zm-3-1h3v-2h-3Z",
    "data-name": "Path 1705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 116h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1706"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349 116h-4v-3h4Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353 116h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1708"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373 96h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1709"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377 96h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1710"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 96h-3v-3h3Zm-3 0h3v-3h-3Z",
    "data-name": "Path 1711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 96h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373 91h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377 91h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 91h-3v-3h3Zm-3 0h3v-3h-3Z",
    "data-name": "Path 1715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 91h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1716"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373 86h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377 86h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 86h-3v-3h3Zm-3 0h3v-2h-3Z",
    "data-name": "Path 1719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 86h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1720"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373 82h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1721"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377 82h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 82h-3v-3h3Zm-3-1h3v-2h-3Z",
    "data-name": "Path 1723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 82h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373 77h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377 77h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 77h-3v-3h3Zm-3-1h3v-2h-3Z",
    "data-name": "Path 1727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 77h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390 96h-4v-3h4Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394 96h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373 101h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377 101h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1732"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 101h-3v-3h3Zm-3 0h3v-2h-3Z",
    "data-name": "Path 1733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 101h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1734"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390 101h-4v-3h4Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394 101h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1736"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 121h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336 121h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 121h-3v-3h3Zm-3 0h3v-3h-3Z",
    "data-name": "Path 1739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 121h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1740"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349 121h-4v-3h4Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1741"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353 121h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 127h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336 127h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 127h-3v-3h3Zm-3-1h3v-2h-3Z",
    "data-name": "Path 1745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 127h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349 127h-4v-3h4Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353 127h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 132h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336 132h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1750"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 132h-3v-3h3Zm-3 0h3v-2h-3Z",
    "data-name": "Path 1751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 132h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349 132h-4v-3h4Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353 132h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 138h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336 138h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 138h-3v-3h3Zm-3 0h3v-3h-3Z",
    "data-name": "Path 1757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 138h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349 138h-4v-3h4Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353 138h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578 76h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582 76h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1762"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586 76h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1763"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578 83h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582 83h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1765"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586 83h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578 90h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582 90h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586 90h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578 96h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582 96h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586 96h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578 103h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1773"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582 103h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586 103h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1775"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578 109h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582 109h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586 109h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578 116h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1779"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582 116h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586 116h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1781"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578 123h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582 123h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1783"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586 123h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578 129h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582 129h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550 90h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554 90h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550 96h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554 96h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550 103h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554 103h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550 109h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554 109h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550 116h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554 116h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550 123h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554 123h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1798"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550 129h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554 129h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476 96h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1801"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 96h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1802"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476 103h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1803"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 103h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1804"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476 109h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1805"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 109h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1806"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476 116h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 116h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476 123h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1809"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 123h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1810"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476 129h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 129h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485 96h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489 96h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485 103h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489 103h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485 109h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1817"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489 109h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485 116h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1819"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489 116h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1820"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485 123h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1821"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489 123h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1822"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485 129h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489 129h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1824"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 76h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 76h-3v-3h3Zm-3 0h3v-2h-3Z",
    "data-name": "Path 1826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 83h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 83h-3v-3h3Zm-3 0h3v-3h-3Z",
    "data-name": "Path 1828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 90h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 90h-3v-3h3Zm-3-1h3v-2h-3Z",
    "data-name": "Path 1830"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 96h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 96h-3v-3h3Zm-3 0h3v-2h-3Z",
    "data-name": "Path 1832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 103h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 103h-3v-3h3Zm-3-1h3v-2h-3Z",
    "data-name": "Path 1834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 109h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 109h-3v-3h3Zm-3 0h3v-2h-3Z",
    "data-name": "Path 1836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 116h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 116h-3v-3h3Zm-3 0h3v-3h-3Z",
    "data-name": "Path 1838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 123h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 123h-3v-3h3Zm-3-1h3v-2h-3Z",
    "data-name": "Path 1840"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 129h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1841"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 129h-3v-3h3Zm-3 0h3v-2h-3Z",
    "data-name": "Path 1842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586 129h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1843"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.5,
    cy: 5.3,
    fill: "#ecf0f1",
    "data-name": "Ellipse 32",
    rx: 53.5,
    ry: 5.3,
    transform: "translate(404 300)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m199 260 4 2 3-2 4 2 3-2 4 2v3h-18Z",
    "data-name": "Path 62423",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#627680",
    "data-name": "freepik--City--inject-351",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 161zV83h21v38h10V96h15v39h8v-24h7v25h5v-23h5v23h10v-4h14v-30h24v30h37V82h26v23h16V79h25v58h6v-30h22v15h12v33h14v-1h-13v-32h-12v-15h-24v30h-5V79h-26v25h-15V82h-27v50h-36v-30H95v30H80v4h-8v-24h-7v24h-4v-25h-7v23h-8V95H30v26h-8V82H0z",
    "data-name": "Path 1702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 130h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1703"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 130h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1704"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249 130h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 130h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1706"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 130h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 130h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1708"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 111h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1709"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 111h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1710"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 111h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 111h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 106h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 106h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 106h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 106h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1716"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 101h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 101h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 101h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 101h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1720"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 96h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1721"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 96h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 96h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 96h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 92h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 92h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 92h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 92h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 111h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 111h3v-3h-3Zm3-1h-3v-2h2Z",
    "data-name": "Path 1730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 116h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 116h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1732"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 116h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 116h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1734"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 116h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 116h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1736"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 136h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 136h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249 136h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 136h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1740"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 136h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1741"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 136h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 141h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 141h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249 141h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 141h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 141h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 141h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 147h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 147h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1750"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249 147h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 147h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 147h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 147h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 153h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 153h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249 153h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 153h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 153h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 153h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 91h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 91h3v-3H7Zm2 0H7v-3h2Z",
    "data-name": "Path 1762"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 91h3v-3H2Zm3 0H3v-3h2Z",
    "data-name": "Path 1763"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 98h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 98h3v-3H7Zm2-1H7v-2h2Z",
    "data-name": "Path 1765"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 98h3v-3H2Zm3-1H3v-2h2Z",
    "data-name": "Path 1766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 104h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 104h3v-3H7Zm2 0H7v-2h2Z",
    "data-name": "Path 1768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 104h3v-3H2Zm3 0H3v-2h2Z",
    "data-name": "Path 1769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 111h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 111h3v-3H7Zm2 0H7v-3h2Z",
    "data-name": "Path 1771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 111h3v-3H2Zm3 0H3v-3h2Z",
    "data-name": "Path 1772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 118h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1773"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 118h3v-3H7Zm2-1H7v-2h2Z",
    "data-name": "Path 1774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 118h3v-3H2Zm3-1H3v-2h2Z",
    "data-name": "Path 1775"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 124h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 124h3v-3H7Zm2 0H7v-2h2Z",
    "data-name": "Path 1777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 124h3v-3H2Zm3 0H3v-2h2Z",
    "data-name": "Path 1778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 131h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1779"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 131h3v-3H7Zm2-1H7v-2h2Z",
    "data-name": "Path 1780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 131h3v-3H2Zm3-1H3v-2h2Z",
    "data-name": "Path 1781"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 137h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 137h3v-3H7Zm2 0H7v-2h2Z",
    "data-name": "Path 1783"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 137h3v-3H2Zm3 0H3v-2h2Z",
    "data-name": "Path 1784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 144h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 144h3v-3H7Zm2 0H7v-3h2Z",
    "data-name": "Path 1786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 104h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 104h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 111h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 111h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 118h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 118h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 124h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 124h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 131h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 131h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 137h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 137h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1798"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 144h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 144h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 111h3v-3h-3Zm3 0h-3v-3h3Z",
    "data-name": "Path 1801"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 111h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1802"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 118h3v-3h-3Zm3-1h-3v-2h3Z",
    "data-name": "Path 1803"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 118h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1804"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 124h3v-3h-3Zm3 0h-3v-2h3Z",
    "data-name": "Path 1805"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 124h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1806"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 131h3v-3h-3Zm3-1h-3v-2h3Z",
    "data-name": "Path 1807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 131h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 137h3v-3h-3Zm3 0h-3v-2h3Z",
    "data-name": "Path 1809"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 137h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1810"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 144h3v-3h-3Zm3 0h-3v-3h3Z",
    "data-name": "Path 1811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 144h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 111h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 111h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 118h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 118h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 124h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1817"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 124h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 131h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1819"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 131h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1820"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 137h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1821"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 137h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1822"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 144h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 144h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1824"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 91h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 91h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 98h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 98h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 104h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 104h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1830"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 111h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 111h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 118h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 118h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 124h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 124h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 131h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 131h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 137h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 137h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1840"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 144h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1841"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 144h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 144h3v-3H2Zm3 0H3v-3h2Z",
    "data-name": "Path 1843"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 91"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 90",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(27 106)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M15 123c0-3 7 2 7 2l-1-6c0-4 5 1 5 1s-4-6-3-12 7 1 7 1l-3-11c0-3 14 3 14 3l-2-7q0-3 5 0 1-3 3-2v-1q1-2 6 3l5-8q3-2 7 3l3 1 1-1c0-4 4 0 6 3l3 1 4-9c5-4 15 9 15 9s6-9 9-4-1 14-1 14l3-4 7 2s-2-5 0-7c3-2 7 4 7 6l-1-11c2-7 8 2 8 2s-1-9 4-10-2 0 3 8 3-5 11-5 6 26 6 26l31-15s1-2 6-3 2 6 2 6 7-6 10-6l6 7 1-1c2-3 3 4 4 8l1 1q0-4 4-5c4 0 2 11 1 14q1-4 5-6c3-1 0 9 0 9l4-1-2 9 5 8-19-9H110l4 6H17s-3-5-2-9",
    "data-name": "Path 2172"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M119 136q1-7 6-12c5-3 14 2 18 0s-5-27 10-29 22 24 29 26 10-6 19-7c9 0 25 18 29 22Z",
    "data-name": "Path 2174"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M119 136q1-7 6-12c5-3 14 2 18 0s-5-27 10-29 22 24 29 26 10-6 19-7c9 0 25 18 29 22Z",
    "data-name": "Path 2175",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M154 132h-4l-2-67-5-12 5 8-1-7-7-14 7 9 1-20 1 12 3-2-3 4 1 15 3-4-2 7Z",
    "data-name": "Path 2176"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8adaf",
    d: "M202 132h-4l-2-67-5-11 5 7-1-7-7-14 7 9 1-20 1 12 3-2-3 4 1 15 3-4-3 7Z",
    "data-name": "Path 2177"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M100 132h-4l-2-52-5-8 5 5-1-5-7-10 7 6 1-15 1 9 3-1-3 3 1 11 3-3-3 5Z",
    "data-name": "Path 2178"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M141 132h-4l-2-52-4-8 5 5-1-5-8-10 8 6V53l1 9 4-1-3 3 1 11 2-3-2 5Z",
    "data-name": "Path 2179"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M114 132h-4l-2-52-5-8 5 5v-5l-8-10 7 6 1-15 1 9 4-1-4 3 1 11 3-3-2 5Z",
    "data-name": "Path 2180"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M35 132h-3l-3-67-4-11 5 7-1-7-8-14 8 9V29l1 12 4-2-3 4 1 15 3-4-3 7Z",
    "data-name": "Path 2181"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8a9094",
    d: "M57 132h-4l-2-67-5-11 5 7-1-7-7-14 7 9 1-20 1 12 3-2-3 4 1 15 3-4-3 7Z",
    "data-name": "Path 2182"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M94 132h-4l-2-67-5-11 5 7-1-7-7-14 7 9 1-20 1 12 3-2-3 4 1 15 3-4-3 7Z",
    "data-name": "Path 2183"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M40 136q2-7 5-12c5-3 12 2 16 0s-5-27 9-29 18 24 24 26 9-6 17-7c7 0 22 18 25 22Z",
    "data-name": "Path 2184"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M40 136q2-7 5-12c5-3 12 2 16 0s-5-27 9-29 18 24 24 26 9-6 17-7c7 0 22 18 25 22Z",
    "data-name": "Path 2185",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M101 31s8 0 10 11-4 13 3 18 9 10 5 12-5 5-1 9 5 10-11 14-28-5-29-12 5-10 5-15-11-10-9-17 12-5 16-10 3-10 11-10",
    "data-name": "Path 2186"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M101 31s8 0 10 11-4 13 3 18 9 10 5 12-5 5-1 9 5 10-11 14-28-5-29-12 5-10 5-15-11-10-9-17 12-5 16-10 3-10 11-10",
    "data-name": "Path 2187",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#92989b",
    d: "M107 134h-3l-4-66-4-10 4 7-1-6-6-11 6 7 1-16v10l3-2-2 3 1 12 2-3-2 5Z",
    "data-name": "Path 2188"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M149 136q-1-7-4-11c-3-3-9 2-12 0s4-25-6-26-14 21-19 24-6-6-12-7c-6 0-17 16-19 20Z",
    "data-name": "Path 2189"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M149 136q-1-7-4-11c-3-3-9 2-12 0s4-25-6-26-14 21-19 24-6-6-12-7c-6 0-17 16-19 20Z",
    "data-name": "Path 2190",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M111 136q1-5 3-7c3-3 8 1 11-1s-3-17 6-18 12 15 17 17 5-4 11-5c5 0 14 11 17 14Z",
    "data-name": "Path 2191"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M214 97s7 1 18-8-10-38-19-45-25 36-18 43 13 10 19 10",
    "data-name": "Path 2192"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M214 97s7 1 18-8-10-38-19-45-25 36-18 43 13 10 19 10",
    "data-name": "Path 2193",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m217 132-1-44 5-5-6 3v-8l7-7-6 4 1-5-2 2-2-15v24l-13-6 13 9v49",
    "data-name": "Path 2194"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M35 61s7 0 18-8S42 14 34 7 9 43 15 51s13 9 20 10",
    "data-name": "Path 2195"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8adaf",
    d: "m41 130-4-79 5-5-6 3v-8l7-7-6 5v-6l-2 3-1-16-1 24-13-6 13 9v4l3 80",
    "data-name": "Path 2196"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m197 135 2-2h3l1-4 4-4 8 1c4 3 3 5 5 5s4-2 7 0l4 4Z",
    "data-name": "Path 2197"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m197 135 2-2h3l1-4 4-4 8 1c4 3 3 5 5 5s4-2 7 0l4 4Z",
    "data-name": "Path 2198",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m228 135-3-3c-2 0-3 3-6 1s-5-8-9-8-5 5-4 6-3 2-4 2l-3 2",
    "data-name": "Path 2199"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m224 135 1-1",
    "data-name": "Line 258"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m214 135-4-8",
    "data-name": "Line 259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m212 128-1 2-3-1",
    "data-name": "Path 2200"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m215 130-2 3-4-1",
    "data-name": "Path 2201"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m125 134 1-2h4l1-4a6 6 0 0 1 5-5 11 11 0 0 1 9 2q3 4 5 5c2 1 4-2 8-1l5 5Z",
    "data-name": "Path 2202"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m125 134 1-2h4l1-4a6 6 0 0 1 5-5 11 11 0 0 1 9 2q3 4 5 5c2 1 4-2 8-1l5 5Z",
    "data-name": "Path 2203",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m154 134 2-1",
    "data-name": "Line 260"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m143 134-4-8",
    "data-name": "Line 261"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m141 126-1 3-3-2",
    "data-name": "Path 2204"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m144 129-2 3-4-1",
    "data-name": "Path 2205"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M185 0s11 0 14 15-5 19 5 27 12 13 7 17-8 7-1 13 7 15-16 20-41-8-42-17 7-14 7-22-15-14-14-24 19-7 24-15 5-14 16-14",
    "data-name": "Path 2206"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M80 9s12 0 14 16-6 19 4 27 11 13 6 17-8 7-2 13 7 15-17 19-40-9-41-18 8-14 9-22-16-15-13-25 19-5 24-13S69 9 80 9",
    "data-name": "Path 2209"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 89",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M80 9s12 0 14 16-6 19 4 27 11 13 6 17-8 7-2 13 7 15-17 19-40-9-41-18 8-14 9-22-16-15-13-25 19-5 24-13S69 9 80 9",
    "data-name": "Path 2210"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M84 139h-3l-2-47-3-9 4 6-1-5-5-10 5 6 1-14 1 9 2-1-2 2v10l2-2-2 5Z",
    "data-name": "Path 2211"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m12 136 5-10c4-3 10 2 14 0s-4-22 8-24 16 20 21 22 8-5 15-6c7 0 19 14 22 18Z",
    "data-name": "Path 2212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M144 137q-1-5 3-9c4-4 10 2 11 2s3-4 7-7 10 1 14 0-3-14 6-14 12 18 18 18 7-4 13-1q8 6 8 11Z",
    "data-name": "Path 2213"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M144 137q-1-5 3-9c4-4 10 2 11 2s3-4 7-7 10 1 14 0-3-14 6-14 12 18 18 18 7-4 13-1q8 6 8 11Z",
    "data-name": "Path 2214",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m208 136 5-7",
    "data-name": "Line 262"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m188 136-2-22",
    "data-name": "Line 263"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m173 136-3-8",
    "data-name": "Line 264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m153 136-3-6",
    "data-name": "Line 265"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m207 129 3 4 7-2",
    "data-name": "Path 2215"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m190 116-3 4-5-4",
    "data-name": "Path 2216"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m192 123-5 5-4-3",
    "data-name": "Path 2217"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m171 131-5-2",
    "data-name": "Line 266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m171 133 3-6",
    "data-name": "Line 267"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m152 133 1-4",
    "data-name": "Line 268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m152 134-4-1",
    "data-name": "Line 269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m125 29 7-8a20 20 0 0 1 15-4c11 1 14 12 17 20 7 17 17 42-11 50-12 3-29 0-34-11q-6-15-1-29z",
    "data-name": "Path 2218"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M148 148h-5l-3-86-6-15 7 10-1-10-10-17 9 11 1-26 1 16 5-2-4 5 1 19 4-5-3 8Z",
    "data-name": "Path 2219"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M142 101v-3l2 1z",
    "data-name": "Path 2220"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m143 75-2 1v-2z",
    "data-name": "Path 2221"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m143 85-1 2v-3z",
    "data-name": "Path 2222"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m142 61 1-1 1 3z",
    "data-name": "Path 2223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m145 135-2 1v-2z",
    "data-name": "Path 2224"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M143 53v2l-1-1q-1-1 1-1",
    "data-name": "Path 2225"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m142 46-1 2v-3z",
    "data-name": "Path 2226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M143 120q1-3 3-1l1 4z",
    "data-name": "Path 2227"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M143 124s2 0 2 1l-2 2z",
    "data-name": "Path 2228"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m145 107-3 2v-4q2-1 3 2",
    "data-name": "Path 2229"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M146 103v2l-2-2z",
    "data-name": "Path 2230"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M145 79v2l-1-1z",
    "data-name": "Path 2231"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M144 115h2v2z",
    "data-name": "Path 2232"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M58 46zv3z",
    "data-name": "Path 2236"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M61 85v3l-2-2q0-1 2-1",
    "data-name": "Path 2237"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M57 18v3l-2-2z",
    "data-name": "Path 2238"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m58 55-2-3 3-1v6z",
    "data-name": "Path 2239"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m54 11 1-3a1 1 0 0 1 1 2z",
    "data-name": "Path 2240"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m59 32-1-1-3-2 3-1v2l1-1Z",
    "data-name": "Path 2241"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m57 25-2 1v-3z",
    "data-name": "Path 2242"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M61 105q-1 0-2-3h2Z",
    "data-name": "Path 2243"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m58 81-1 1v-2z",
    "data-name": "Path 2244"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m56 58 3 1-2 2 1 1-2 1Z",
    "data-name": "Path 2245"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m57 48-1 1-1-2a1 1 0 0 1 2 1",
    "data-name": "Path 2246"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M55 33zq3 0 3 3l-3 3z",
    "data-name": "Path 2247"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m59 91-2 2v-5a2 2 0 0 1 2 3",
    "data-name": "Path 2248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M58 110v-3h4v5z",
    "data-name": "Path 2249"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M59 127a1 1 0 0 1 1 2l-1 1Z",
    "data-name": "Path 2250"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m60 116-2 1v-3z",
    "data-name": "Path 2251"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M184 42a22 22 0 0 1 14 11c4 9-3 15 1 24s14 13 4 20-21-4-27-3-6 10-23 6-12-16-5-21 1-15 6-27c3-9 18-14 30-10",
    "data-name": "Path 2252"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M184 42a22 22 0 0 1 14 11c4 9-3 15 1 24s14 13 4 20-21-4-27-3-6 10-23 6-12-16-5-21 1-15 6-27c3-9 18-14 30-10",
    "data-name": "Path 2253",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m181 154-3-81 23-14-23 11-1-12 6-6-6 4-2-15-1 23-16-8 16 12v14l-13-4 13 8 2 67Z",
    "data-name": "Path 2254"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M177 127v2l-2-1q0-1 2-1",
    "data-name": "Path 2256"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M176 108v2l-2-1z",
    "data-name": "Path 2257"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m176 118-2-2 2-1v1Z",
    "data-name": "Path 2258"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M175 77v1l-2-1z",
    "data-name": "Path 2259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M174 113h-1v-2z",
    "data-name": "Path 2261"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M174 106h-2v-3q4 2 2 3",
    "data-name": "Path 2262"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M175 121h-2v-2q3 0 2 2",
    "data-name": "Path 2263"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M173 127v-2q2 0 2 2z",
    "data-name": "Path 2264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M176 99v2l-2-1q-1-1 2-1",
    "data-name": "Path 2265"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m125 148 2-2h3q2-2 2-4a6 6 0 0 1 5-5l8 2c4 2 3 5 6 5s4-2 8-1l4 5Z",
    "data-name": "Path 2266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m125 148 2-2h3q2-2 2-4a6 6 0 0 1 5-5l8 2c4 2 3 5 6 5s4-2 8-1l4 5Z",
    "data-name": "Path 2267",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m155 148 1-1",
    "data-name": "Line 270"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m144 148-5-8",
    "data-name": "Line 271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m142 140-1 3-4-2",
    "data-name": "Path 2268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m145 143-2 3-4-1",
    "data-name": "Path 2269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m155 154 4-5 8-1c3 0 2-6 2-7q2-10 11-12 12-2 20 4c8 6 7 12 12 12s8-5 17-2q9 4 10 11Z",
    "data-name": "Path 2270"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m221 154 4-3",
    "data-name": "Line 272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m197 154-11-18",
    "data-name": "Line 273"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m169 153-3-1",
    "data-name": "Line 274"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m192 137-2 6-8-4",
    "data-name": "Path 2271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m198 143-4 7-8-2",
    "data-name": "Path 2272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m221 150 1 3h3",
    "data-name": "Path 2273"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m168 153 1-2",
    "data-name": "Line 275"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 33",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(191 136)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M186 136z",
    "data-name": "Path 2274"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 34",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(181 138)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M185 147z",
    "data-name": "Path 2275"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 35",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(198 143)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 36",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(168 151)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M165 152zv-1z",
    "data-name": "Path 2276"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 37",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(220 149)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M224 150a1 1 0 1 0 1 0z",
    "data-name": "Path 2277"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 38",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(225 152)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M47 98s9 0 21-10-12-46-21-54-30 43-23 52 16 11 23 12",
    "data-name": "Path 2280"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m51 139-2-53 6-5-6 3v-9l8-9-8 5 1-6-2 3-1-19-1 29-16-7 16 11v58",
    "data-name": "Path 2281"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m47 116 3-1v3z",
    "data-name": "Path 2282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m45 95 3 1-3 1Z",
    "data-name": "Path 2283"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M47 102q0-1 2-1v2z",
    "data-name": "Path 2284"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m47 91 2-1v2z",
    "data-name": "Path 2285"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M50 127v3l-3-2z",
    "data-name": "Path 2286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m49 110-4 1v-3q4 0 4 2",
    "data-name": "Path 2287"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M49 86h-4v-2z",
    "data-name": "Path 2288"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m51 71 2 1-2 1Z",
    "data-name": "Path 2289"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M45 120q4 1 4 2l-4 1Z",
    "data-name": "Path 2290"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M49 77v2l-3-1z",
    "data-name": "Path 2291"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M17 139q-1-5 6-6h10q2-2 3-7l3-6 7-2c5 2 6 9 11 10q5 0 11-1 6 3 11 7l3 3 5 2Z",
    "data-name": "Path 2292"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17 139q-1-5 6-6h10q2-2 3-7l3-6 7-2c5 2 6 9 11 10q5 0 11-1 6 3 11 7l3 3 5 2Z",
    "data-name": "Path 2293",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m60 139 3-7",
    "data-name": "Line 276"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m49 139-6-14",
    "data-name": "Line 277"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m28 139-4-3",
    "data-name": "Line 278"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m61 137-2-4",
    "data-name": "Line 279"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m61 136 7-1",
    "data-name": "Line 280"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m49 129 2-2",
    "data-name": "Line 281"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m51 133-7-3",
    "data-name": "Line 282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m49 138-6-2",
    "data-name": "Line 283"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m48 136 4-6",
    "data-name": "Line 284"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M47 125z",
    "data-name": "Path 2294"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M47 127a1 1 0 1 0 0-1z",
    "data-name": "Path 2295"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 39",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(40 130)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 40",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(51 130)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 41",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(42 136)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 42",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(24 136)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M62 132h1z",
    "data-name": "Path 2296"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 43",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(58 132)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 44",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(67 134)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m0 146 2-2 4-1q2-1 2-4a7 7 0 0 1 6-7 13 13 0 0 1 10 2c5 4 4 7 7 7s5-2 10-1l5 6Z",
    "data-name": "Path 2297"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m36 146 2-2",
    "data-name": "Line 285"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m23 146-6-10",
    "data-name": "Line 286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m20 137-1 3-5-2",
    "data-name": "Path 2298"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m24 140-3 4-5-1",
    "data-name": "Path 2299"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "freepik--Trees--inject-2",
    transform: "translate(486 88)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M218 141c0-3-7 2-7 2l1-6c0-3-4 1-4 1s3-6 3-11-8 0-8 0l3-11c0-3-13 3-13 3l1-7q0-2-4 0-1-3-3-1v-2q-1-2-6 3l-5-8q-3-2-6 4h-4v-1c-1-4-4 0-7 3l-2 1-4-8c-4-5-14 8-14 8s-7-9-9-4 1 14 1 14l-3-4-7 3s2-6 0-8c-3-2-6 4-7 6l1-11c-2-7-7 2-7 2s1-8-5-10 3 0-2 9-4-6-11-5-6 25-6 25l-30-15s-1-2-6-3-2 6-2 6-7-6-9-6l-6 8-1-2c-2-3-3 4-4 8v1q-1-4-5-5c-4 0-2 11-1 14q-1-4-4-6c-3-1-1 9-1 9l-3-1 1 9-5 8 19-9h99l-4 6h94s3-5 2-9",
    "data-name": "Path 2172"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M128 154q-3-7-7-11c-5-4-14 2-19-1s5-27-11-28-23 23-30 26-11-7-21-7c-9-1-26 17-30 21Z",
    "data-name": "Path 2174"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M128 154q-3-7-7-11c-5-4-14 2-19-1s5-27-11-28-23 23-30 26-11-7-21-7c-9-1-26 17-30 21Z",
    "data-name": "Path 2175",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M83 150h4l2-67 5-11-5 7 1-7 8-13-8 8-1-20-1 12-4-2 4 4-1 15-3-4 2 7Z",
    "data-name": "Path 2176"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8adaf",
    d: "M37 150h3l3-67 5-11-6 7 1-7 8-13-8 8V47l-1 12-4-2 3 4-1 15-3-4 3 7Z",
    "data-name": "Path 2177"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M136 150h4l2-51 5-9-5 6v-6l9-10-8 6-1-15-1 9-4-1 3 3v11l-4-3 3 5Z",
    "data-name": "Path 2178"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M95 150h4l3-51 4-9-5 6 1-6 8-10-8 6V71l-1 9-4-1 3 3-1 11-3-3 3 5Z",
    "data-name": "Path 2179"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M122 150h4l2-51 5-9-5 6v-6l9-10-8 6-1-15-1 9-4-1 4 3-1 11-3-3 2 5Z",
    "data-name": "Path 2180"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M196 150h4l3-67 4-11-5 7 1-7 8-13-8 8V47l-1 12-4-2 3 4-1 15-3-4 3 7Z",
    "data-name": "Path 2181"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8a9094",
    d: "M178 150h3l3-67 4-11-5 7 1-7 8-13-8 8V47l-1 12-4-2 3 4-1 15-3-4 3 7Z",
    "data-name": "Path 2182"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M142 150h3l3-67 5-11-6 7 1-7 8-13-7 8-1-20-1 12-4-2 3 4-1 15-3-4 3 7Z",
    "data-name": "Path 2183"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M197 154q-2-7-6-11c-4-4-12 2-16-1s5-27-10-28-19 23-26 26-9-7-17-7c-8-1-23 17-27 21Z",
    "data-name": "Path 2184"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M197 154q-2-7-6-11c-4-4-12 2-16-1s5-27-10-28-19 23-26 26-9-7-17-7c-8-1-23 17-27 21Z",
    "data-name": "Path 2185",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M134 49s-8 0-10 11 4 13-4 18-9 10-5 12 6 5 1 9-5 10 12 14 30-5 31-11-5-11-6-16 12-10 10-17-13-4-17-10-3-10-12-10",
    "data-name": "Path 2186"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M134 49s-8 0-10 11 4 13-4 18-9 10-5 12 6 5 1 9-5 10 12 14 30-5 31-11-5-11-6-16 12-10 10-17-13-4-17-10-3-10-12-10",
    "data-name": "Path 2187",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#92989b",
    d: "M129 152h3l4-66 4-9-4 6 1-6 6-11-6 7-1-16-1 10-3-2 3 4-1 11-2-3 2 5Z",
    "data-name": "Path 2188"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M85 154q1-7 4-11c4-3 9 2 12 0s-3-25 8-26 14 21 19 24 7-6 14-7c5 0 17 16 20 20Z",
    "data-name": "Path 2189"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M85 154q1-7 4-11c4-3 9 2 12 0s-3-25 8-26 14 21 19 24 7-6 14-7c5 0 17 16 20 20Z",
    "data-name": "Path 2190",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M129 154q-1-5-4-7c-3-2-8 1-11-1s3-17-6-18-14 15-18 17-6-4-12-5c-5 0-15 11-18 14Z",
    "data-name": "Path 2191"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M27 115s-8 1-19-7 11-39 19-46 27 36 20 44-14 9-20 9",
    "data-name": "Path 2192"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M27 115s-8 1-19-7 11-39 19-46 27 36 20 44-14 9-20 9",
    "data-name": "Path 2193",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m23 150 2-44-6-5 6 3v-8l-7-7 7 4-1-5 2 2 1-15 1 24 14-6-14 9v49",
    "data-name": "Path 2194"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M197 79s-8 0-19-8 11-39 20-46 26 36 19 44-13 9-20 10",
    "data-name": "Path 2195"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m44 153-1-2h-3q-2-2-2-4l-4-4-9 1q-3 5-5 5-2-1-7 0l-5 4Z",
    "data-name": "Path 2197"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m44 153-1-2h-3q-2-2-2-4l-4-4-9 1q-3 5-5 5-2-1-7 0l-5 4Z",
    "data-name": "Path 2198",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m12 153 3-2c2-1 3 2 6 0s5-8 10-8 5 5 4 7 3 1 4 1l3 2",
    "data-name": "Path 2199"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m16 153-1-1",
    "data-name": "Line 258"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m27 153 4-7",
    "data-name": "Line 259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m29 146 1 2 3-1",
    "data-name": "Path 2200"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m26 149 2 2 4-1",
    "data-name": "Path 2201"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m114 152-2-2h-4l-1-4a6 6 0 0 0-5-5l-9 2q-4 5-6 5-2-1-9-1l-4 5Z",
    "data-name": "Path 2202"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m114 152-2-2h-4l-1-4a6 6 0 0 0-5-5l-9 2q-4 5-6 5-2-1-9-1l-4 5Z",
    "data-name": "Path 2203",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m83 152-2-1",
    "data-name": "Line 260"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m94 152 5-8",
    "data-name": "Line 261"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M96 145v2l4-2",
    "data-name": "Path 2204"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m93 147 2 3 4-1",
    "data-name": "Path 2205"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M69 64s-9 0-12 7 4 10-4 14-9 7-5 9 6 4 1 7-5 7 13 10 32-4 32-9-5-7-5-11 12-8 10-13-14-3-18-7-4-7-12-7",
    "data-name": "Path 2207",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M153 27s-12 0-14 16 6 19-5 27-11 13-6 17 9 7 2 13-7 15 18 19 43-9 43-18-8-14-8-22 16-14 13-25-20-5-25-13-6-14-18-14",
    "data-name": "Path 2209"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 89",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M153 27s-12 0-14 16 6 19-5 27-11 13-6 17 9 7 2 13-7 15 18 19 43-9 43-18-8-14-8-22 16-14 13-25-20-5-25-13-6-14-18-14",
    "data-name": "Path 2210"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M148 157h4l2-59 4-10-4 7v-7l7-11-7 7-1-17-1 10-3-1 3 3v13l-3-3 3 5Z",
    "data-name": "Path 2211"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M221 154q-2-6-5-9c-4-3-11 1-15-1s4-22-8-24-17 20-23 22-8-5-16-6c-7 0-20 14-23 18Z",
    "data-name": "Path 2212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M100 155q2-5-2-9c-4-4-11 2-13 2s-2-4-7-7-10 1-14 0 3-14-6-14-13 18-19 18-8-4-15-1q-7 6-8 11Z",
    "data-name": "Path 2213"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M100 155q2-5-2-9c-4-4-11 2-13 2s-2-4-7-7-10 1-14 0 3-14-6-14-13 18-19 18-8-4-15-1q-7 6-8 11Z",
    "data-name": "Path 2214",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m33 154-6-7",
    "data-name": "Line 262"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m50 154 3-22",
    "data-name": "Line 263"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m65 154 3-8",
    "data-name": "Line 264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m84 155 3-6",
    "data-name": "Line 265"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m34 147-3 4-7-2",
    "data-name": "Path 2215"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m48 134 4 5 4-5",
    "data-name": "Path 2216"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m46 141 5 5 4-3",
    "data-name": "Path 2217"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m66 149 6-2",
    "data-name": "Line 266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m66 151-3-6",
    "data-name": "Line 267"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m85 151-1-3",
    "data-name": "Line 268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m85 152 4-1",
    "data-name": "Line 269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m114 47-7-8a23 23 0 0 0-16-4c-12 1-15 13-18 20-8 17-18 42 12 50 12 3 30 0 35-11q5-15 2-29z",
    "data-name": "Path 2218"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M89 166h4l3-76 5-13-6 9 1-9 10-15-9 10-1-23-1 14-5-2 4 5-1 16-3-4 3 7Z",
    "data-name": "Path 2219"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M95 119v-3l-2 1z",
    "data-name": "Path 2220"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m94 93 2 1v-2z",
    "data-name": "Path 2221"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m94 103 1 2v-3z",
    "data-name": "Path 2222"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m95 79-2-1v3z",
    "data-name": "Path 2223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m92 153 2 1v-2z",
    "data-name": "Path 2224"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M94 71v2l1-1q1-1-1-1",
    "data-name": "Path 2225"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m95 65 2 1-1-2z",
    "data-name": "Path 2226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m94 138-3-1-1 4z",
    "data-name": "Path 2227"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M94 142s-2 0-2 1l2 2z",
    "data-name": "Path 2228"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m92 125 3 2v-4z",
    "data-name": "Path 2229"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M91 121v2l2-1z",
    "data-name": "Path 2230"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M92 98v2l1-2z",
    "data-name": "Path 2231"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m93 134-2-1v2z",
    "data-name": "Path 2232"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m192 12-7-7a23 23 0 0 0-16-5c-11 1-15 13-18 20-8 17-18 43 12 50 13 4 30 0 35-10q7-15 2-30z",
    "data-name": "Path 2233"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m192 12-7-7a23 23 0 0 0-16-5c-11 1-15 13-18 20-8 17-18 43 12 50 13 4 30 0 35-10q7-15 2-30z",
    "data-name": "Path 2234",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M178 64h-2v2z",
    "data-name": "Path 2236"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M174 104v3l3-3z",
    "data-name": "Path 2237"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M178 36v3l2-2z",
    "data-name": "Path 2238"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m177 73 2-3-3-1v6z",
    "data-name": "Path 2239"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m181 29-1-3a1 1 0 0 0-1 2z",
    "data-name": "Path 2240"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m176 50 1-1 3-2q1-1-3-1v2l-1-1Z",
    "data-name": "Path 2241"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m178 43 2 1v-1l1-2z",
    "data-name": "Path 2242"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m174 123 3-2q-1-2-3-1Z",
    "data-name": "Path 2243"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m177 99 1 1v-2z",
    "data-name": "Path 2244"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M179 76q-1 0-3 2l2 1v1l1 1Z",
    "data-name": "Path 2245"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m178 66 2 1v-2a1 1 0 0 0-2 1",
    "data-name": "Path 2246"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M180 51zq-3 1-3 3l3 3z",
    "data-name": "Path 2247"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m176 109 2 2v-4z",
    "data-name": "Path 2248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M177 128v-3h-4v5z",
    "data-name": "Path 2249"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M176 145a1 1 0 0 0-1 2l1 1Z",
    "data-name": "Path 2250"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m175 134 2 1v-3z",
    "data-name": "Path 2251"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M58 60a24 24 0 0 0-14 11c-5 9 3 16-1 24s-15 13-5 20 22-4 29-3 7 10 25 6 12-16 5-21-2-15-6-27c-4-9-20-14-33-10",
    "data-name": "Path 2252"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M58 60a24 24 0 0 0-14 11c-5 9 3 16-1 24s-15 13-5 20 22-4 29-3 7 10 25 6 12-16 5-21-2-15-6-27c-4-9-20-14-33-10",
    "data-name": "Path 2253",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m61 172 3-70-21-11 21 9V90l-5-6 6 4 1-13 1 20 15-7-15 10v13l12-4-12 6-2 59Z",
    "data-name": "Path 2254"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M61 145v2l2-1q1-1-2-1",
    "data-name": "Path 2256"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M62 126v2l1-1z",
    "data-name": "Path 2257"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m61 136 2-2h-2Z",
    "data-name": "Path 2258"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M63 95v1l1-1z",
    "data-name": "Path 2259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M64 131h1v-2z",
    "data-name": "Path 2261"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m63 124 2 1v-4q-3 2-2 3",
    "data-name": "Path 2262"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M63 139h2v-2q-2 0-2 2",
    "data-name": "Path 2263"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M65 145v-2q-2 0-2 2z",
    "data-name": "Path 2264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M62 117v2l2-1z",
    "data-name": "Path 2265"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m113 166-1-2h-4q-2-2-1-4a6 6 0 0 0-6-5l-9 2c-4 3-3 5-6 5s-4-2-8-1l-5 5Z",
    "data-name": "Path 2266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m113 166-1-2h-4q-2-2-1-4a6 6 0 0 0-6-5l-9 2c-4 3-3 5-6 5s-4-2-8-1l-5 5Z",
    "data-name": "Path 2267",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m83 166-2-1",
    "data-name": "Line 270"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m93 166 5-8",
    "data-name": "Line 271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m95 159 1 2 4-2",
    "data-name": "Path 2268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m92 161 2 3 4-1",
    "data-name": "Path 2269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m89 172-4-4c-4-2-4 0-8-1-3-1-3-7-3-8q-1-10-12-12-11-3-20 4c-9 6-8 12-13 12s-9-5-19-1q-8 4-10 10Z",
    "data-name": "Path 2270"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m20 172-5-3",
    "data-name": "Line 272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m41 172 12-18",
    "data-name": "Line 273"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m68 172 4-2",
    "data-name": "Line 274"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m46 155 2 6 9-4",
    "data-name": "Path 2271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m40 161 4 7 9-2",
    "data-name": "Path 2272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19 168v3h-4",
    "data-name": "Path 2273"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m70 171-1-2",
    "data-name": "Line 275"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 33",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(46 155)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M52 154z",
    "data-name": "Path 2274"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 34",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(56 156)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M53 166z",
    "data-name": "Path 2275"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 35",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(43 161)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 36",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(68 169)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M72 170z",
    "data-name": "Path 2276"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 37",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(19 168)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M16 169a1 1 0 1 1-1-1z",
    "data-name": "Path 2277"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 38",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(14 170)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M184 116s-9 1-23-10 13-46 24-54 31 43 23 52-16 11-24 12",
    "data-name": "Path 2280"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m210 157 1-53-6-5 7 3v-9l-9-8 8 5-1-7 3 3 1-19 1 29 16-7-16 11v58",
    "data-name": "Path 2281"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m188 134-3-1v3z",
    "data-name": "Path 2282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M190 113q-4 0-4 2h4Z",
    "data-name": "Path 2283"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m188 120-3-1v2z",
    "data-name": "Path 2284"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m188 109-2-1v2z",
    "data-name": "Path 2285"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M185 146zv1l3-2z",
    "data-name": "Path 2286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m186 128 4 1v-3q-4 0-4 2",
    "data-name": "Path 2287"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M186 104h4v-2q-4 0-4 2",
    "data-name": "Path 2288"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m184 89-3 1 3 1Z",
    "data-name": "Path 2289"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M190 138q-4 1-4 2l4 1Z",
    "data-name": "Path 2290"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M186 95v2l3-1z",
    "data-name": "Path 2291"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M216 157q0-5-7-6-5 2-10 0-4-2-3-6l-3-7a9 9 0 0 0-8-2c-5 2-6 9-11 10q-6 0-13-1-6 3-10 7l-4 3-5 2Z",
    "data-name": "Path 2292"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M216 157q0-5-7-6-5 2-10 0-4-2-3-6l-3-7a9 9 0 0 0-8-2c-5 2-6 9-11 10q-6 0-13-1-6 3-10 7l-4 3-5 2Z",
    "data-name": "Path 2293",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m175 157-3-7",
    "data-name": "Line 276"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m185 157 7-14",
    "data-name": "Line 277"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m205 157 3-3",
    "data-name": "Line 278"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m175 155 2-4",
    "data-name": "Line 279"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m174 154-7-1",
    "data-name": "Line 280"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m186 148-2-3",
    "data-name": "Line 281"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m184 151 7-3",
    "data-name": "Line 282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m186 156 6-2",
    "data-name": "Line 283"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m187 154-4-5",
    "data-name": "Line 284"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M188 143zv-1z",
    "data-name": "Path 2294"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M188 145a1 1 0 1 1-1 0z",
    "data-name": "Path 2295"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 39",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(190 148)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 40",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(182 148)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 41",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(188 154)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 42",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(207 154)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M173 150z",
    "data-name": "Path 2296"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 43",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(176 151)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 44",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(167 152)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m234 164-2-2-5-1q-2-1-1-4-1-5-7-7a14 14 0 0 0-11 3c-5 3-4 6-7 6s-5-2-10-1l-6 6Z",
    "data-name": "Path 2297"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m196 164-3-2",
    "data-name": "Line 285"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m210 164 6-10",
    "data-name": "Line 286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m213 155 1 3 5-2",
    "data-name": "Path 2298"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m209 158 2 4 5-1",
    "data-name": "Path 2299"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "freepik--Trees--inject-2",
    transform: "translate(286 121)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M179 114c-1-3-6 1-6 1l1-5c0-3-4 1-4 1l2-9c0-5-6 0-6 0l3-9c0-2-11 3-11 3l1-6q0-2-4 0 0-3-2-1v-1q-1-2-5 2l-4-6q-3-2-5 2l-3 1v-1q-2-3-6 3h-2l-3-7c-4-3-12 7-12 7s-5-7-7-3 1 11 1 11l-3-3-6 2s3-5 0-6c-2-2-4 4-5 5l1-9c-1-6-6 1-6 1s1-6-4-7 2 0-2 6-3-4-9-4-5 21-5 21L44 91s-1-2-5-3-2 5-2 5-5-4-7-4l-5 5-1-1c-1-2-3 4-3 7l-1 1q0-4-3-5c-3 0-2 9-1 12q-1-4-4-5c-2-1 0 7 0 7l-3-1 1 7-4 7 16-7h81l-4 4h78z",
    "data-name": "Path 2172"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M97 124q-2-7-5-9c-4-3-11 1-15-1s4-22-8-23-17 19-23 21-8-5-15-5c-7-1-20 13-24 17Z",
    "data-name": "Path 2174"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M97 124q-2-7-5-9c-4-3-11 1-15-1s4-22-8-23-17 19-23 21-8-5-15-5c-7-1-20 13-24 17Z",
    "data-name": "Path 2175",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M68 120h3l2-53 3-9-4 6 1-6 6-11-6 7V38l-1 10-3-2 3 3-1 12-2-3 2 5Z",
    "data-name": "Path 2176"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8adaf",
    d: "M30 120h3l2-53 3-9-4 6 1-6 6-11-6 7V38l-1 10-3-2 3 3-1 12-3-3 2 5Z",
    "data-name": "Path 2177"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M111 120h3l2-41 3-7-3 5v-5l6-8-6 5V57l-1 7-3-1 3 3-1 9-2-3 2 5Z",
    "data-name": "Path 2178"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M78 120h3l2-41 3-7-3 5v-5l6-8-6 5V57l-1 7-3-1 3 3-1 9-2-3 2 5Z",
    "data-name": "Path 2179"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M100 120h3l1-41 4-7-4 5 1-5 6-8-6 5-1-12v7l-3-1 2 3v9l-3-3 2 5Z",
    "data-name": "Path 2180"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M162 120h3l2-53 3-9-3 6v-6l6-11-6 7V38l-1 10-3-2 3 3-1 12-2-3 2 5Z",
    "data-name": "Path 2181"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8a9094",
    d: "M145 120h3l2-53 4-9-4 6v-6l7-11-6 7-1-16-1 10-3-2 3 3-1 12-2-3 2 5Z",
    "data-name": "Path 2182"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M116 120h3l2-53 3-9-4 6 1-6 6-11-6 7V38l-1 10-3-2 3 3-1 12-3-3 2 5Z",
    "data-name": "Path 2183"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M159 124q-1-7-4-9c-4-3-10 1-13-1s4-22-7-23-15 19-20 21-7-5-13-5c-6-1-18 13-20 17Z",
    "data-name": "Path 2184"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M159 124q-1-7-4-9c-4-3-10 1-13-1s4-22-7-23-15 19-20 21-7-5-13-5c-6-1-18 13-20 17Z",
    "data-name": "Path 2185",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M110 39s-6 0-8 9 3 11-3 15-6 7-3 9 4 5 0 8-4 8 9 11 23-4 23-9-3-9-4-13 9-8 8-14-10-3-13-7-3-9-9-9",
    "data-name": "Path 2186"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M110 39s-6 0-8 9 3 11-3 15-6 7-3 9 4 5 0 8-4 8 9 11 23-4 23-9-3-9-4-13 9-8 8-14-10-3-13-7-3-9-9-9",
    "data-name": "Path 2187",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#92989b",
    d: "M106 122h2l3-53 3-7-3 4v-4l5-9-5 6V46l-1 8-2-2 2 3v9l-2-2 1 4Z",
    "data-name": "Path 2188"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M71 124q1-5 4-9c2-2 7 2 9 0s-3-20 5-21 12 17 15 19 5-5 11-5c4 0 13 13 15 16Z",
    "data-name": "Path 2189"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M71 124q1-5 4-9c2-2 7 2 9 0s-3-20 5-21 12 17 15 19 5-5 11-5c4 0 13 13 15 16Z",
    "data-name": "Path 2190",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m103 124-3-6c-3-2-7 1-9 0s3-14-5-15-10 12-13 13-5-3-9-3-12 9-14 11Z",
    "data-name": "Path 2191"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M20 93s-6 0-14-7 8-31 15-36 20 28 15 35-11 7-16 8",
    "data-name": "Path 2192"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M20 93s-6 0-14-7 8-31 15-36 20 28 15 35-11 7-16 8",
    "data-name": "Path 2193",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m18 120 1-35-4-4 4 2v-6l-6-5 6 3-1-4 2 2 1-13v19l11-4-11 7v40",
    "data-name": "Path 2194"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M163 63s-6 1-15-6 8-31 15-37 20 29 15 35-10 8-15 8",
    "data-name": "Path 2195"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8adaf",
    d: "m158 119 3-63-4-4 4 2v-6l-5-6 5 3-1-4 2 2 1-13 1 20 10-5-10 7v4l-3 64",
    "data-name": "Path 2196"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m34 123-1-2h-3l-1-3-3-3-7 1q-2 3-4 4c-2 1-2-2-5-1l-4 4Z",
    "data-name": "Path 2197"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m34 123-1-2h-3l-1-3-3-3-7 1q-2 3-4 4c-2 1-2-2-5-1l-4 4Z",
    "data-name": "Path 2198",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9 123 2-2q3 1 5 0c2-1 4-6 8-6s3 4 3 5l3 1q2 0 2 2",
    "data-name": "Path 2199"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m12 123-1-1",
    "data-name": "Line 258"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m20 123 4-6",
    "data-name": "Line 259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M22 117v2l3-1",
    "data-name": "Path 2200"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m20 119 1 3 3-1",
    "data-name": "Path 2201"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m91 122-1-1-3-1-1-3-4-4-7 2q-3 4-4 4-1-1-7-1l-3 4Z",
    "data-name": "Path 2202"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m91 122-1-1-3-1-1-3-4-4-7 2q-3 4-4 4-1-1-7-1l-3 4Z",
    "data-name": "Path 2203",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m68 122-2-1",
    "data-name": "Line 260"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m76 122 4-6",
    "data-name": "Line 261"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m78 116 1 2 3-1",
    "data-name": "Path 2204"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m76 118 1 3 3-1",
    "data-name": "Path 2205"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M44 15s-9 0-12 12 4 15-4 21-9 11-5 14 6 6 1 11-6 11 13 16 32-7 33-14-5-12-6-18 13-11 11-20-15-5-18-11-4-11-13-11",
    "data-name": "Path 2206"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M44 15s-9 0-12 12 4 15-4 21-9 11-5 14 6 6 1 11-6 11 13 16 32-7 33-14-5-12-6-18 13-11 11-20-15-5-18-11-4-11-13-11",
    "data-name": "Path 2207",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M36 133h4l4-76 4-11-4 7 1-7 7-12-7 8-1-18-1 11-3-2 3 4-1 13-2-3 2 6Z",
    "data-name": "Path 2208"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M126 22s-9 0-11 12 5 16-3 22-9 11-5 14 7 6 2 10-6 12 13 16 33-7 33-14-6-12-6-18 12-12 10-20-15-5-19-11-5-11-14-11",
    "data-name": "Path 2209"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 89",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M126 22s-9 0-11 12 5 16-3 22-9 11-5 14 7 6 2 10-6 12 13 16 33-7 33-14-6-12-6-18 12-12 10-20-15-5-19-11-5-11-14-11",
    "data-name": "Path 2210"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M124 126h3l3-62 3-11-4 7 1-6 6-13-6 8-2-18v11l-4-1 3 3v13l-3-3 3 6Z",
    "data-name": "Path 2211"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M181 124q-1-5-4-8c-3-2-8 1-11 0s3-18-7-19-13 15-17 17-6-4-12-5c-5 0-15 12-18 15Z",
    "data-name": "Path 2212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M76 125q2-4-2-8c-3-3-8 2-9 2l-6-5q-6-1-10 0c-4 1 2-12-5-12s-10 14-15 14-5-2-10 0q-6 5-7 9Z",
    "data-name": "Path 2213"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M76 125q2-4-2-8c-3-3-8 2-9 2l-6-5q-6-1-10 0c-4 1 2-12-5-12s-10 14-15 14-5-2-10 0q-6 5-7 9Z",
    "data-name": "Path 2214",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m25 124-4-6",
    "data-name": "Line 262"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m40 124 3-18",
    "data-name": "Line 263"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m53 124 2-7",
    "data-name": "Line 264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m68 124 3-5",
    "data-name": "Line 265"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m26 118-3 3-5-1",
    "data-name": "Path 2215"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m39 107 3 4 3-3",
    "data-name": "Path 2216"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m38 114 3 3 4-2",
    "data-name": "Path 2217"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m54 120 5-2",
    "data-name": "Line 266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m54 121-2-5",
    "data-name": "Line 267"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m70 122-2-3",
    "data-name": "Line 268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m69 122 3-1",
    "data-name": "Line 269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m91 38-5-7a16 16 0 0 0-12-3c-9 1-12 10-14 16-6 14-14 34 9 40 10 3 23 0 27-8q4-12 1-24z",
    "data-name": "Path 2218"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M73 133h3l2-60 4-11-4 7v-7l8-12-7 8-1-19-1 12-3-2 3 4-1 13-3-4 3 7Z",
    "data-name": "Path 2219"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M77 95v-1z",
    "data-name": "Path 2220"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M77 75zv-2z",
    "data-name": "Path 2221"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m76 83 2 1v-2z",
    "data-name": "Path 2222"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M77 64q1-1-1-1z",
    "data-name": "Path 2223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m75 123 1 1v-2z",
    "data-name": "Path 2224"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m77 57-1 2z",
    "data-name": "Path 2225"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m77 52 2 1v-2z",
    "data-name": "Path 2226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M76 111q1-1-2-1v3z",
    "data-name": "Path 2227"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m77 114-2 1 2 1z",
    "data-name": "Path 2228"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m75 100 2 2v-3z",
    "data-name": "Path 2229"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M74 97v2l2-1z",
    "data-name": "Path 2230"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M75 78v2z",
    "data-name": "Path 2231"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M76 107h-2v2z",
    "data-name": "Path 2232"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m159 10-5-6a16 16 0 0 0-12-4c-9 1-12 10-14 16-6 14-14 35 9 41 9 2 23 0 27-9q4-12 1-24z",
    "data-name": "Path 2233"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m159 10-5-6a16 16 0 0 0-12-4c-9 1-12 10-14 16-6 14-14 35 9 41 9 2 23 0 27-9q4-12 1-24z",
    "data-name": "Path 2234",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M140 123h3l4-78 4-11-5 7 1-7 7-12-7 8V12l-1 11-4-2 3 4v13l-3-3 2 6Z",
    "data-name": "Path 2235"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m145 52-1-1v2z",
    "data-name": "Path 2236"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M142 83v3l2-2z",
    "data-name": "Path 2237"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M145 29v3l2-2z",
    "data-name": "Path 2238"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M144 59zl2-1q0-2-2-2z",
    "data-name": "Path 2239"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M147 23v-2l-1 1z",
    "data-name": "Path 2240"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M144 40zl2-2q0-1-1-1v1h-2Z",
    "data-name": "Path 2241"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m145 34 2 2v-3z",
    "data-name": "Path 2242"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m142 99 2-2-2-1Z",
    "data-name": "Path 2243"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m144 79 1 1v-1z",
    "data-name": "Path 2244"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m146 61-2 1 1 2 1 1Z",
    "data-name": "Path 2245"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m145 53 1 1v-2z",
    "data-name": "Path 2246"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M146 41zl-2 2q0 2 3 3z",
    "data-name": "Path 2247"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m143 87 2 2v-3z",
    "data-name": "Path 2248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M144 103v-2l-3-1v5z",
    "data-name": "Path 2249"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m144 117-1 1 1 1Z",
    "data-name": "Path 2250"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m143 107 1 2v-3z",
    "data-name": "Path 2251"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M44 48a18 18 0 0 0-11 9c-4 7 3 13 0 20s-12 10-4 16 17-4 22-3 5 8 18 5 10-13 4-17-1-12-4-22c-3-7-15-11-25-8",
    "data-name": "Path 2252"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44 48a18 18 0 0 0-11 9c-4 7 3 13 0 20s-12 10-4 16 17-4 22-3 5 8 18 5 10-13 4-17-1-12-4-22c-3-7-15-11-25-8",
    "data-name": "Path 2253",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m49 138 2-56-16-9 16 7v-8l-3-4 4 3 1-11 1 16 11-5-11 8v10l9-3-9 5-2 47Z",
    "data-name": "Path 2254"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M50 116v2l1-1z",
    "data-name": "Path 2256"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M50 101v2l2-1z",
    "data-name": "Path 2257"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m50 109 2-1-2-1v1Z",
    "data-name": "Path 2258"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m51 77 1-1h-1Z",
    "data-name": "Path 2259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M52 105zv-1z",
    "data-name": "Path 2261"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M52 100h1v-3q-3 2-1 3",
    "data-name": "Path 2262"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M51 112h2v-2q-2 0-2 2",
    "data-name": "Path 2263"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M53 116v-1l-2 1z",
    "data-name": "Path 2264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m51 94-1 2z",
    "data-name": "Path 2265"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m91 133-1-1-3-1-1-2a5 5 0 0 0-4-5l-7 2q-3 4-5 4h-6l-4 3Z",
    "data-name": "Path 2266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m91 133-1-1-3-1-1-2a5 5 0 0 0-4-5l-7 2q-3 4-5 4h-6l-4 3Z",
    "data-name": "Path 2267",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m67 133-1-1",
    "data-name": "Line 270"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m76 133 4-6",
    "data-name": "Line 271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M78 127v3l3-2",
    "data-name": "Path 2268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m75 130 2 2 3-1",
    "data-name": "Path 2269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m67 138-3-3q-1-1-6-1-2-3-2-7a11 11 0 0 0-9-9q-8-1-15 3c-7 6-6 10-10 10s-7-4-14-1q-7 3-8 8Z",
    "data-name": "Path 2270"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m15 138-3-2",
    "data-name": "Line 272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m34 138 8-14",
    "data-name": "Line 273"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m56 138 3-2",
    "data-name": "Line 274"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m38 125 1 4 7-3",
    "data-name": "Path 2271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m33 130 3 5 7-2",
    "data-name": "Path 2272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m15 135-1 3-3-1",
    "data-name": "Path 2273"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m57 137-1-1",
    "data-name": "Line 275"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0.4,
    fill: "#263238",
    "data-name": "Ellipse 33",
    rx: 0.5,
    ry: 0.4,
    transform: "translate(37 124)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M43 124zv-1z",
    "data-name": "Path 2274"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0.4,
    fill: "#263238",
    "data-name": "Ellipse 34",
    rx: 0.5,
    ry: 0.4,
    transform: "translate(46 126)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M43 133z",
    "data-name": "Path 2275"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0.4,
    fill: "#263238",
    "data-name": "Ellipse 35",
    rx: 0.5,
    ry: 0.4,
    transform: "translate(33 129)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0.4,
    fill: "#263238",
    "data-name": "Ellipse 36",
    rx: 0.5,
    ry: 0.4,
    transform: "translate(56 136)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M59 136z",
    "data-name": "Path 2276"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0.4,
    fill: "#263238",
    "data-name": "Ellipse 37",
    rx: 0.5,
    ry: 0.4,
    transform: "translate(14 135)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M12 135",
    "data-name": "Path 2277"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0.4,
    fill: "#263238",
    "data-name": "Ellipse 38",
    rx: 0.5,
    ry: 0.4,
    transform: "translate(10 137)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M153 93s-7 1-17-8 9-37 17-43 24 34 18 42-12 9-18 9",
    "data-name": "Path 2280"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m150 126 1-42-5-4 5 2v-8l-6-6 6 4-1-5 2 2 1-15 1 23 12-6-12 9v47",
    "data-name": "Path 2281"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m153 108-2-1v2z",
    "data-name": "Path 2282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m154 91-2 1 2 1Z",
    "data-name": "Path 2283"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M153 96h-2v2z",
    "data-name": "Path 2284"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m153 88-2-1v2z",
    "data-name": "Path 2285"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M151 117zl-1 1 3-1z",
    "data-name": "Path 2286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M152 103h2v-2q-2 1-2 2",
    "data-name": "Path 2287"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m152 83 2 1v-2z",
    "data-name": "Path 2288"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m150 71-2 1 2 1Z",
    "data-name": "Path 2289"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M154 111q-2 0-2 2h2Z",
    "data-name": "Path 2290"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M152 76v2l2-1z",
    "data-name": "Path 2291"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M177 126q0-4-5-5-5 2-8 0-2-2-2-5l-3-5-5-2c-5 2-5 8-9 9q-4-1-9-1-5 2-9 5l-3 2-3 2Z",
    "data-name": "Path 2292"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M177 126q0-4-5-5-5 2-8 0-2-2-2-5l-3-5-5-2c-5 2-5 8-9 9q-4-1-9-1-5 2-9 5l-3 2-3 2Z",
    "data-name": "Path 2293",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m143 126-2-6",
    "data-name": "Line 276"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m151 126 5-11",
    "data-name": "Line 277"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m168 126 3-2",
    "data-name": "Line 278"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m142 125 2-4",
    "data-name": "Line 279"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m142 124-5-1",
    "data-name": "Line 280"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m151 119-1-2",
    "data-name": "Line 281"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m150 122 5-3",
    "data-name": "Line 282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m151 125 5-1",
    "data-name": "Line 283"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m152 124-3-5",
    "data-name": "Line 284"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M153 115z",
    "data-name": "Path 2294"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M153 117z",
    "data-name": "Path 2295"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0.4,
    fill: "#263238",
    "data-name": "Ellipse 39",
    rx: 0.5,
    ry: 0.4,
    transform: "translate(157 119)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0.4,
    fill: "#263238",
    "data-name": "Ellipse 40",
    rx: 0.5,
    ry: 0.4,
    transform: "translate(149 119)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0.4,
    fill: "#263238",
    "data-name": "Ellipse 41",
    rx: 0.5,
    ry: 0.4,
    transform: "translate(156 124)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0.4,
    fill: "#263238",
    "data-name": "Ellipse 42",
    rx: 0.5,
    ry: 0.4,
    transform: "translate(171 124)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M141 120z",
    "data-name": "Path 2296"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0.4,
    fill: "#263238",
    "data-name": "Ellipse 43",
    rx: 0.5,
    ry: 0.4,
    transform: "translate(143 121)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0.4,
    fill: "#263238",
    "data-name": "Ellipse 44",
    rx: 0.5,
    ry: 0.4,
    transform: "translate(136 122)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m190 132-1-2-4-1-1-3a6 6 0 0 0-5-5l-8 2c-4 2-3 5-6 5s-3-2-7-1l-5 5Z",
    "data-name": "Path 2297"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m162 132-2-1",
    "data-name": "Line 285"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m172 132 5-8",
    "data-name": "Line 286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M175 124v3l4-2",
    "data-name": "Path 2298"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m172 127 1 3 4-1",
    "data-name": "Path 2299"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M0 0h634v83H0z",
    "data-name": "Rectangle 435",
    transform: "translate(62 218)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m125 207-12-3v47l21-6-7-18z",
    "data-name": "Path 2550"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m166 93 13-12-15-1-9 23-15 9 2 20 5 7Z",
    "data-name": "Path 2551"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m638 179 19-39 13-16v-4l-12 13-2-18-2-3 2 23-9 16-2-29-2 3v34l-8 15-3 4 10 22 5 13 1 12-2 20 11 2-1-24-5-19Z",
    "data-name": "Path 2552"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "m117 262 3-2 4 2 4-2 3 2 4-2 3 2 4-2 3 2 4-2 4 2 3-2 4 2 3-2 4 2 3-2 4 2 4-2 3 2v3h-71v-3l3-2Z",
    "data-name": "Path 235",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "m242 262 4-2 3 2 4-2 3 2 4-2 3 2 4-2 4 2 3-2 4 2v3l-36-1Z",
    "data-name": "Path 2129",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    d: "m277 262-3-2-4 2-3-2-4 2-4-2-3 2-4-2-3 2-4-2",
    "data-name": "Path 2130",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 85",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 82"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m140 259-12-29a99 99 0 0 1 0-45q3-14 17-41c14-27 17-42 20-50s36-28 43-32l7-5",
    "data-name": "Path 222"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(0,0,0,0)",
    d: "m91 44 22 29c8 12 28 59 28 59l-17 35q-9 21-11 45c-2 24-1 30-1 38l-2 9",
    "data-name": "Path 223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m133 47 1 54 1 1 12 22 7-16 13-38c0-3-22-27-23-29",
    "data-name": "Path 224"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m211 56-40 25c-2 0 13-35 13-35",
    "data-name": "Path 225"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m181 46-12 17c-2 2-21-23-21-23",
    "data-name": "Path 226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m113 31-3 30-20-22",
    "data-name": "Path 227"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m131 43-4 45-14-25 2-36",
    "data-name": "Path 228"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m118 259-1-12a139 139 0 0 1-2-38",
    "data-name": "Path 229"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m117 217 1 17",
    "data-name": "Path 230"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m120 231 1 13 3 10",
    "data-name": "Path 231"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m119 185-3 17",
    "data-name": "Path 232"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m118 203-1 9",
    "data-name": "Path 233"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m126 166 9-20",
    "data-name": "Line 83"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m133 153 9-15",
    "data-name": "Line 84"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m207 137-2 2-4-1 3-2z",
    "data-name": "Path 296"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M189 83s3-3 6-2 5 5 5 5l-7 1c-3 0-4-4-4-4",
    "data-name": "Path 297"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M152 173s2-2 5-1 5 5 5 5h-7q-4-3-3-4",
    "data-name": "Path 298"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m210 76 3 5q0 6-1 8l-4-7z",
    "data-name": "Path 299"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m194 197 4 5-2 8-3-7z",
    "data-name": "Path 300"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m158 76-3 3-4-1 4-3z",
    "data-name": "Path 301"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m182 70-3 2q-4 0-4-1l4-2z",
    "data-name": "Path 302"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m231 196-3 2q-3 0-4-1l4-2z",
    "data-name": "Path 303"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M147 60s-1 3-4 4-7-1-7-1l6-5q5 0 5 2",
    "data-name": "Path 304"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M193 52s-1 3-4 4-7-1-7-1l5-4q5 0 6 1",
    "data-name": "Path 305"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m127 45-2 5q-6 3-7 2-1-2 4-6z",
    "data-name": "Path 306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M229 110s1-4 4-5 7 1 7 1l-6 5c-3 2-5-1-5-1",
    "data-name": "Path 307"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M138 43s1-3 4-4 7 0 7 0l-6 5q-5 0-5-1",
    "data-name": "Path 308"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M230 81s1-3 4-4 7 0 7 0l-6 5q-5 0-5-1",
    "data-name": "Path 309"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M230 81s1-3 4-4 7 0 7 0l-6 5q-5 0-5-1",
    "data-name": "Path 310",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M159 126s0-4 3-5 7 1 7 1l-5 5c-3 2-5-1-5-1",
    "data-name": "Path 311"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M159 126s0-4 3-5 7 1 7 1l-5 5c-3 2-5-1-5-1",
    "data-name": "Path 312",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M191 105h5c3 2 4 7 4 7l-7-2q-3-4-2-5",
    "data-name": "Path 313"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M191 105h5c3 2 4 7 4 7l-7-2q-3-4-2-5",
    "data-name": "Path 314",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M103 161h-5c-3-1-5-6-5-6l7 1q3 3 3 5",
    "data-name": "Path 315"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M103 161h-5c-3-1-5-6-5-6l7 1q3 3 3 5",
    "data-name": "Path 316",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M93 71h-5c-3-1-5-6-5-6l7 1q4 3 3 5",
    "data-name": "Path 317"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M93 71h-5c-3-1-5-6-5-6l7 1q4 3 3 5",
    "data-name": "Path 318",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M169 44h5c3 2 4 7 4 7l-7-2q-3-3-2-5",
    "data-name": "Path 319"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M169 44h5c3 2 4 7 4 7l-7-2q-3-3-2-5",
    "data-name": "Path 320",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M188 61h5l4 7q-1 1-7-2c-6-3-2-5-2-5",
    "data-name": "Path 321"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M188 61h5l4 7q-1 1-7-2c-6-3-2-5-2-5",
    "data-name": "Path 322",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m200 56 2 6q-3 5-5 6v-8z",
    "data-name": "Path 323"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m200 56 2 6q-3 5-5 6v-8z",
    "data-name": "Path 324",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M232 51s0 3-2 5-8 1-8 1l5-6z",
    "data-name": "Path 325"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M232 51s0 3-2 5-8 1-8 1l5-6z",
    "data-name": "Path 326",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m230 66-5-2c-2-2-3-7-3-7l7 3q2 5 1 6",
    "data-name": "Path 327"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m230 66-5-2c-2-2-3-7-3-7l7 3q2 5 1 6",
    "data-name": "Path 328",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m112 82-2-5q0-7 2-8l3 8z",
    "data-name": "Path 329"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m112 82-2-5q0-7 2-8l3 8z",
    "data-name": "Path 330",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M101 73s1-3 4-4 7 0 7 0l-6 5q-5 0-5-1",
    "data-name": "Path 331"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M101 73s1-3 4-4 7 0 7 0l-6 5q-5 0-5-1",
    "data-name": "Path 332",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M127 52s0 4-3 6-7 1-7 1l5-6z",
    "data-name": "Path 333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M127 52s0 4-3 6-7 1-7 1l5-6z",
    "data-name": "Path 334",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m125 68-5-2c-3-2-3-7-3-7l6 3q3 5 2 6",
    "data-name": "Path 335"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m125 68-5-2c-3-2-3-7-3-7l6 3q3 5 2 6",
    "data-name": "Path 336",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M181 74s0 4-3 5l-7 1q0-1 5-6z",
    "data-name": "Path 337"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M181 74s0 4-3 5l-7 1q0-1 5-6z",
    "data-name": "Path 338",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m179 90-5-2-3-8 7 4q2 5 1 6",
    "data-name": "Path 339"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m179 90-5-2-3-8 7 4q2 5 1 6",
    "data-name": "Path 340",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M153 81s1-3 4-4 7 1 7 1l-6 5q-5 0-5-2",
    "data-name": "Path 341"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M153 81s1-3 4-4 7 1 7 1l-6 5q-5 0-5-2",
    "data-name": "Path 342",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m158 67 5 3 1 8-5-5z",
    "data-name": "Path 343"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m158 67 5 3 1 8-5-5z",
    "data-name": "Path 344",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M163 62s1-3 4-4 7 1 7 1l-6 5q-5 0-5-2",
    "data-name": "Path 345"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M163 62s1-3 4-4 7 1 7 1l-6 5q-5 0-5-2",
    "data-name": "Path 346",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m169 48 4 3q2 6 1 8l-5-5z",
    "data-name": "Path 347"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m169 48 4 3q2 6 1 8l-5-5z",
    "data-name": "Path 348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M143 93s0 4-2 5l-7 1 4-6z",
    "data-name": "Path 349"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M143 93s0 4-2 5l-7 1 4-6z",
    "data-name": "Path 350",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m141 109-5-2q-2-6-2-8l6 4q2 5 1 6",
    "data-name": "Path 351"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m141 109-5-2q-2-6-2-8l6 4q2 5 1 6",
    "data-name": "Path 352",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M103 123h5q5 5 5 6l-7-1q-3-3-3-5",
    "data-name": "Path 353"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M103 123h5q5 5 5 6l-7-1q-3-3-3-5",
    "data-name": "Path 354",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m116 117 1 6-4 6-1-8z",
    "data-name": "Path 355"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m116 117 1 6-4 6-1-8z",
    "data-name": "Path 356",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M137 76q-2 6-2 8 1 2 6-4l1-6zm5 8q4 4 3 5l-5 1q-5-4-5-6 1-2 7 0",
    "data-name": "Path 357"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m124 81 7-1q-1-2-6-5l-5 2s1 3 4 4m5-9 2-5 3 5q-1 7-3 8z",
    "data-name": "Path 358"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m156 50 4 6s1-5 0-8l-4-4zm8-1 5-1-2 6c-2 2-7 2-7 2z",
    "data-name": "Path 359"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m181 69 5 6s1-5-1-8l-4-4zm8-1 5-1-2 6q-4 2-6 2c-2 0 1-5 3-7",
    "data-name": "Path 360"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m213 52-2 7q2 0 6-4l1-6zm5 8q4 3 3 5h-5c-3-1-5-6-5-6z",
    "data-name": "Path 361"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M124 101v-8s-4 3-5 6l1 6zm-7-6q-4-2-4-3 0-2 5-3c5-1 6 4 6 4z",
    "data-name": "Path 362"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m202 58 7-3q-1-1-7-3c-6-2-4 4-4 4s1 2 4 2m2-10 1-5 4 4v8z",
    "data-name": "Path 363"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M260 114h-7q0 2 5 5a5 5 0 0 0 6-1s-1-3-4-4m-5 8-3 5-2-6q1-6 3-7z",
    "data-name": "Path 364"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m98 43 2 8s2-4 3-7l-3-6zm8 4q5 0 5 2 0 3-4 4-7 0-7-2 1-3 6-4",
    "data-name": "Path 365"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m242 140 3 2v5l-3-4z",
    "data-name": "Path 366"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m242 140 3 2v5l-3-4z",
    "data-name": "Path 367",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m149 152 3 2 1 5-4-3z",
    "data-name": "Path 368"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m149 152 3 2 1 5-4-3z",
    "data-name": "Path 369",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m258 203 2 2 1 5-3-3z",
    "data-name": "Path 370"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m258 203 2 2 1 5-3-3z",
    "data-name": "Path 371",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M144 97h4l2 4-4-1z",
    "data-name": "Path 372"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M144 97h4l2 4-4-1z",
    "data-name": "Path 373",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Flying kite-bro"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#eceff1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m298 254-2-1 1-1h3v1z",
    "data-name": "Path 2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 247zl2-1 1 1-2 1z",
    "data-name": "Path 2028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286 264zh1l-1-1h-1l-1 1v2-3l-1-1-1-1v-1h1l1 2v-1h1v-2l-1-1-1-1v-1l2 2v1-1l1-2v-1h-1l-1-1v-1h1l1 1v1l1-1v-2h-1l-1-2 1-1 1 2v1-3h-1l-1-2 1-1 1 2v1-3l-1-1v-2h1v5l1 2-1 2 1-1 2-1v1l-1 1h-2v3l2-1v1l-1 1h-2v2l-1 1 2-1h1v1l-1 1-2-1v2q0 1 0 0v2-1l1-1 1-1v4-1l1-1 1-1-1-1v-2h1l1 2-1 1 1-1 1-1h1l-1-2v-1h1v3l1-1 1-1-1-2v-1l1-1v1l1 2-1 1 1-2 1-1-1-1v-2h1v3l1-2v-4h1v3l-1 1-1 2-1 1-1 2 1-1 2 1v1h-1l-2-1-1 1-1 1h3v1h-2l-1-1h-1l-1 2h-1 3v1h-2l-1-1-1 1q-1 0 0 0v1h-1v1l1-1h2v2a1 1 0 0 1-2 0l-1-1z",
    "data-name": "Path 2029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152 251 1-1-2-1a1 1 0 0 0 0 2z",
    "data-name": "Path 2030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161 246v-1l-2-2-1 1 1 1z",
    "data-name": "Path 2031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 259v1h1zh1l1 2v-2l1-1v-2l-1 2v-1h-1v-2h1l1-1v-1h-1l-1 1v1l-1-2v-1h1l1-1v-1h-1l-1 1v1-1l-1-2h1l1-1v-1h-1l-1 2v-2l1-1 1-1-1-1-1 2v-2l1-1 1-1-1-1-1 2v6q-1-2-2-1v1h2v2l1 1-2-1v2l2-1v1l1 2-2-1v1l1 1h1v3-1l-1-1h-1v2-1h-1l-1-1 1-1v-2h-1v3l-2-1v-1l1-1v-2h-1v3l-1-1-1-1 1-1v-1l-1-1v3l-1-1-1-1 1-1 1-1-1-1-1 2v1l-1-2 1-2v-1h-1v3l1 2 1 1 1 1h-3v1h2l1-1 1 2h1-2v1h2l2 1h-2v1h3l1 1zv-1h-2v1l1 1z",
    "data-name": "Path 2032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248 253 2-1-1-1h-2a1 1 0 0 0 0 2z",
    "data-name": "Path 2033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 246zl-2-2v1l-1 1 2 1z",
    "data-name": "Path 2034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329 253-1-1h1l2-1a1 1 0 0 1 0 2z",
    "data-name": "Path 2036"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319 247v-1l2-2h1v1l-1 2z",
    "data-name": "Path 2037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 264zv-2l-2 1v3-4h-2v-2l1-1 1 2v1-2l1-2h-2l-1-1 1-1 2 1v1-1l1-2-2-1v-2l2 2v1l1-2v-2h-2v-3l2 2v1-3h-1l-1-2v-1l2 2v1-3l-1-1-1-2h1l1 2v7l1-1 2-1v1l-1 1h-2v2l-1 1h1l2-1v1l-1 1h-2l-1 3 2-1h1v1l-1 1h-2v2l-1 1h1l1-2h1v3l1-1v-1h1l-1-2v-1l1-1 1 3h-1 1l2-1v-1l-1-1v-2h1v3l1-1 2-1-1-1-1-2h2v3l1-2v-1l-1-1v-2h1l1 2v1-2h1l-1-2v-2h1l1 1-1 2v1h-1v2l-1 1-1 2h3v1h-2l-1-1-2 2h-1 3v2a1 1 0 0 1-2 0l-1-1-2 1-1 1h3v1a1 1 0 0 1-2 0l-1-1-1 1-1 1v1-1h3v1a1 1 0 0 1-2 1l-1-1z",
    "data-name": "Path 2038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103 263 1 1h1zl-1-1 1-1 1 1v3h1v-4h1l1-2h-1v-1l-1 2v1l-1-1v-3h1l1-1v-1h-1l-1 1v1-1l-1-2h-1l2-1 1-1v-1h-1l-1 2-1 1v-2l-1-2h2l1-2-1-1-1 2-1 1v-3h2l1-2-1-1-2 2v1-1l1-2 1-1v-3h-1l-1 3 1 1-1 2v4-1l-2-1-1 1 2 1h1l1 2v1l-2-1v1l1 1h1l1 3-2-1v1l1 1h2v3l-1-2h-1v3l-1-1-1-1-1-1 1-1 1-1-1-1h-1v3l-2-1-1-1 2-1v-2h-2v3l-1-1-1-1 1-1v-3l-1 1v3l-1-2-1-1 1-1 1-2h-2v3l-1-2 1-2-1-2h-1v3l1 1 1 2 1 1 1 2h-3v1a1 1 0 0 0 2 0l1-1 1 1 1 1h-2v2h1l2-2v1l2 1v1-1l-2 1v1h1l2-1v1h1v1h1-3v1l1 1 2-1z",
    "data-name": "Path 2127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m315 257 2-1h-3z",
    "data-name": "Path 2042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 253v-1l-2-1 1 1z",
    "data-name": "Path 2043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 254h2l-1-1h-2z",
    "data-name": "Path 2045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269 244-1-1-1-2-1 1 1 2z",
    "data-name": "Path 2046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 259zl-1-1 1-1h1v1l1 2v-3l1-1 1-1-1-1-1 2v1-1l-1-1v-2h1l1-1v-1h-1l-1 1v1l-1-2v-1h1l1-2-1-1-1 2v1l-1-1v-2l1-1 1-1-1-1-1 2v1-3h1l1-1v-1h-1l-1 1v1-3l1-1v-2h-1v5l-1 2 1 2-1-1-2-1v1l1 1h2v3-1l-2-1v2h3v1l1 2h-1l-1-1h-1v1l1 1h2v2l-1-1h-1v3-1h-1v-1l-1-1 1-1v-1l-1-1v3h-1l-1-1-1-1 1-1v-2h-1v3l-1-1-1-1 1-1v-2h-1v3l-1-1-1-1 2-1v-2h-1l-1 2v1-2l-1-1 1-1-1-2h-1l1 3 1 1v1l1 2 1 1h-3v1a1 1 0 0 0 2 0l1-1 1 1 1 1h-2v1h1l1-1 1 1 1 1h1-3v1l1 1h1l1-1h1v1l1 1h-3l1 1h1z",
    "data-name": "Path 2047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299 256h1z",
    "data-name": "Path 2048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 252zl-2-1v1l1 1z",
    "data-name": "Path 2049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 264zv-1h1v3h1v-2l-1-1h2v-2h-1l-1 2v-3h1l1-1h-1v-1l-1 2-1-2 1-1 1-1h-1l-1 1v1-1l-1-2h1l1-1v-1h-1l-1 1v1-2h1l1-1v-1h-1l-1 1v1-2l1-1v-2l-1 2v5q-1-2-2-1v1h2v2l1 1-1-1-1-1v1l1 1h1v2h1-1l-1-1v1l1 1h1v2l-1-1v-1l-1 1v2-1h-1v-4 1l-1 1 1 1h-1l-1-1v-3l-1 2h1-1l-1-1 1-1v-2h-1l-1 2 1 1-1-2h-1l1-1v-2l-1 2v1-5h-1v2l1 1v1l1 1 1 2-1-1-2 1 1 1h1l1-1 1 1h-2v1h3l1 1h-1v1h1l1-1v1h1v1h-2v1h1z",
    "data-name": "Path 2050"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#eceff1",
    "data-name": "freepik--Plants--inject-122"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m488 250 2-1-1-1h-2a1 1 0 0 0 0 2z",
    "data-name": "Path 2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502 245v-1q-1-2-3-2l-1 1 2 1z",
    "data-name": "Path 2028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501 261zv-2h-2v4h-1l1-4-2-1-1-1v-1h1l2 2v1-4l-1-1-1-1v-1l1-1 1 2v1h1l1-3v-1h-2l-1-2 1-1 2 2v1-1l1-3h-2l-1-2h1v-1l2 2v1-3l-1-1-2-1 1-1 2 2v-3l-2-1v-2h1l1 2v8h1l2-2v2l-1 1-2-1v3l-1 1q2-2 3-1v1l-1 1h-2l-1 3v1-1l2-1 1 1-2 1h-1l-1 1v1q0 1 0 0v2-1l1-1h1v-1l1 1v3l1-1v-1l1-1-1-2v-1l1-1 1 3-1 1 1-1 2-1h1l-2-2v-2h2v3l1-1 1-1-1-2v-1l1-1 1 3v1l1-2v-1l-1-1v-3h1l1 3v1-2l1-1-1-2 1-2h1l-1 3v2l-1 1-1 2-1 2h3v1h-2l-1-1-2 2h-1l3 1v1h-2l-1-1h-1l-2 2h2l1 1-1 1h-1l-2-1-1 1-1 1h3v1l-2 1-1-1z",
    "data-name": "Path 2029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m667 246-2-1 1-1 3-1a1 1 0 0 1 0 2z",
    "data-name": "Path 2030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m646 242 1-1 2-3 1 1v1l-1 2z",
    "data-name": "Path 2031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m656 259-1 1h-1zl1-1-1-2h-2v4-4l-2-1-1-2h1v-1l2 3v1-3h1v-2l-2-1-1-1v-1h1l2 2v1-1l1-3 1-1h-2l-1-2v-1h1l1 2 1 1v-2l1-2-2-1-1-1v-1l1-1 2 3v1-4l-2-1-1-1v-1l1-1 2 2v1-3l-2-2v-2h1l1 3v9l1-1 2-2 1 1v1l-2 1h-2v3l-1 1 3-2v2l-1 1h-2l-1 3-1 1h1l2-2 1 1v1l-2 1h-2v3l-1 1 1-1 1-1v-1h2v4h-1 1l1-1v-1l2-1-2-2v-2h2v4-1l3-1v-1l-1-2v-2h1l1 3-1 1 2-1 1-2-1-2v-2h1l1 3v1l1-2 1-1-2-2v-2h1l1 3 1-3v-4h2l-1 3-1 1v1l-1 2-1 2-1 2h3l1 1-1 1h-2l-1-2-2 2-1 1h3v2h-2l-2-2v1l-2 1-1 1h3v2h-2l-2-1-1 1-1 1v1-1h3v2h-2l-2-1z",
    "data-name": "Path 2032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m556 253-2-1 1-1h3a1 1 0 0 1 0 2z",
    "data-name": "Path 2033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542 246zl2-2 1 1v1l-1 1z",
    "data-name": "Path 2034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m615 260-1 1zv-1h-2v3-3h-1l-1-2h1l1 2v-2l1-1-2-1v-2l2 2v1-1l1-2-2-1v-2l2 2v1-2l1-1-2-1v-2l2 2v1-3h-2v-2q1-1 2 1v1-3l-2-1v-2h1l1 2v7-1l2-1v1l-1 1h-1l-1 1v1l2-1v1l-1 1h-1l-1 2v1q0-2 2-1v1l-1 1-1-1v2h-1v1h1v-1l1-1h1v3zh1v-1l1-1v-1l-1-2h1l1 2v1-1l1-1h1l-1-1v-2h1v3l1-1 1-1-1-1v-2h1v3l1-2h1l-1-2-1-1h1l1 2 1-2-1-1 1-2h1l-1 3-1 1v1l-1 1-1 2 1-1 2 1v1a1 1 0 0 1-2 0l-1-1-1 1-1 1h3l-1 1h-1l-1-1-2 1v1h2v1a1 1 0 0 1-2 0l-1-1v1q0 1 0 0h-1v1zh3v1h-1z",
    "data-name": "Path 2035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m458 253-2-1h1l2-1a1 1 0 0 1 0 2z",
    "data-name": "Path 2036"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444 247v-1l2-2 1 1-2 2z",
    "data-name": "Path 2037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448 253v-1l-1-1h-1l1 1z",
    "data-name": "Path 2043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448 264zh1v2h1l-1-2 1-1 1-1-1-1-1 2v-2l1-1v-1l-1 1v1-1l-1-1v-1h1l1-1h-1l-1 1v-1l-1-1h1l1-1v-1h-1l-1 1v1-2h1l1-1v-1h-1l-1 1v1-2l1-1v-1l-1 1v5-1h-2v1h2v1l1 1-2-1v1l1 1h1v1l1 1h-1l-1-1v1h2v3-1l-1-1h-1v2zh-1v-1h-1v-1l1-1v-1h-1v2h-1l-1-1 1-1v-1l-1-1v3l-1-1-1-1 1-1v-1h-1v2l-1-1v-1h1v-2h-1v2l-1-1 1-1a1 1 0 0 0-1-2v3l1 1v1l1 1h-2v1h1l1-1 1 1 1 1h-2v1h1l1-1 1 1h1-2v1h3zh-2l1 1h1z",
    "data-name": "Path 2044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 254h-2l1-1h2v1z",
    "data-name": "Path 2045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547 249v-1l2-2 1 1-1 1z",
    "data-name": "Path 2046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m607 260 1 1zh1l1 1v1-2l1-1v-2l-1 2v1-2h-1v-1l1-1 1-1h-1l-1 1v1-1l-1-2 1-1 1-1h-1l-1 1v1-1l-1-2h2v-2l-2 1v1-2l1-1h1v-1l-2 1v-2l1-1 1-1h-1l-1 2v5-1h-2v1h2l1 2v1-1h-2l1 1h1l1 3v-1l-2-1v1l1 1h1v3-1l-1-1h-1v2zh-1v-1h-1v-1l1-1v-1h-1l-1 2h1-1l-1-1v-3l-1 2h1-1l-1-1v-3l-1 2 1 1-1-2h-1l1-1v-2h-1v3-2h-1l1-2-1-1v3h1v1l1 2v1-1l-2 1v1h1l1-1 2 1-2 1v1a1 1 0 0 0 2 0l1-1 1 1h-1l-1 1 1 1h1l1-1h1v1zh-2v1a1 1 0 0 0 2 0z",
    "data-name": "Path 2047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m487 253-2-1h1l2-1a1 1 0 0 1 0 2z",
    "data-name": "Path 2048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476 248zl1-1 1 1-1 1z",
    "data-name": "Path 2049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475 260v1h-1zh-1v2h-1v-1l1-1-1-1-1-1h1l1 1v1-3l-1-1h-1l1-1 1 1v1-1l1-1v-1h-1l-1-1 1-1 1 1v1l1-1v-1l-1-1-1-1h1l1 1v-2h-1l-1-1 1-1 1 1v1-2l-1-1v-1l1 1v5l2-1v1l-1 1h-1v1l-1 1h1l1-1v1h-2v3l1-1v1h-2v3-1l1-1h1v2-1h1v-3l1 2 1-1h1l-1-1v-2h1v3-1l1-1v-3 1l1 1-1 1 1-1 1-1-1-1v-1l1 1v1-4h1v2l-1 1v1l-1 1v1h2l-1 1h-1l-1-1-1 1v1h2l-1 1h-1l-1-1-1 1v1-1l1 1v1h-1l-1-1-1 1zv-1h2v1h-2Z",
    "data-name": "Path 2050"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M417 265H231",
    "data-name": "Line 254"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    "data-name": "freepik--Floor--inject-122"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437 265h-11",
    "data-name": "Path 2555"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M526 265h-56",
    "data-name": "Line 310"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714 265H510",
    "data-name": "Path 62422"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "freepik--Floor--inject-122"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M219 265H31",
    "data-name": "Line 254"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 87"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "m519 262-3-2-3 2-3-2-4 2-3-2-3 2-3-2-3 2-3-2-3 2-4-2-3 2-3-2-3 2-3-2-3 3v2h54Z",
    "data-name": "Path 2125",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "m604 264 62 1-5-3-3-2-3 2-3-2-3 2-3-2-3 2-3-2-4 2-3-2-3 2-3-2-3 2-3-2-4 2-3-2-3 2-3-2-3 2-3-2-3 2-2-2-3 2-3-2-4 2-3-2-3 2-3-2-3 2-3-2-3 2-4-2-3 2-3-2-3 2-3-2-3 2-3-2-4 2-3-2-3 2v2z",
    "data-name": "Union 95",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "m392 262-3-2-4 2-4-2-3 2-4-2-4 2-3-2-4 2-4-2-4 2-3-2-4 2-4-2-3 2-4-2-4 3v2l65-1Z",
    "data-name": "Path 2553",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    d: "m596 260 3 2 3-2 3 2 3-2 3 2 3-2 4 2 3-2 3 2 3-2 3 2 3-2 3 2 4-2 3 2 3-2 3 2 3-2 3 2 3-2 4 2 3-2 3 2",
    "data-name": "Path 2123",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    d: "m472 260 3 2 3-2 3 2 3-2 4 2 3-2 3 2 3-2 3 2 3-2 3 2 4-2 3 2 3-2 3 2 3-2 3 2",
    "data-name": "Path 2126",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    d: "m596 260-3 2-4-2-3 2-3-2-3 2-3-2-3 2-3-2-3 2-4-2-3 2-3-2-3 2-3-2-3 2-3-2-4 2",
    "data-name": "Path 70596",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    d: "m337 260 4 2 3-2 4 2 4-2 3 2 4-2 4 2 4-2 3 2 4-2 4 2 3-2 4 2 4-2 4 2 3-2 4 2",
    "data-name": "Path 2554",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 86",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "freepik--Tree--inject-758"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "m666 259 8-18a64 64 0 0 0 0-30l-11-26c-6-12-11-27-13-32s-24-18-28-21l-5-3",
    "data-name": "Path 222"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "m698 121-15 18c-5 7-18 38-18 38l11 23q6 13 7 29l1 25 1 6",
    "data-name": "Path 223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "M670 123v34l-1 1-7 14-5-10c-3-9-9-23-8-25l14-19",
    "data-name": "Path 224"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "m619 128 27 17c2 1-9-23-9-23",
    "data-name": "Path 225"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "m640 121 7 12c1 1 14-15 14-15",
    "data-name": "Path 226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "m683 112 2 19 13-14",
    "data-name": "Path 227"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "m672 120 2 29 9-17-1-23",
    "data-name": "Path 228"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "m680 261 1-9 1-24",
    "data-name": "Path 229"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "m681 233-1 10",
    "data-name": "Path 230"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "m679 241-1 9-2 7",
    "data-name": "Path 231"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "m679 211 3 11",
    "data-name": "Path 232"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "M680 223v6",
    "data-name": "Path 233"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m675 199-6-13",
    "data-name": "Line 83"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m670 191-6-10",
    "data-name": "Line 84"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "freepik--Leaves--inject-758"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m622 180 2 2 2-1-2-1z",
    "data-name": "Path 296"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m634 145-4-1-3 4h4z",
    "data-name": "Path 297"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m658 204-3-1-4 3 5 1z",
    "data-name": "Path 298"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m620 141-2 3 1 5 2-4z",
    "data-name": "Path 299"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m631 219-3 3 1 6 3-5z",
    "data-name": "Path 300"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m654 141 2 2 2-1-2-1z",
    "data-name": "Path 301"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m639 137 1 2 3-1-2-1z",
    "data-name": "Path 302"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m607 219 2 1h2l-2-2z",
    "data-name": "Path 303"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m661 130 3 3q3 0 4-1l-4-2z",
    "data-name": "Path 304"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m632 126 2 2h5l-4-3z",
    "data-name": "Path 305"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m674 121 2 4 4 1-2-5z",
    "data-name": "Path 306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m608 163-2-3h-5l4 4z",
    "data-name": "Path 307"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m667 120-2-3h-5l4 4z",
    "data-name": "Path 308"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m607 144-2-2h-5l4 3z",
    "data-name": "Path 309"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m607 144-2-2h-5l4 3z",
    "data-name": "Path 310",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m654 173-3-3-4 1 3 3z",
    "data-name": "Path 311"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m654 173-3-3-4 1 3 3z",
    "data-name": "Path 312",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M633 160h-4l-2 4 4-1z",
    "data-name": "Path 313"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M633 160h-4l-2 4 4-1z",
    "data-name": "Path 314",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M689 196h4l3-4-5 1z",
    "data-name": "Path 315"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M689 196h4l3-4-5 1z",
    "data-name": "Path 316",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M696 138h4l3-4-5 1z",
    "data-name": "Path 317"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M696 138h4l3-4-5 1z",
    "data-name": "Path 318",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M647 120h-3l-3 5 4-2z",
    "data-name": "Path 319"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M647 120h-3l-3 5 4-2z",
    "data-name": "Path 320",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m635 131-3 1-3 4 4-1z",
    "data-name": "Path 321"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m635 131-3 1-3 4 4-1z",
    "data-name": "Path 322",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m627 128-1 4 3 4v-5z",
    "data-name": "Path 323"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m627 128-1 4 3 4v-5z",
    "data-name": "Path 324",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m606 125 2 3 4 1-3-4z",
    "data-name": "Path 325"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m606 125 2 3 4 1-3-4z",
    "data-name": "Path 326",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m607 135 4-1 1-5-4 2z",
    "data-name": "Path 327"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m607 135 4-1 1-5-4 2z",
    "data-name": "Path 328",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m684 145 1-3-1-5-2 5z",
    "data-name": "Path 329"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m684 145 1-3-1-5-2 5z",
    "data-name": "Path 330",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m691 139-3-3-4 1 3 3z",
    "data-name": "Path 331"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m691 139-3-3-4 1 3 3z",
    "data-name": "Path 332",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m674 126 2 3 5 1-3-4z",
    "data-name": "Path 333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m674 126 2 3 5 1-3-4z",
    "data-name": "Path 334",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m676 136 3-1 2-5-4 2z",
    "data-name": "Path 335"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m676 136 3-1 2-5-4 2z",
    "data-name": "Path 336",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m639 140 2 3 5 1-3-4z",
    "data-name": "Path 337"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m639 140 2 3 5 1-3-4z",
    "data-name": "Path 338",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m640 150 4-1 2-5-5 2z",
    "data-name": "Path 339"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m640 150 4-1 2-5-5 2z",
    "data-name": "Path 340",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m657 145-2-3q-4 0-5 1l4 2z",
    "data-name": "Path 341"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m657 145-2-3q-4 0-5 1l4 2z",
    "data-name": "Path 342",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m654 135-3 2-1 6 4-4z",
    "data-name": "Path 343"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m654 135-3 2-1 6 4-4z",
    "data-name": "Path 344",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m651 132-3-3-4 1 4 3z",
    "data-name": "Path 345"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m651 132-3-3-4 1 4 3z",
    "data-name": "Path 346",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m647 123-3 2v5l3-3z",
    "data-name": "Path 347"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m647 123-3 2v5l3-3z",
    "data-name": "Path 348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m664 152 1 4h5l-3-4z",
    "data-name": "Path 349"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m664 152 1 4h5l-3-4z",
    "data-name": "Path 350",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m665 162 3-1q3-3 2-5l-4 3z",
    "data-name": "Path 351"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m665 162 3-1q3-3 2-5l-4 3z",
    "data-name": "Path 352",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M690 171h-4l-2 5 4-1z",
    "data-name": "Path 353"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M690 171h-4l-2 5 4-1z",
    "data-name": "Path 354",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M681 168v4l3 4v-6z",
    "data-name": "Path 355"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M681 168v4l3 4v-6z",
    "data-name": "Path 356",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m668 141 1 5-4-2v-4zm-3 6-3 3h4l3-4z",
    "data-name": "Path 357"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M676 144h-5l4-4 4 1zm-3-5-1-4-2 4 2 5z",
    "data-name": "Path 358"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m656 125-3 3v-5l2-2zm-6-1-3-1 1 4 5 1z",
    "data-name": "Path 359"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m639 137-3 3v-5l3-2zm-5-1-3-1 1 4 4 1z",
    "data-name": "Path 360"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m618 125 2 5-4-2-1-4zm-3 6-2 3h4l3-4z",
    "data-name": "Path 361"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M676 157v-5l3 4-1 4zm4-3 3-2-3-2-4 2z",
    "data-name": "Path 362"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m625 129-4-2 5-1 3 2zm-1-6v-3l-3 2v5z",
    "data-name": "Path 363"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M588 166h5l-4 3h-3zm3 5 2 3 2-4-2-4z",
    "data-name": "Path 364"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m693 120-1 5-2-5 1-3zm-5 2-3 1 2 3q4 0 5-1z",
    "data-name": "Path 365"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m600 182-2 2v3l2-2z",
    "data-name": "Path 366"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m600 182-2 2v3l2-2z",
    "data-name": "Path 367",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m660 190-2 2v3l2-2z",
    "data-name": "Path 368"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m660 190-2 2v3l2-2z",
    "data-name": "Path 369",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m590 223-2 2v3l2-2z",
    "data-name": "Path 370"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m590 223-2 2v3l2-2z",
    "data-name": "Path 371",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m663 154-2 1-2 2h3z",
    "data-name": "Path 372"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m663 154-2 1-2 2h3z",
    "data-name": "Path 373",
    opacity: 0.3
  })))), /*#__PURE__*/React.createElement("g", {
    stroke: "#263238",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M280 262h3v-98h-3Z",
    "data-name": "Path 24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M279 163h5l1-9h-7Z",
    "data-name": "Path 25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M280 163h4v-9h-5Z",
    "data-name": "Path 26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M278 153h8v1h-8z",
    "data-name": "Rectangle 5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M278 162h7v2h-7z",
    "data-name": "Rectangle 6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M279 152h6v1z",
    "data-name": "Rectangle 7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M281 150h1v2h-1z",
    "data-name": "Rectangle 8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M279 256h6v8h-6z",
    "data-name": "Rectangle 9"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "M595 42s0-5 2-7 5-1 7-2 0-4 4-7 7 0 8 3 1 5 4 3a3 3 0 0 1 4 3q0 3 2 4 5 0 6 2c1 2-2 1 2 1l6 2 5 1h2-57l2-2z",
    "data-name": "Path 1052",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "M432 42s0-4 2-7 4 0 6-1-1-4 3-7 6 0 7 3 1 4 3 3 4 0 4 3-1 4 1 3 5 1 5 2-2 1 1 1l5 2 5 1h2-48l2-2z",
    "data-name": "Path 2128",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "M522 16s0-4 1-7 4 0 7-1-1-4 3-7 6 0 6 3 1 4 3 3 4 0 4 3 0 4 2 3 4 1 5 2-2 1 1 1l5 2 4 1h2-47l1-2z",
    "data-name": "Path 71995",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ecf0f1",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232 37s0-6 2-9 6-1 10-2-1-5 4-8 9 0 10 3 1 6 4 4a4 4 0 0 1 6 3q-1 6 3 5 6 0 7 2c1 2-3 2 1 2l8 2 6 1 3 1h-70l2-3z",
    "data-name": "Path 959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232 37s0-6 2-9 6-1 10-2-1-5 4-8 9 0 10 3 1 6 4 4a4 4 0 0 1 6 3q-1 6 3 5 6 0 7 2c1 2-3 2 1 2l8 2 6 1 3 1h-70l2-3z",
    "data-name": "Path 960",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    d: "m181 262-3-2-4 2-4-2-3 2-4-2-3 2-4-2-3 2-4-2-4 2-3-2-4 2-3-2-4 2-3-2-4 2-4-2-3 2-4-2-3 2",
    "data-name": "Path 236",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    d: "m217 262-4-2-3 2-4-2-3 2-4-2",
    "data-name": "Path 62424",
    opacity: 0.7
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M1327 362h288v300h-288z",
    "data-name": "Rectangle 9416"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m1405 409-22 24",
    "data-name": "Line 1624"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m1601 425-22 24",
    "data-name": "Line 1726"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m1358 454-6 6",
    "data-name": "Line 1625"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m1554 470-6 6",
    "data-name": "Line 1728"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m1383 424-21 22",
    "data-name": "Line 1626"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m1579 439-21 23",
    "data-name": "Line 1727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1475 504-13 14",
    "data-name": "Path 71989"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m1496 481-17 18",
    "data-name": "Line 1628"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m1459 520-4 5",
    "data-name": "Line 1629"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m1479 491-17 18",
    "data-name": "Line 1630"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1321 356h300v313h-300z",
    "data-name": "Rectangle 9436"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#263238",
    "data-name": "Group 57378"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1419 362h5v300h-5z",
    "data-name": "Rectangle 9458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1519 362h5v300h-5z",
    "data-name": "Rectangle 9457"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57401"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57389",
    transform: "translate(1294 462)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.5,
    cy: 6,
    fill: "#627680",
    stroke: "#707070",
    "data-name": "Ellipse 1403",
    opacity: 0.1,
    rx: 82.5,
    ry: 6,
    transform: "translate(0 216)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57388"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57387"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57386"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#263238",
    strokeLinecap: "round",
    "data-name": "Group 57385"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    d: "m105 31-11-6-8-11s6-2 19 12",
    "data-name": "Path 1045"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M102 33s-1 13 1 18l-10 3s3-11-5-16l6-6q3-3 5-3z",
    "data-name": "Path 71168"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110 29q-3 7-6 6l-6-3-2 1q1 1-1 2c-2 1-6 6-9 6l-4-6-1-3-1-2 2-4q-1-3 0-8 2-7 10-7c8 0 20 10 18 18",
    "data-name": "Path 71170"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M83 22s1-2 4 1",
    "data-name": "Path 71172"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M92 11c6-1 11 3 12 2s2 3 2 3c1 2 6 6 4 13q-3 7-7 7-6-1-5-4h-1 0l2-2q1-1-5-4c-6-3 3-9-9-12 1-2 6-3 7-3",
    "data-name": "Path 71173"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    strokeMiterlimit: 10,
    d: "M94 10v8c-5 4-8-6-12 1q-2 3-6 3-5-3-3-4c2-1 1 2 4 0s1-6 4-9q2-3 7-2z",
    "data-name": "Path 69644"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    d: "M83 24v1h3",
    "data-name": "Path 71876"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    d: "M85 26h-2",
    "data-name": "Line 1722"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m85 33-3 1",
    "data-name": "Path 71877"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#627680",
    stroke: "#263238",
    d: "M81 90s-4 16-5 28 6 57 6 59l7 37-9 3q-2 1 0 3c2 2 11 1 13 2s4-1 4-4l-1-3v-52l16 44 2 5 6-1-3-11-7-38-1-6c0-1 4-19 5-33s-4-33-4-33Z",
    "data-name": "Path 71935"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M95 161zl1-27 2-13 5-2 1 1-5 1-2 13z",
    "data-name": "Path 71937"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M61 58zL49 44v-1l8-4 11 14v1zm0-1 6-4Z",
    "data-name": "Path 71939"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M73 71 61 58v-4l-2-4-1-3-2 2 1 2v2l-5-5v2l1 7q0 2 3 3l3 2 7 16s5-6 7-7",
    "data-name": "Path 71960"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M67 79zl-9-15-2-2-3-4-1-4-1-3 1-2h1l3 3-1-2 1-2h2l1 2v1l1 1 2 3-1 2v2l12 15zM52 49zl1 3 1 4 2 3 3 2 8 15 5-4-11-15-1-3 1-1-2-2v-1l-1-2-1-2v1l-1 1 1 2 1 2h-1Z",
    "data-name": "Path 71961"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m70 49-1 2 3 2 3 1h2l1-1 1-2s-6-4-9-2",
    "data-name": "Path 71962"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m76 55-1-1-3-1-3-2v-1l1-1c3-3 9 2 10 2v1l-2 1zm-1-2 1 1 1-2h1l1-1q-4-2-8-2l-1 2 2 2z",
    "data-name": "Path 71963"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m73 46-5 1-3 1 4 1 4 1-2 1q-3 0-2 2h3l3-1 3 1 2-1 6 8 7-1-13-11z",
    "data-name": "Path 71964"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M86 61zl-6-8H68q0-2 3-2l1-1-3-1h-4v-1q2-2 3-2h5l7 1 13 12v1zm-6-9 6 8 6-1-12-11-7-1h-5l-2 1 2 1h5l1 1-3 2-2 1h3l3-1h5Zm-11 0",
    "data-name": "Path 71965"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "m123 65-2-16c-1-3-13-6-15-5 0 0-28 7-27 8s-2 24-2 24l-4-5-5 5-2 2 6 8 8 6s9 5 19 3 12-4 12-4l2-6 4-3c1-1 7-11 6-17",
    "data-name": "Path 71966"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m95 96-15-4-8-5-6-8v-1l2-2 5-5h1l2 3 2-22 14-5 14-4c2 0 14 4 15 6l1 7 1 9c2 6-4 14-5 17l-5 4-2 5s-1 3-12 5zM67 79l6 7c2 3 7 5 7 5s9 6 19 4q14-4 12-4l2-6 4-4c1-1 7-10 6-16l-2-9-1-6c0-2-12-6-14-6-12 3-26 7-27 9l-2 23h-1l-3-5-5 5z",
    "data-name": "Path 71967"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M119 62zl1-3v-1l1 1z",
    "data-name": "Path 71968"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m113 85 5-20h1z",
    "data-name": "Path 71969"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M81 92h-2l1-1 4-1 6-26h1v1c-1 4-5 25-7 26z",
    "data-name": "Path 71976"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M80 86zl-2-8v5h-1v-7h1s0 7 3 9z",
    "data-name": "Path 71977"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m85 69-2-2 1-1z",
    "data-name": "Path 71978"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M83 65zl-3-9 1-1v1z",
    "data-name": "Path 71979"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe5f55",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m66 63-2-3-5 4 1 2z",
    "data-name": "Path 71996"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57373"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#263238",
    strokeLinecap: "round",
    "data-name": "Group 57374"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeLinejoin: "round",
    d: "M96 214s-4 4-8-1c0 1-7 2-10 5q-2 4 0 5l18-1c2 0 1-7 0-8",
    "data-name": "Path 70872"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m86 214 1 1",
    "data-name": "Path 71879"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M84 214v2",
    "data-name": "Path 71881"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m77 222 20-1",
    "data-name": "Path 71880"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    d: "m113 211-6 2-1 4 7 2h7q2-1 1-4l-1-4Z",
    "data-name": "Path 71981"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    d: "m106 216 15 1",
    "data-name": "Path 71982"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    d: "m120 79 5-12q5-5 3-12c-2-7-10-10-14-14l-1-1 2-11q1-13-8-21c-7-4-19-2-21 5l4 3v9c-1 4-4 4-3 8s4 7 3 9c-1 3-4 5 0 9s-2 15 9 28c5 8 17 8 21 0Z",
    "data-name": "Path 71983"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57419"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "Group 57347"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1589 668s-2 58-5 78v1h1l2-1c1-7 8-53 6-77Z",
    "data-name": "Path 70868"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1666 657h-75a4 4 0 0 0-4 4v6l2 3 3 1h74a4 4 0 0 0 4-4v-6l-1-2z",
    "data-name": "Path 70869"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1587 662h82v13h-82z",
    "data-name": "Rectangle 9449"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#627680",
    d: "M1587 662h82v2h-82z",
    "data-name": "Rectangle 9450"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1685 571zc-1 6-9 38-10 72-2 33 8 90 9 101v1l-2 1h0l-2-2c-1-8-10-55-12-80-1-26 9-82 11-92l2-3q2-2 5 1",
    "data-name": "Path 70870"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57405"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57344"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57340"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1609 626-11 2c-2 0-17-7-24-7s-10 21-10 21 40 16 61 15 36-16 36-25-24-4-33-6-19 0-19 0",
    "data-name": "Path 70621"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1604 630s9 6 12 11",
    "data-name": "Path 70622"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1667 557c-9-12-31-13-45-10 0 0-15 4-18 10l-18 35-24 12-16 4-13-5c-3 0-6 6-5 7s8 5 12 5c2 2 43-6 47-7s25-28 25-28 1 25 0 35-6 11-5 12 9 5 30 5 31-7 31-7l8-43c1-9 1-13-9-25",
    "data-name": "Path 70623"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    "data-name": "Group 57328",
    transform: "translate(1528 546)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "m48 61-26 7-10 1c2 2 31-3 43-5Z",
    "data-name": "Path 70624"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m48 61-26 7-10 1c2 2 31-3 43-5Z",
    "data-name": "Path 70625",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1667 557c-9-12-31-13-45-10 0 0-15 4-18 10l-18 35-24 12-16 4-13-5c-3 0-6 6-5 7s8 5 12 5c2 2 43-7 47-7s25-28 25-28 1 25 0 35-6 11-5 12 9 5 30 5 31-7 31-7l8-43c1-9 1-13-9-25",
    "data-name": "Path 70627"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1546 608-4-6-6-2-5-3 2 3 3 2s-2 2-2 4 4 3 7 4",
    "data-name": "Path 70628"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1530 611-9-6s-3-7-1-8 1 6 1 6l2 1v-5l1 2 1 3 1 1v-5l2 1 1 6 2-4v4l5 4",
    "data-name": "Path 70630"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1529 607 3 6",
    "data-name": "Path 70631"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1526 605 1 5",
    "data-name": "Path 70632"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1523 604 1 3",
    "data-name": "Path 70633"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1622 547s-15 4-18 10l-18 35-15 7q5 5 6 12l10-3c4 0 25-28 25-28s1 25 0 35q-5 12-5 12c2 3 2 6 13 7 3 1 12-2 17-2 20 0 31-7 31-7l8-43c1-9 1-13-9-25s-31-13-45-10",
    "data-name": "Path 70634"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    "data-name": "Group 57329",
    transform: "translate(1571 546)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M5 61q9-2 14-7l20-28 1 9c-3 5-21 27-24 28L6 64zm91-50q-6-6-15-9c-6 27-12 66-16 70-6 5-15 8-9 8s8-1 8 2l-1 4h3c20 1 30-6 30-6l8-44c1-9 2-13-8-25",
    "data-name": "Path 70635",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m38 23 2 12-5-15",
    "data-name": "Path 70636"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1622 547s-15 4-18 10l-18 35-15 7 6 11 10-2c4 0 25-28 25-28s1 25 0 35q-5 12-5 12c2 3 2 6 13 7 3 1 12-2 17-2 20 0 31-7 31-7l8-43c1-9 1-13-9-25s-31-13-45-10",
    "data-name": "Path 70638"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1645 657s15 0 24-14c6-10 0-21-12-22s-18 8-28 13c-21 11-38 12-50 14s-9 2 2 6 42 8 64 3",
    "data-name": "Path 70639"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1608 645s16-5 30-13",
    "data-name": "Path 70640"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1573 626-4-2",
    "data-name": "Line 1701"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1599 644-12-7",
    "data-name": "Line 1702"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1611 509s-11 7-7 15 14 4 14 4Z",
    "data-name": "Path 70652"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1624 549s8 17 10 13 1-19 1-19Z",
    "data-name": "Path 70653"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1613 514q-4 8-1 18l-1 3-2 3 3 1s3 11 6 12 15-5 17-7 2-15-2-21-14-14-20-9",
    "data-name": "Path 70654"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    "data-name": "Group 57332",
    transform: "translate(1609 513)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "M26 32c2-2 2-16-1-21l-9-9-5 7s7 10 7 18c1 8-8 10-10 10l2 1c3 0 14-5 16-6",
    "data-name": "Path 70655"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26 32c2-2 2-16-1-21l-9-9-5 7s7 10 7 18c1 8-8 10-10 10l2 1c3 0 14-5 16-6",
    "data-name": "Path 70656",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1613 514q-4 8-1 18c1 2-3 4-3 5l3 2s3 11 6 12 15-5 17-7 2-15-2-21-14-14-20-9",
    "data-name": "Path 70658"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1615 531v2s3 1 4 0",
    "data-name": "Path 70659"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1614 529s2-3 5 0",
    "data-name": "Path 70660"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1618 533-2 1",
    "data-name": "Line 1703"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    d: "M1618 542q-2 3-3 2",
    "data-name": "Path 70685"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1624 502s-16 2-16 9 20 19 20 19-1 1 0 19l4 55s18 5 26-22 4-43-4-61-16-21-30-19",
    "data-name": "Path 70661"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1628 530s24 19 27 37",
    "data-name": "Path 70662"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1642 581v4",
    "data-name": "Path 70663"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1634 536a114 114 0 0 1 8 40",
    "data-name": "Path 70664"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1635 512s12 8 18 25",
    "data-name": "Path 70665"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1635 525q-11-6-17-12",
    "data-name": "Path 71906"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1654 541 1 4",
    "data-name": "Path 70666"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1673 566q6 5 4 13c-2 8-32 48-35 48s-7-2-9-7 5-12 5-12l20-34s4-6 9-7",
    "data-name": "Path 70667"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1673 566q6 5 4 13c-2 8-32 48-35 48s-7-2-9-7 5-12 5-12l20-34s4-6 9-7",
    "data-name": "Path 70670"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1644 615-15-43 1-19-1-1-5-4q-2 0-2 2c0 2-4 2-4 3l-1 1-1 3c-1 2 4 13 5 15l9 46q4 12 8 14s5-4 7-8",
    "data-name": "Path 70671"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    "data-name": "Group 57334",
    transform: "translate(1616 548)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "M4 15c0 2 10 52 17 68l1 1s6-3 7-7V67L14 24V6l-1-2s-9 8-9 11",
    "data-name": "Path 70672"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 15c0 2 10 52 17 68l1 1s6-3 7-7V67L14 24V6l-1-2s-9 8-9 11",
    "data-name": "Path 70673",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1644 615-15-43 1-19-1-1-5-4q-2 0-2 2c0 2-4 2-4 3l-1 1-1 3c-1 2 4 13 5 15l9 46q4 12 8 14s5-4 7-8",
    "data-name": "Path 70675"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1644 615-7-23-12 9 5 17q4 12 8 14s5-4 7-8",
    "data-name": "Path 70676"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1644 615-7-24-12 10 5 17q4 12 8 14s5-4 7-8",
    "data-name": "Path 70679"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1582 625s-2-5-11-4-9 9-9 23 5 42 5 48 17 0 17 0l1-54",
    "data-name": "Path 70642"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1582 694-14-1c0 1 3 1 4 11s-2 16-2 17c1 2 11 1 11 1v-16z",
    "data-name": "Path 70680"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1581 723h-11q-1 3-1 14c0 11 15 8 15-2s-3-12-3-12",
    "data-name": "Path 70683"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1581 711s0 8-5 8-4-8-4-8c-2 2-4 16-3 24s15 8 15-2-3-22-3-22",
    "data-name": "Path 70684"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1584 691h-18l2 9c0 2 15-1 16-1z",
    "data-name": "Path 70647"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1585 649 1-10",
    "data-name": "Line 1704"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1579 730h-6",
    "data-name": "Line 1705"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1576 719v11",
    "data-name": "Line 1708"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1578 727h-4",
    "data-name": "Line 1706"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1578 724h-4",
    "data-name": "Line 1707"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57345"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "Group 57349"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#627680",
    d: "M1518 617h66v2h-66z",
    "data-name": "Rectangle 9448"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d3dade",
    d: "m1550 583 14 36h-46l-13-35Z",
    "data-name": "Path 70408"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "#263238",
    strokeLinecap: "round",
    "data-name": "Group 57370"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#627680",
    strokeLinejoin: "round",
    "data-name": "Group 57341"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1688 757h6l3-124h-12Z",
    "data-name": "Path 70417"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442 757h6l3-124h-12Z",
    "data-name": "Path 70418"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#627680",
    strokeLinejoin: "round",
    d: "M1421 623h294v10h-294z",
    "data-name": "Rectangle 9447"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1728 619h-320v7h320Z",
    "data-name": "Path 71286"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57404"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fe5f55",
    d: "M1491 601h-3a2 2 0 0 0-3 2v3l1 3 2 2 4 4v-4l-5-4q-2-4 4-3z",
    "data-name": "Path 71891"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe5f55",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1492 619h13l2-21h-17Z",
    "data-name": "Path 70838"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1496 598s1-2-4-3-10-1-12-6 0-6 0-6",
    "data-name": "Path 70839"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1498 596s3-3-2-5-9 1-11-2",
    "data-name": "Path 70840"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1491 612q-3-3-4-7t4-1",
    "data-name": "Path 71889"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1492 615q-6-4-7-10 0-7 5-3",
    "data-name": "Path 71892"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57472"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57381",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57322"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 88"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m417 464 34 6h0l23 4h2l5 1h1l3 1h3l1 1v-1l-25-54-9-1-15-1h0l-17-1h0-11l1 9h0l1 14h0l2 16Z",
    "data-name": "Path 2072"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe5f55",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m440 420 48 56 1 1v-1l-34-55Z",
    "data-name": "Path 2073"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m423 419 63 57h2l-48-56Z",
    "data-name": "Path 2074"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe5f55",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m413 428 25 17v1l43 29h1l3 1-62-57h-11Z",
    "data-name": "Path 2075"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m414 442 62 32h0l5 1h1l-44-29v-1l-25-17Z",
    "data-name": "Path 2076"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe5f55",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m416 458 35 12h0l23 4-60-32Z",
    "data-name": "Path 2077"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m464 422-47 42",
    "data-name": "Line 256"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m412 419 77 58",
    "data-name": "Line 257"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M422 427s10 25 35 25",
    "data-name": "Path 2078"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m489 475 13 10 10 4 7 4q5 4 3 10-4 5-10 6l-11 2-12 2-8 4-2 2v3c0 1-1-2 0 0l4 7q8 6 17 7 14 3 27-1a35 35 0 0 0 20-18l2-13v-6q0 2-1-1l-4-7-1-3q11 15 4 33a35 35 0 0 1-13 15q-10 6-22 5c-10 0-24 0-30-11l-4-10q2-7 8-8 11-3 21-5c4 0 16-3 14-10l1 3v-1 1q-1-4-6-5l-10-5-16-11z",
    "data-name": "Path 2080"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m490 477 13 14q4 3 7 7l1 3q-2 2-5 3l-23 7c-5 2-13 5-11 12l-1-1 5 9 10 9a20 20 0 0 0 13 3q10-3 17-7l15-8q5-2 8-8 4-8 1-13l-8-21q-6-11-1-22l1 4-2 6v5q0-2 0 0l1 3 9 24q3 8 1 17-6 7-13 11l-11 5-12 6a21 21 0 0 1-19-2q-7-5-12-13-3-5-3-12c0-13 40-15 39-21l1 4-3-3-6-4-12-14z",
    "data-name": "Path 2081"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M442 441c-68 124 52 100 41 221",
    "data-name": "Path 2079"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57356",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    "data-name": "Mask Group 587",
    transform: "translate(299 362)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "slider"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "slider illustration",
    transform: "translate(-120 63)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#627680",
    "data-name": "freepik--City--inject-351",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144 130zV52h21v38h9V65h15v39h9V81h7v24h4V82h6v23h9v-4h15V72h23v29h37V52h27v22h16V48h24v58h7V76h22v15h12v33h14v-1h-14V91h-12V76h-23v30h-5V48h-26v25h-15V51h-27v50h-36V71h-24v30h-15v4h-9V81h-6v24h-4V80h-7v24h-8V64h-16v26h-8V51h-22z",
    "data-name": "Path 1702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401 99h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1703"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396 99h4v-3h-4Zm3 0h-2v-2h2Z",
    "data-name": "Path 1704"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 99h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388 99h3v-3h-3Zm3 0h-3v-2h3Z",
    "data-name": "Path 1706"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 99h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 99h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1708"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 80h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1709"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 80h4v-3h-4Zm3-1h-2v-2h2Z",
    "data-name": "Path 1710"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351 80h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 80h3v-3h-3Zm3-1h-3v-2h3Z",
    "data-name": "Path 1712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 75h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 75h4v-3h-4Zm3 0h-2v-3h2Z",
    "data-name": "Path 1714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351 75h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 75h3v-3h-3Zm3 0h-3v-3h3Z",
    "data-name": "Path 1716"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 70h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 70h4v-3h-4Zm3 0h-2v-3h2Z",
    "data-name": "Path 1718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351 70h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 70h3v-3h-3Zm3 0h-3v-3h3Z",
    "data-name": "Path 1720"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 65h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1721"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 65h4v-3h-4Zm3 0h-2v-2h2Z",
    "data-name": "Path 1722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351 65h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 65h3v-3h-3Zm3 0h-3v-2h3Z",
    "data-name": "Path 1724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 61h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 61h4v-3h-4Zm3-1h-2v-2h2Z",
    "data-name": "Path 1726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351 61h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 61h3v-3h-3Zm3-1h-3v-2h3Z",
    "data-name": "Path 1728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343 80h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 80h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 85h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 85h4v-3h-4Zm3 0h-2v-3h2Z",
    "data-name": "Path 1732"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351 85h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 85h3v-3h-3Zm3 0h-3v-3h3Z",
    "data-name": "Path 1734"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343 85h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 85h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1736"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401 105h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396 105h4v-3h-4Zm3 0h-2v-3h2Z",
    "data-name": "Path 1738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 105h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388 105h3v-3h-3Zm3 0h-3v-3h3Z",
    "data-name": "Path 1740"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 105h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1741"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 105h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401 111h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396 111h4v-3h-4Zm3-1h-2v-2h2Z",
    "data-name": "Path 1744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 111h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388 111h3v-3h-3Zm3-1h-3v-2h3Z",
    "data-name": "Path 1746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 111h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 111h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401 116h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396 116h4v-3h-4Zm3 0h-2v-3h2Z",
    "data-name": "Path 1750"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 116h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388 116h3v-3h-3Zm3 0h-3v-3h3Z",
    "data-name": "Path 1752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 116h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 116h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401 122h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396 122h4v-3h-4Zm3-1h-2v-2h2Z",
    "data-name": "Path 1756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 122h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388 122h3v-3h-3Zm3-1h-3v-2h3Z",
    "data-name": "Path 1758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 122h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 122h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 60h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 60h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1762"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 60h3v-3h-3Zm3 0h-3v-3h3Z",
    "data-name": "Path 1763"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 67h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 67h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1765"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 67h3v-3h-3Zm3-1h-3v-2h3Z",
    "data-name": "Path 1766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 73h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 73h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 73h3v-3h-3Zm3 0h-3v-2h3Z",
    "data-name": "Path 1769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 80h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 80h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 80h3v-3h-3Zm3 0h-3v-3h3Z",
    "data-name": "Path 1772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 87h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1773"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 87h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 87h3v-3h-3Zm3-1h-3v-2h3Z",
    "data-name": "Path 1775"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 93h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 93h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 93h3v-3h-3Zm3 0h-3v-2h3Z",
    "data-name": "Path 1778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 100h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1779"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 100h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 100h3v-3h-3Zm3 0h-3v-3h3Z",
    "data-name": "Path 1781"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 107h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 107h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1783"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 107h3v-3h-3Zm3-1h-3v-2h3Z",
    "data-name": "Path 1784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 113h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 113h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 73h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178 73h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 80h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178 80h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 87h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178 87h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 93h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178 93h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 100h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178 100h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 107h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178 107h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1798"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 113h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178 113h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 80h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1801"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252 80h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1802"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 87h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1803"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252 87h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1804"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 93h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1805"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252 93h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1806"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 100h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252 100h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 107h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1809"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252 107h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1810"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 113h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252 113h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247 80h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 80h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247 87h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 87h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247 93h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1817"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 93h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247 100h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1819"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 100h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1820"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247 107h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1821"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 107h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1822"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247 113h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 113h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1824"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314 60h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 60h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314 67h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 67h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314 73h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 73h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1830"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314 80h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 80h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314 87h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 87h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314 93h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 93h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314 100h3v-3h-3Zm2 0h-2v-3h2Z",
    "data-name": "Path 1837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 100h3v-3h-3Zm3 0h-2v-3h2Z",
    "data-name": "Path 1838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314 107h3v-3h-3Zm2-1h-2v-2h2Z",
    "data-name": "Path 1839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 107h3v-3h-3Zm3-1h-2v-2h2Z",
    "data-name": "Path 1840"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314 113h3v-3h-3Zm2 0h-2v-2h2Z",
    "data-name": "Path 1841"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 113h3v-3h-3Zm3 0h-2v-2h2Z",
    "data-name": "Path 1842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 113h3v-3h-3Zm3 0h-3v-2h3Z",
    "data-name": "Path 1843"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.5,
    cy: 5.3,
    fill: "#ecf0f1",
    "data-name": "Ellipse 32",
    rx: 53.5,
    ry: 5.3,
    transform: "translate(208 284)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m520 244-3 2-4-2-3 2-4-2-4 2v3h18Z",
    "data-name": "Path 62423",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#627680",
    "data-name": "freepik--City--inject-351",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M719 144V67h-21v38h-9V79h-15v40h-9V95h-7v25h-4V97h-6v23h-10v-4h-14V86h-23v30h-37V66h-27v22h-16V63h-24v58h-7V91h-22v15h-12v33h-14v-1h14v-32h12V91h23v30h5V62h26v26h15V66h27v50h36V86h24v30h15v3h9V96h6v23h4V95h7v23h8V79h16v26h8V66h22z",
    "data-name": "Path 1702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462 114h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1703"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 114h-4v-3h4Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1704"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 114h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475 114h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1706"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479 114h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 114h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1708"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503 94h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1709"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508 94h-4v-3h4Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1710"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 94h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516 94h-3v-3h3Zm-3 0h3v-2h-3Z",
    "data-name": "Path 1712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503 90h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508 90h-4v-3h4Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 90h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516 90h-3v-3h3Zm-3-1h3v-2h-3Z",
    "data-name": "Path 1716"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503 85h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508 85h-4v-3h4Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 85h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516 85h-3v-3h3Zm-3 0h3v-3h-3Z",
    "data-name": "Path 1720"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503 80h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1721"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508 80h-4v-3h4Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 80h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516 80h-3v-3h3Zm-3 0h3v-3h-3Z",
    "data-name": "Path 1724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503 75h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508 75h-4v-3h4Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 75h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516 75h-3v-3h3Zm-3 0h3v-2h-3Z",
    "data-name": "Path 1728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 94h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524 94h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503 100h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508 100h-4v-3h4Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1732"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 100h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516 100h-3v-3h3Zm-3-1h3v-2h-3Z",
    "data-name": "Path 1734"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 100h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524 100h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1736"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462 120h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 120h-4v-3h4Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 120h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475 120h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1740"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479 120h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1741"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 120h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462 125h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 125h-4v-3h4Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 125h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475 125h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479 125h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 125h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462 131h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 131h-4v-3h4Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1750"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 131h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475 131h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479 131h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 131h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462 136h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 136h-4v-3h4Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 136h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475 136h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479 136h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 136h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709 75h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713 75h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1762"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717 75h-3v-3h3Zm-3-1h3v-2h-3Z",
    "data-name": "Path 1763"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709 81h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713 81h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1765"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717 81h-3v-3h3Zm-3 0h3v-2h-3Z",
    "data-name": "Path 1766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709 88h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713 88h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717 88h-3v-3h3Zm-3 0h3v-3h-3Z",
    "data-name": "Path 1769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709 95h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713 95h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717 95h-3v-3h3Zm-3-1h3v-2h-3Z",
    "data-name": "Path 1772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709 101h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1773"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713 101h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717 101h-3v-3h3Zm-3 0h3v-2h-3Z",
    "data-name": "Path 1775"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709 108h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713 108h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717 108h-3v-3h3Zm-3 0h3v-3h-3Z",
    "data-name": "Path 1778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709 115h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1779"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713 115h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717 115h-3v-3h3Zm-3-1h3v-2h-3Z",
    "data-name": "Path 1781"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709 121h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713 121h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1783"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717 121h-3v-3h3Zm-3 0h3v-2h-3Z",
    "data-name": "Path 1784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709 128h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713 128h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681 88h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685 88h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681 95h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685 95h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681 101h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685 101h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681 108h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685 108h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681 115h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685 115h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681 121h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685 121h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1798"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681 128h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685 128h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606 95h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1801"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611 95h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1802"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606 101h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1803"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611 101h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1804"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606 108h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1805"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611 108h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1806"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606 115h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611 115h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606 121h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1809"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611 121h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1810"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606 128h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611 128h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616 95h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620 95h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616 101h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620 101h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616 108h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1817"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620 108h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616 115h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1819"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620 115h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1820"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616 121h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1821"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620 121h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1822"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616 128h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620 128h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1824"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549 75h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554 75h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549 81h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554 81h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549 88h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554 88h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1830"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549 95h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554 95h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549 101h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554 101h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549 108h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554 108h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549 115h-3v-3h3Zm-2-1h2v-2h-2Z",
    "data-name": "Path 1837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554 115h-3v-3h3Zm-3-1h2v-2h-2Z",
    "data-name": "Path 1838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549 121h-3v-3h3Zm-2 0h2v-2h-2Z",
    "data-name": "Path 1839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554 121h-3v-3h3Zm-3 0h2v-2h-2Z",
    "data-name": "Path 1840"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549 128h-3v-3h3Zm-2 0h2v-3h-2Z",
    "data-name": "Path 1841"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554 128h-3v-3h3Zm-3 0h2v-3h-2Z",
    "data-name": "Path 1842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717 128h-3v-3h3Zm-3 0h3v-3h-3Z",
    "data-name": "Path 1843"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 91"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 90",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "freepik--Trees--inject-2",
    transform: "translate(453 90)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M224 123c0-3-7 2-7 2l2-6c0-4-5 1-5 1s3-6 3-12-8 1-8 1l3-11c0-3-14 3-14 3l2-7q0-3-5 0-1-3-3-2v-1q0-2-6 3l-5-8q-3-2-7 3l-3 1v-1c-1-4-5 0-7 3l-3 1-4-9c-4-4-15 9-15 9s-6-9-9-4 1 14 1 14l-3-4-7 2s3-5 0-7-6 4-7 6l1-11c-2-7-8 2-8 2s1-9-4-10 3 0-3 8-3-5-11-5-6 26-6 26L55 95s-1-2-6-3-2 6-2 6-7-6-10-6l-6 7-1-1c-2-3-3 4-4 8v1q-1-4-5-5c-4 0-2 11-1 14q-1-5-4-6c-3-1-1 9-1 9l-3-1 1 9-5 8 19-9h103l-5 6h97s3-5 2-9",
    "data-name": "Path 2172"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M121 136q-3-7-7-12c-5-3-13 2-18 0s5-27-10-29-22 24-29 26-9-6-19-7c-9 0-25 18-29 22Z",
    "data-name": "Path 2174"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M121 136q-3-7-7-12c-5-3-13 2-18 0s5-27-10-29-22 24-29 26-9-6-19-7c-9 0-25 18-29 22Z",
    "data-name": "Path 2175",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M85 132h4l2-67 5-12-5 8 1-7 7-14-7 9-1-20-1 12-3-2 3 4-1 15-3-4 3 7Z",
    "data-name": "Path 2176"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8adaf",
    d: "M38 132h3l2-67 5-11-5 7 1-7 8-14-8 9V29l-1 12-4-2 3 4-1 15-3-4 3 7Z",
    "data-name": "Path 2177"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M140 132h3l2-52 5-8-5 5 1-5 8-10-8 6V53l-1 9-4-1 3 3-1 11-3-3 3 5Z",
    "data-name": "Path 2178"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M98 132h4l2-52 4-8-4 5v-5l8-10-7 6-1-15-1 9-4-1 4 3-1 11-3-3 2 5Z",
    "data-name": "Path 2179"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M125 132h4l2-52 5-8-5 5 1-5 7-10-7 6-1-15-1 9-3-1 3 3-1 11-3-3 2 5Z",
    "data-name": "Path 2180"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M204 132h4l2-67 4-11-5 7 1-7 8-14-8 9V29l-1 12-4-2 3 4-1 15-2-4 2 7Z",
    "data-name": "Path 2181"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8a9094",
    d: "M183 132h3l2-67 5-11-5 7 1-7 8-14-8 9-1-20-1 12-3-2 3 4-1 15-3-4 3 7Z",
    "data-name": "Path 2182"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M146 132h3l2-67 5-11-5 7 1-7 8-14-8 9V29l-1 12-4-2 3 4-1 15-3-4 3 7Z",
    "data-name": "Path 2183"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M199 136q-1-7-5-12c-4-3-12 2-16 0s5-27-9-29-18 24-24 26-9-6-17-7c-7 0-21 18-25 22Z",
    "data-name": "Path 2184"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M199 136q-1-7-5-12c-4-3-12 2-16 0s5-27-9-29-18 24-24 26-9-6-17-7c-7 0-21 18-25 22Z",
    "data-name": "Path 2185",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M138 31s-7 0-10 11 4 13-3 18-8 10-5 12 6 5 1 9-5 10 11 14 29-5 29-12-5-10-5-15 11-10 10-17-13-5-16-10-4-10-12-10",
    "data-name": "Path 2186"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M138 31s-7 0-10 11 4 13-3 18-8 10-5 12 6 5 1 9-5 10 11 14 29-5 29-12-5-10-5-15 11-10 10-17-13-5-16-10-4-10-12-10",
    "data-name": "Path 2187",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#92989b",
    d: "M133 134h2l4-66 4-10-4 7 1-6 6-11-6 7-1-16v10l-3-2 2 3v12l-3-3 2 5Z",
    "data-name": "Path 2188"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M90 136q1-7 4-11c3-3 9 2 12 0s-4-25 7-26 13 21 18 24 6-6 13-7c5 0 16 16 18 20Z",
    "data-name": "Path 2189"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M90 136q1-7 4-11c3-3 9 2 12 0s-4-25 7-26 13 21 18 24 6-6 13-7c5 0 16 16 18 20Z",
    "data-name": "Path 2190",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M129 136q-1-5-4-7c-3-3-8 1-11-1s3-17-6-18-12 15-16 17-6-4-12-5c-5 0-14 11-17 14Z",
    "data-name": "Path 2191"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M25 97s-7 1-18-8 10-38 19-45 25 36 18 43-12 10-19 10",
    "data-name": "Path 2192"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M25 97s-7 1-18-8 10-38 19-45 25 36 18 43-12 10-19 10",
    "data-name": "Path 2193",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m22 132 1-44-5-5 6 3v-8l-7-7 6 4v-5l2 2 1-15v24l13-6-13 9v49",
    "data-name": "Path 2194"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M205 61s-8 0-18-8 10-39 18-46 25 36 19 44-13 9-19 10",
    "data-name": "Path 2195"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8adaf",
    d: "m199 130 4-79-5-5 5 3v-8l-7-7 7 5-1-6 2 3 1-16 1 24 13-6-13 9v4l-3 80",
    "data-name": "Path 2196"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m42 135-1-2h-4l-1-4-4-4-8 1q-3 5-5 5-2-1-7 0l-4 4Z",
    "data-name": "Path 2197"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m42 135-1-2h-4l-1-4-4-4-8 1q-3 5-5 5-2-1-7 0l-4 4Z",
    "data-name": "Path 2198",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m11 135 3-3c2 0 3 3 6 1s5-8 9-8 5 5 4 6 3 2 4 2l3 2",
    "data-name": "Path 2199"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m15 135-1-1",
    "data-name": "Line 258"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m25 135 5-8",
    "data-name": "Line 259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m27 128 1 2 3-1",
    "data-name": "Path 2200"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m25 130 1 3 4-1",
    "data-name": "Path 2201"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m114 134-1-2h-4l-1-4a6 6 0 0 0-5-5 11 11 0 0 0-9 2q-3 4-5 5c-2 1-4-2-8-1l-4 5Z",
    "data-name": "Path 2202"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m114 134-1-2h-4l-1-4a6 6 0 0 0-5-5 11 11 0 0 0-9 2q-3 4-5 5c-2 1-4-2-8-1l-4 5Z",
    "data-name": "Path 2203",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m85 134-2-1",
    "data-name": "Line 260"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m96 134 5-8",
    "data-name": "Line 261"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m98 126 1 3 4-2",
    "data-name": "Path 2204"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m95 129 2 3 4-1",
    "data-name": "Path 2205"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M54 0S43 0 40 15s5 19-5 27-12 13-7 17 8 7 2 13-8 15 15 20 41-8 42-17-7-14-7-22 16-14 14-24-19-7-23-15S65 0 54 0",
    "data-name": "Path 2206"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M159 9s-11 0-14 16 6 19-4 27-11 13-6 17 8 7 2 13-7 15 17 19 40-9 41-18-8-14-8-22 15-15 12-25-18-5-23-13-6-14-17-14",
    "data-name": "Path 2209"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 89",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M159 9s-11 0-14 16 6 19-4 27-11 13-6 17 8 7 2 13-7 15 17 19 40-9 41-18-8-14-8-22 15-15 12-25-18-5-23-13-6-14-17-14",
    "data-name": "Path 2210"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M156 139h2l2-47 3-9-3 6v-5l5-10-5 6-1-14v9l-3-1 2 2v10l-2-2 2 5Z",
    "data-name": "Path 2211"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M227 136q-1-7-5-10c-4-3-10 2-14 0s4-22-7-24-17 20-22 22-8-5-15-6c-6 0-19 14-22 18Z",
    "data-name": "Path 2212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M95 137q1-5-2-9c-5-4-11 2-12 2s-2-4-7-7-10 1-13 0 2-14-7-14-11 18-18 18-7-4-13-1q-7 6-8 11Z",
    "data-name": "Path 2213"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M95 137q1-5-2-9c-5-4-11 2-12 2s-2-4-7-7-10 1-13 0 2-14-7-14-11 18-18 18-7-4-13-1q-7 6-8 11Z",
    "data-name": "Path 2214",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m31 136-5-7",
    "data-name": "Line 262"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m51 136 3-22",
    "data-name": "Line 263"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m67 136 2-8",
    "data-name": "Line 264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m86 136 3-6",
    "data-name": "Line 265"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m32 129-3 4-6-2",
    "data-name": "Path 2215"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m49 116 4 4 4-4",
    "data-name": "Path 2216"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m48 123 4 5 4-3",
    "data-name": "Path 2217"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m68 131 6-2",
    "data-name": "Line 266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m68 133-3-6",
    "data-name": "Line 267"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m87 133-1-4",
    "data-name": "Line 268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m87 134 4-1",
    "data-name": "Line 269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m114 29-6-8a20 20 0 0 0-15-4c-11 1-14 12-18 20-7 17-16 42 12 50 12 3 28 0 33-11q5-15 2-29z",
    "data-name": "Path 2218"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M91 148h5l3-86 6-15-6 10V47l10-17-9 11-1-26-1 16-5-2 4 5-1 19-4-5 3 8Z",
    "data-name": "Path 2219"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M97 101v-3l-1 1z",
    "data-name": "Path 2220"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m96 75 2 1v-2z",
    "data-name": "Path 2221"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m96 85 2 2v-3z",
    "data-name": "Path 2222"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m97 61-1-1v3z",
    "data-name": "Path 2223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m94 135 2 1v-2z",
    "data-name": "Path 2224"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M96 53v2l2-1z",
    "data-name": "Path 2225"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m97 46 2 2v-3z",
    "data-name": "Path 2226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M96 120q-1-3-3-1v4z",
    "data-name": "Path 2227"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M96 124s-2 0-2 1l2 2z",
    "data-name": "Path 2228"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m95 107 2 2v-4q-2-1-2 2",
    "data-name": "Path 2229"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M93 103v2l2-2z",
    "data-name": "Path 2230"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M94 79v2l1-1z",
    "data-name": "Path 2231"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M95 115h-2v2z",
    "data-name": "Path 2232"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m182 46-2-1v3z",
    "data-name": "Path 2236"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m179 85-1 3 3-2z",
    "data-name": "Path 2237"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M182 18v3l2-2z",
    "data-name": "Path 2238"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m181 55 2-3-3-1v6z",
    "data-name": "Path 2239"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M185 11V8a1 1 0 0 0-2 2z",
    "data-name": "Path 2240"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M181 32v-1l3-2-2-1v2l-2-1Z",
    "data-name": "Path 2241"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m183 25 1 1 1-1v-2z",
    "data-name": "Path 2242"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m178 105 3-3h-3Z",
    "data-name": "Path 2243"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m181 81 1 1v-2z",
    "data-name": "Path 2244"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m183 58-3 1 2 2v1l1 1Z",
    "data-name": "Path 2245"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m182 48 2 1v-2a1 1 0 0 0-2 1",
    "data-name": "Path 2246"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M184 33zq-2 0-3 3l3 3z",
    "data-name": "Path 2247"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m180 91 2 2v-5a2 2 0 0 0-2 3",
    "data-name": "Path 2248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M181 110v-3h-3l-1 5z",
    "data-name": "Path 2249"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M180 127a1 1 0 0 0-1 2l1 1Z",
    "data-name": "Path 2250"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m179 116 2 1v-3z",
    "data-name": "Path 2251"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M55 42a22 22 0 0 0-14 11c-4 9 3 15 0 24s-14 13-5 20 21-4 27-3 7 10 23 6 12-16 5-21-1-15-5-27c-4-9-19-14-31-10",
    "data-name": "Path 2252"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55 42a22 22 0 0 0-14 11c-4 9 3 15 0 24s-14 13-5 20 21-4 27-3 7 10 23 6 12-16 5-21-1-15-5-27c-4-9-19-14-31-10",
    "data-name": "Path 2253",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m58 154 3-81-23-14 24 11V58l-5-6 5 4 2-15 1 23 16-8-16 12v14l13-4-13 8-2 67Z",
    "data-name": "Path 2254"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M62 127v2l2-1q1-1-2-1",
    "data-name": "Path 2256"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M63 108v2l2-1z",
    "data-name": "Path 2257"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m63 118 2-2-2-1v1Z",
    "data-name": "Path 2258"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M64 77v1l2-1z",
    "data-name": "Path 2259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M65 113h1l1-2z",
    "data-name": "Path 2261"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M65 106h2v-3q-4 2-2 3",
    "data-name": "Path 2262"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M65 121h1v-2q-3 0-1 2",
    "data-name": "Path 2263"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M66 127v-2q-2 0-2 2z",
    "data-name": "Path 2264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M63 99v2l2-1q1-1-2-1",
    "data-name": "Path 2265"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m114 148-2-2h-3l-1-4a6 6 0 0 0-5-5 11 11 0 0 0-9 2c-4 2-3 5-6 5s-3-2-7-1l-5 5Z",
    "data-name": "Path 2266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m114 148-2-2h-3l-1-4a6 6 0 0 0-5-5 11 11 0 0 0-9 2c-4 2-3 5-6 5s-3-2-7-1l-5 5Z",
    "data-name": "Path 2267",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m85 148-2-1",
    "data-name": "Line 270"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m95 148 5-8",
    "data-name": "Line 271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M98 140v3l4-2",
    "data-name": "Path 2268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m95 143 2 3 3-1",
    "data-name": "Path 2269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m84 154-4-5-8-1c-2 0-2-6-2-7q-1-10-11-12-11-2-19 4c-9 6-8 12-13 12s-8-5-17-2q-9 4-10 11Z",
    "data-name": "Path 2270"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m19 154-4-3",
    "data-name": "Line 272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m42 154 11-18",
    "data-name": "Line 273"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m70 153 3-1",
    "data-name": "Line 274"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m48 137 1 6 8-4",
    "data-name": "Path 2271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m41 143 4 7 9-2",
    "data-name": "Path 2272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18 150v3h-4",
    "data-name": "Path 2273"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M71 153v-2",
    "data-name": "Line 275"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 33",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(47 136)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M54 136zh-1z",
    "data-name": "Path 2274"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 34",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(57 138)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M54 147z",
    "data-name": "Path 2275"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 35",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(40 143)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 36",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(70 151)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M74 152zv-1z",
    "data-name": "Path 2276"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 37",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(18 149)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M15 150a1 1 0 1 1-1 0z",
    "data-name": "Path 2277"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 38",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(13 152)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M192 98s-9 0-21-10 12-46 22-54 29 43 22 52-15 11-23 12",
    "data-name": "Path 2280"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m188 139 2-53-6-5 6 3v-9l-8-9 8 5-1-6 2 3 2-19 1 29 15-7-15 11v58",
    "data-name": "Path 2281"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M192 116q0-1-3-1v3z",
    "data-name": "Path 2282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m194 95-3 1 3 1Z",
    "data-name": "Path 2283"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M192 102q0-1-2-1v2z",
    "data-name": "Path 2284"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m192 91-2-1v2z",
    "data-name": "Path 2285"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M189 127v3l3-2c1-1-3-1-3-1",
    "data-name": "Path 2286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m190 110 4 1v-3q-4 0-4 2",
    "data-name": "Path 2287"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M191 86h3v-2q-3 0-3 2",
    "data-name": "Path 2288"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m188 71-2 1 2 1Z",
    "data-name": "Path 2289"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m194 120-4 2 4 1Z",
    "data-name": "Path 2290"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M191 77v2l2-1z",
    "data-name": "Path 2291"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M222 139q1-5-6-6h-10q-2-2-3-7l-2-6a8 8 0 0 0-8-2c-5 2-5 9-11 10q-5 0-11-1-6 3-10 7l-4 3-4 2Z",
    "data-name": "Path 2292"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M222 139q1-5-6-6h-10q-2-2-3-7l-2-6a8 8 0 0 0-8-2c-5 2-5 9-11 10q-5 0-11-1-6 3-10 7l-4 3-4 2Z",
    "data-name": "Path 2293",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m179 139-2-7",
    "data-name": "Line 276"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m190 139 6-14",
    "data-name": "Line 277"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m212 139 3-3",
    "data-name": "Line 278"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m179 137 2-4",
    "data-name": "Line 279"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m178 136-6-1",
    "data-name": "Line 280"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m190 129-2-2",
    "data-name": "Line 281"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m188 133 7-3",
    "data-name": "Line 282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m190 138 6-2",
    "data-name": "Line 283"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m191 136-4-6",
    "data-name": "Line 284"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M192 125z",
    "data-name": "Path 2294"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M192 127a1 1 0 1 1 0-1z",
    "data-name": "Path 2295"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 39",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(198 130)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 40",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(187 130)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 41",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(196 136)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 42",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(214 136)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M177 132z",
    "data-name": "Path 2296"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 43",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(180 132)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 44",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(171 134)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m239 146-2-2-4-1q-2-1-1-4a7 7 0 0 0-7-7 13 13 0 0 0-10 2c-5 4-4 7-7 7s-4-2-10-1l-5 6Z",
    "data-name": "Path 2297"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m203 146-2-2",
    "data-name": "Line 285"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m217 146 5-10",
    "data-name": "Line 286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m219 137 1 3 5-2",
    "data-name": "Path 2298"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m216 140 2 4 5-1",
    "data-name": "Path 2299"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "freepik--Trees--inject-2",
    transform: "translate(0 71)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M16 141c0-3 7 2 7 2l-2-6c0-3 5 1 5 1s-3-6-3-11 8 0 8 0l-4-11c-1-3 14 3 14 3l-2-7q0-2 5 0 1-3 3-1v-2q0-2 6 3l4-8q4-2 7 4h4v-1c0-4 4 0 6 3l3 1 4-8c4-5 14 8 14 8s6-9 9-4-1 14-1 14l3-4 7 3s-3-6 0-8 6 4 7 6l-1-11c1-7 7 2 7 2s-1-8 4-10-2 0 3 9 3-6 11-5 6 25 6 25l30-15s1-2 6-3 2 6 2 6 6-6 9-6l6 8 1-2c2-3 3 5 4 8v1q1-4 5-5c3 0 2 11 1 14q1-4 4-6c3-1 0 9 0 9l4-1-1 9 5 8-19-9H107l5 6H18s-3-5-2-9",
    "data-name": "Path 2172"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M106 154q2-7 7-11c5-4 14 2 19-1s-6-27 11-28 23 23 30 26 10-7 21-7c9-1 26 17 30 21Z",
    "data-name": "Path 2174"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M106 154q2-7 7-11c5-4 14 2 19-1s-6-27 11-28 23 23 30 26 10-7 21-7c9-1 26 17 30 21Z",
    "data-name": "Path 2175",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M151 150h-4l-2-67-5-11 5 7-1-7-8-13 8 8V47l1 12 4-2-3 4 1 15 3-4-3 7Z",
    "data-name": "Path 2176"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8adaf",
    d: "M197 150h-4l-2-67-5-11 5 7v-7l-9-13 8 8 1-20 1 12 4-2-3 4v15l4-4-3 7Z",
    "data-name": "Path 2177"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M98 150h-4l-2-51-5-9 5 6-1-6-8-10 8 6 1-15 1 9 4-1-4 3 1 11 3-3-2 5Z",
    "data-name": "Path 2178"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M138 150h-3l-3-51-5-9 6 6-1-6-8-10 7 6 1-15 1 9 4-1-3 3 1 11 3-3-3 5Z",
    "data-name": "Path 2179"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M112 150h-4l-2-51-5-9 5 6-1-6-8-10 8 6 1-15 1 9 4-1-4 3 1 11 3-3-2 5Z",
    "data-name": "Path 2180"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M37 150h-3l-3-67-5-11 6 7-1-7-8-13 7 8 1-20 1 12 4-2-3 4 1 15 3-4-3 7Z",
    "data-name": "Path 2181"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8a9094",
    d: "M56 150h-4l-2-67-5-11 5 7v-7l-9-13 8 8 1-20 1 12 4-2-3 4 1 15 3-4-3 7Z",
    "data-name": "Path 2182"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M92 150h-4l-2-67-5-11 5 7v-7l-9-13 8 8 1-20 1 12 4-2-4 4 1 15 3-4-2 7Z",
    "data-name": "Path 2183"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m37 154 5-11c5-4 13 2 17-1s-5-27 9-28 20 23 26 26 9-7 18-7c8-1 23 17 27 21Z",
    "data-name": "Path 2184"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m37 154 5-11c5-4 13 2 17-1s-5-27 9-28 20 23 26 26 9-7 18-7c8-1 23 17 27 21Z",
    "data-name": "Path 2185",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M99 49s9 0 11 11-4 13 4 18 8 10 5 12-6 5-1 9 5 10-12 14-30-5-31-11 5-11 6-16-12-10-11-17 14-4 17-10 4-10 12-10",
    "data-name": "Path 2186"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M99 49s9 0 11 11-4 13 4 18 8 10 5 12-6 5-1 9 5 10-12 14-30-5-31-11 5-11 6-16-12-10-11-17 14-4 17-10 4-10 12-10",
    "data-name": "Path 2187",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#92989b",
    d: "M105 152h-3l-4-66-4-9 4 6-1-6-6-11 6 7 1-16v10l3-2-2 4v11l3-3-2 5Z",
    "data-name": "Path 2188"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M149 154q-1-7-4-11c-4-3-10 2-13 0s4-25-7-26-15 21-19 24-7-6-14-7c-6 0-17 16-20 20Z",
    "data-name": "Path 2189"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M149 154q-1-7-4-11c-4-3-10 2-13 0s4-25-7-26-15 21-19 24-7-6-14-7c-6 0-17 16-20 20Z",
    "data-name": "Path 2190",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M105 154q0-5 4-7c3-2 8 1 11-1s-3-17 6-18 13 15 18 17 6-4 12-5c5 0 15 11 18 14Z",
    "data-name": "Path 2191"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M207 115s8 1 19-7-11-39-19-46-27 36-20 44 13 9 20 9",
    "data-name": "Path 2192"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M207 115s8 1 19-7-11-39-19-46-27 36-20 44 13 9 20 9",
    "data-name": "Path 2193",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m210 150-1-44 5-5-5 3v-8l7-7-7 4 1-5-2 2-1-15-1 24-14-6 14 9v49",
    "data-name": "Path 2194"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M37 79s7 0 19-8-11-39-20-46-26 36-20 44 14 9 21 10",
    "data-name": "Path 2195"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m189 153 2-2h3l1-4 5-4 8 1q5 5 6 5 1-1 7 0l5 4Z",
    "data-name": "Path 2197"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m189 153 2-2h3l1-4 5-4 8 1q5 5 6 5 1-1 7 0l5 4Z",
    "data-name": "Path 2198",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m222 153-3-2c-2-1-3 2-7 0s-5-8-9-8-5 5-5 7-2 1-4 1l-3 2",
    "data-name": "Path 2199"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m218 153 1-1",
    "data-name": "Line 258"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m207 153-5-7",
    "data-name": "Line 259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m205 146-1 3-3-2",
    "data-name": "Path 2200"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m208 149-2 2-4-1",
    "data-name": "Path 2201"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m120 152 2-2h4l1-4a6 6 0 0 1 5-5l9 2q5 5 6 5 2-1 8-1l5 5Z",
    "data-name": "Path 2202"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m120 152 2-2h4l1-4a6 6 0 0 1 5-5l9 2q5 5 6 5 2-1 8-1l5 5Z",
    "data-name": "Path 2203",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m151 152 1-1",
    "data-name": "Line 260"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m140 152-5-8",
    "data-name": "Line 261"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m138 145-1 2-4-2",
    "data-name": "Path 2204"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m141 147-2 3-4-1",
    "data-name": "Path 2205"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M165 64s9 0 11 7-3 10 4 14 10 7 6 9-7 4-2 7 6 7-12 10-32-4-33-9 6-7 6-11-12-8-11-13 15-3 19-7 4-7 12-7",
    "data-name": "Path 2207",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M81 27s11 0 14 16-6 19 4 27 12 13 7 17-9 7-2 13 7 15-18 19-43-9-44-18 8-14 9-22-16-14-13-25 20-5 25-13 6-14 18-14",
    "data-name": "Path 2209"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 89",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M81 27s11 0 14 16-6 19 4 27 12 13 7 17-9 7-2 13 7 15-18 19-43-9-44-18 8-14 9-22-16-14-13-25 20-5 25-13 6-14 18-14",
    "data-name": "Path 2210"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M85 157h-3l-2-59-4-10 4 7v-7l-7-11 7 7 1-17v10l4-1-3 3v13l3-3-3 5Z",
    "data-name": "Path 2211"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M13 154q2-6 5-9c4-3 11 1 15-1s-5-22 8-24 17 20 23 22 8-5 16-6c6 0 20 14 23 18Z",
    "data-name": "Path 2212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M133 155q-1-5 3-9c4-4 11 2 12 2s2-4 7-7 11 1 15 0-3-14 6-14 13 18 19 18 8-4 14-1q8 6 9 11Z",
    "data-name": "Path 2213"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M133 155q-1-5 3-9c4-4 11 2 12 2s2-4 7-7 11 1 15 0-3-14 6-14 13 18 19 18 8-4 14-1q8 6 9 11Z",
    "data-name": "Path 2214",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m201 154 5-7",
    "data-name": "Line 262"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m184 154-3-22",
    "data-name": "Line 263"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m169 154-3-8",
    "data-name": "Line 264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m150 155-3-6",
    "data-name": "Line 265"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m200 147 3 4 7-2",
    "data-name": "Path 2215"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m186 134-4 5-4-5",
    "data-name": "Path 2216"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m187 141-4 5-4-3",
    "data-name": "Path 2217"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m167 149-6-2",
    "data-name": "Line 266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m167 151 3-6",
    "data-name": "Line 267"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m148 151 2-3",
    "data-name": "Line 268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m149 152-4-1",
    "data-name": "Line 269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m120 47 7-8a23 23 0 0 1 16-4c12 1 15 13 18 20 8 17 18 42-12 50-12 3-30 0-35-11q-7-15-2-29z",
    "data-name": "Path 2218"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M145 166h-4l-3-76-6-13 6 9-1-9-9-15 9 10 1-23 1 14 5-2-4 5 1 16 3-4-3 7Z",
    "data-name": "Path 2219"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M139 119v-3l1 1z",
    "data-name": "Path 2220"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m140 93-2 1v-2z",
    "data-name": "Path 2221"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m140 103-2 2v-3z",
    "data-name": "Path 2222"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M139 79q0-1 1-1v3z",
    "data-name": "Path 2223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m142 153-2 1v-2z",
    "data-name": "Path 2224"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M140 71v2l-2-1z",
    "data-name": "Path 2225"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m139 65-2 1v-2z",
    "data-name": "Path 2226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m140 138 3-1v4z",
    "data-name": "Path 2227"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M140 142s2 0 2 1l-2 2z",
    "data-name": "Path 2228"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m141 125-2 2v-4z",
    "data-name": "Path 2229"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m142 121 1 2-2-1z",
    "data-name": "Path 2230"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m141 98 1 2z",
    "data-name": "Path 2231"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m141 134 2-1v2z",
    "data-name": "Path 2232"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m41 12 8-7a23 23 0 0 1 16-5c11 1 14 13 18 20 8 17 18 43-12 50-13 4-30 0-36-10q-6-15-1-30z",
    "data-name": "Path 2233"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m41 12 8-7a23 23 0 0 1 16-5c11 1 14 13 18 20 8 17 18 43-12 50-13 4-30 0-36-10q-6-15-1-30z",
    "data-name": "Path 2234",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M56 64h1l1 2z",
    "data-name": "Path 2236"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m59 104 1 3-3-3z",
    "data-name": "Path 2237"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M56 36v3l-2-2q0-1 2-1",
    "data-name": "Path 2238"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m57 73-2-3 3-1v6z",
    "data-name": "Path 2239"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M53 29v-3a1 1 0 0 1 2 2z",
    "data-name": "Path 2240"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M57 50v-1l-3-2 2-1v2l2-1Z",
    "data-name": "Path 2241"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m56 43-3 1v-3z",
    "data-name": "Path 2242"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m60 123-3-2q1-2 3-1Z",
    "data-name": "Path 2243"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M56 99v1-2z",
    "data-name": "Path 2244"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M55 76q2 0 3 2l-2 1v1l-1 1Z",
    "data-name": "Path 2245"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m56 66-2 1v-2a1 1 0 0 1 2 1",
    "data-name": "Path 2246"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M54 51zq2 1 3 3l-3 3z",
    "data-name": "Path 2247"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m58 109-2 2v-4z",
    "data-name": "Path 2248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M57 128v-3h3l1 5z",
    "data-name": "Path 2249"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M57 145a1 1 0 0 1 2 2l-1 1Z",
    "data-name": "Path 2250"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m59 134-2 1v-3z",
    "data-name": "Path 2251"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M176 60a24 24 0 0 1 14 11c5 9-3 16 1 24s15 13 5 20-22-4-29-3-7 10-25 6-12-16-5-21 1-15 6-27c4-9 20-14 33-10",
    "data-name": "Path 2252"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M176 60a24 24 0 0 1 14 11c5 9-3 16 1 24s15 13 5 20-22-4-29-3-7 10-25 6-12-16-5-21 1-15 6-27c4-9 20-14 33-10",
    "data-name": "Path 2253",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m173 172-3-70 21-11-21 9V90l4-6-5 4-1-13-1 20-15-7 14 10 1 13-12-4 12 6 2 59Z",
    "data-name": "Path 2254"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M173 145v2l-2-1q0-1 2-1",
    "data-name": "Path 2256"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M172 126v2l-2-1z",
    "data-name": "Path 2257"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m173 136-3-2h2Z",
    "data-name": "Path 2258"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M171 95v1l-2-1z",
    "data-name": "Path 2259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M170 131h-1v-2z",
    "data-name": "Path 2261"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m170 124-2 1v-4q4 2 2 3",
    "data-name": "Path 2262"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M171 139h-2v-2q3 0 2 2",
    "data-name": "Path 2263"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M169 145v-2q3 0 2 2z",
    "data-name": "Path 2264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M172 117v2l-2-1z",
    "data-name": "Path 2265"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m121 166 1-2h4l1-4a6 6 0 0 1 5-5 12 12 0 0 1 10 2c4 3 3 5 6 5s4-2 8-1l5 5Z",
    "data-name": "Path 2266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m121 166 1-2h4l1-4a6 6 0 0 1 5-5 12 12 0 0 1 10 2c4 3 3 5 6 5s4-2 8-1l5 5Z",
    "data-name": "Path 2267",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m151 166 2-1",
    "data-name": "Line 270"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m141 166-5-8",
    "data-name": "Line 271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M138 159v2l-4-2",
    "data-name": "Path 2268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m142 161-3 3-4-1",
    "data-name": "Path 2269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m145 172 4-4c4-2 4 0 8-1 3-1 2-7 3-8q0-10 11-12 12-3 21 4c9 6 8 12 13 12s9-5 18-1q9 4 11 10Z",
    "data-name": "Path 2270"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m214 172 4-3",
    "data-name": "Line 272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m192 172-11-18",
    "data-name": "Line 273"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m165 172-3-2",
    "data-name": "Line 274"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m187 155-1 6-9-4",
    "data-name": "Path 2271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m194 161-5 7-9-2",
    "data-name": "Path 2272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m214 168 1 3h4",
    "data-name": "Path 2273"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m164 171 1-2",
    "data-name": "Line 275"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 33",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(187 155)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M181 154z",
    "data-name": "Path 2274"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 34",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(177 156)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M180 166zh1v-1h-1z",
    "data-name": "Path 2275"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 35",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(190 161)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 36",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(164 169)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M161 170zl1-1z",
    "data-name": "Path 2276"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 37",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(214 168)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M218 169a1 1 0 1 0 1-1z",
    "data-name": "Path 2277"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 38",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(219 170)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M50 116s9 1 22-10-12-46-23-54-31 43-23 52 16 11 24 12",
    "data-name": "Path 2280"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m24 157-1-53 6-5-7 3v-9l9-8-8 5 1-7-3 3-1-19-1 29-16-7 16 11v58",
    "data-name": "Path 2281"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M46 134q0-1 3-1v3z",
    "data-name": "Path 2282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m44 113 4 2h-4Z",
    "data-name": "Path 2283"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M46 120q0-1 2-1l1 2z",
    "data-name": "Path 2284"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m46 109 2-1v2z",
    "data-name": "Path 2285"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M49 146zv1l-3-2z",
    "data-name": "Path 2286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m48 128-4 1v-3q4 0 4 2",
    "data-name": "Path 2287"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M48 104h-4v-2c1 0 5 1 4 2",
    "data-name": "Path 2288"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m50 89 2 1-2 1Z",
    "data-name": "Path 2289"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M44 138q4 1 4 2l-4 1Z",
    "data-name": "Path 2290"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M48 95v2l-3-1z",
    "data-name": "Path 2291"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M18 157q-1-5 7-6 5 2 10 0 4-2 3-6l3-7a9 9 0 0 1 8-2c5 2 6 9 11 10q6 0 12-1 6 3 11 7l4 3 5 2Z",
    "data-name": "Path 2292"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 157q-1-5 7-6 5 2 10 0 4-2 3-6l3-7a9 9 0 0 1 8-2c5 2 6 9 11 10q6 0 12-1 6 3 11 7l4 3 5 2Z",
    "data-name": "Path 2293",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m58 157 3-7",
    "data-name": "Line 276"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m49 157-7-14",
    "data-name": "Line 277"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m29 157-4-3",
    "data-name": "Line 278"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m59 155-2-4",
    "data-name": "Line 279"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m59 154 7-1",
    "data-name": "Line 280"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m48 148 2-3",
    "data-name": "Line 281"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m50 151-7-3",
    "data-name": "Line 282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m48 156-6-2",
    "data-name": "Line 283"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m47 154 4-5",
    "data-name": "Line 284"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M46 143z",
    "data-name": "Path 2294"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M46 145",
    "data-name": "Path 2295"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 39",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(43 148)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 40",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(50 148)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 41",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(45 154)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 42",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(25 154)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M61 150z",
    "data-name": "Path 2296"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 43",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(57 151)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.5,
    fill: "#263238",
    "data-name": "Ellipse 44",
    rx: 0.6,
    ry: 0.5,
    transform: "translate(65 152)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m0 164 2-2 5-1 1-4q1-5 7-7a14 14 0 0 1 11 3c5 3 4 6 7 6s5-2 10-1l6 6Z",
    "data-name": "Path 2297"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m38 164 2-2",
    "data-name": "Line 285"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m24 164-6-10",
    "data-name": "Line 286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m21 155-1 3-5-2",
    "data-name": "Path 2298"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m25 158-3 4-5-1",
    "data-name": "Path 2299"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "freepik--Trees--inject-2",
    transform: "translate(243 105)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M12 114c0-3 6 1 6 1l-1-5c0-3 3 1 3 1l-2-9c0-5 6 0 6 0l-2-9c0-2 10 3 10 3l-1-6q1-2 4 0 1-3 3-1v-1q0-2 5 2l3-6q3-2 6 2l2 1 1-1q1-3 5 3h2l4-7c3-3 11 7 11 7s5-7 7-3-1 11-1 11l3-3 6 2s-2-5 0-6c2-2 5 4 5 5v-9c1-6 6 1 6 1s-1-6 3-7-2 0 2 6 3-4 9-4 5 21 5 21l25-12s1-2 5-3 1 5 1 5 6-4 8-4l5 5v-1c2-2 3 4 4 7v1q0-4 4-5c3 0 1 9 1 12q0-4 3-5c2-1 0 7 0 7l3-1-1 7 4 7-15-7H87l4 4H13z",
    "data-name": "Path 2172"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M94 124q1-7 5-9c4-3 11 1 14-1s-4-22 9-23 17 19 22 21 8-5 16-5c7-1 20 13 23 17Z",
    "data-name": "Path 2174"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M94 124q1-7 5-9c4-3 11 1 14-1s-4-22 9-23 17 19 22 21 8-5 16-5c7-1 20 13 23 17Z",
    "data-name": "Path 2175",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M122 120h-2l-2-53-4-9 4 6-1-6-6-11 6 7 1-16v10l3-2-2 3 1 12 2-3-2 5Z",
    "data-name": "Path 2176"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8adaf",
    d: "M161 120h-3l-2-53-4-9 4 6v-6l-7-11 6 7 1-16 1 10 3-2-3 3 1 12 2-3-2 5Z",
    "data-name": "Path 2177"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M79 120h-3l-1-41-4-7 4 5-1-5-6-8 6 5 1-12v7l3-1-2 3v9l3-3-2 5Z",
    "data-name": "Path 2178"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M112 120h-2l-2-41-4-7 4 5-1-5-6-8 6 5 1-12v7l3-1-2 3 1 9 2-3-2 5Z",
    "data-name": "Path 2179"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cacb",
    d: "M91 120h-3l-2-41-4-7 4 5v-5l-6-8 5 5 1-12 1 7 3-1-3 3 1 9 2-3-2 5Z",
    "data-name": "Path 2180"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M28 120h-3l-1-53-4-9 4 6-1-6-6-11 6 7 1-16v10l3-2-2 3v12l3-3-2 5Z",
    "data-name": "Path 2181"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8a9094",
    d: "M45 120h-3l-1-53-4-9 4 6-1-6-6-11 6 7V38l1 10 3-2-2 3v12l3-3-2 5Z",
    "data-name": "Path 2182"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M75 120h-3l-2-53-4-9 4 6v-6l-7-11 6 7 1-16 1 10 3-2-3 3 1 12 2-3-2 5Z",
    "data-name": "Path 2183"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M31 124q2-7 5-9c3-3 9 1 12-1s-3-22 8-23 14 19 19 21 7-5 14-5c6-1 17 13 20 17Z",
    "data-name": "Path 2184"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M31 124q2-7 5-9c3-3 9 1 12-1s-3-22 8-23 14 19 19 21 7-5 14-5c6-1 17 13 20 17Z",
    "data-name": "Path 2185",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M80 39s7 0 8 9-2 11 3 15 7 7 4 9-4 5-1 8 4 8-9 11-22-4-23-9 4-9 4-13-9-8-8-14 11-3 13-7 3-9 9-9",
    "data-name": "Path 2186"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M80 39s7 0 8 9-2 11 3 15 7 7 4 9-4 5-1 8 4 8-9 11-22-4-23-9 4-9 4-13-9-8-8-14 11-3 13-7 3-9 9-9",
    "data-name": "Path 2187",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#92989b",
    d: "M85 122h-2l-4-53-2-7 3 4-1-4-5-9 5 6V46l1 8 2-2-2 3 1 9 2-2-2 4Z",
    "data-name": "Path 2188"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m119 124-3-9c-3-2-7 2-10 0s3-20-5-21-11 17-15 19-5-5-10-5c-4 0-13 13-15 16Z",
    "data-name": "Path 2189"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m119 124-3-9c-3-2-7 2-10 0s3-20-5-21-11 17-15 19-5-5-10-5c-4 0-13 13-15 16Z",
    "data-name": "Path 2190",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M88 124q0-4 3-6c2-2 6 1 8 0s-2-14 5-15 10 12 13 13 5-3 10-3c4 0 11 9 13 11Z",
    "data-name": "Path 2191"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M170 93s6 0 15-7-9-31-15-36-20 28-15 35 10 7 15 8",
    "data-name": "Path 2192"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M170 93s6 0 15-7-9-31-15-36-20 28-15 35 10 7 15 8",
    "data-name": "Path 2193",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m173 120-1-35 4-4-5 2v-6l6-5-5 3v-4l-1 2-1-13-1 19-10-4 10 7v40",
    "data-name": "Path 2194"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M28 63s6 1 14-6-8-31-15-37S7 49 12 55s11 8 16 8",
    "data-name": "Path 2195"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8adaf",
    d: "m33 119-4-63 4-4-4 2v-6l6-6-6 3 1-4-2 2-1-13v20l-11-5 11 7v4l2 64",
    "data-name": "Path 2196"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m157 123 1-2h2l1-3 4-3 6 1 4 4q2-1 6-1l3 4Z",
    "data-name": "Path 2197"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m157 123 1-2h2l1-3 4-3 6 1 4 4q2-1 6-1l3 4Z",
    "data-name": "Path 2198",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m181 123-2-2q-1 1-5 0c-4-1-3-6-7-6s-4 4-3 5-2 2-3 1-3 1-3 2",
    "data-name": "Path 2199"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m178 123 1-1",
    "data-name": "Line 258"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m170 123-3-6",
    "data-name": "Line 259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m169 117-1 2-3-1",
    "data-name": "Path 2200"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m171 119-2 3-2-1",
    "data-name": "Path 2201"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m99 122 2-1 2-1 1-3 4-4 7 2q3 4 5 4 2-1 6-1l4 4Z",
    "data-name": "Path 2202"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m99 122 2-1 2-1 1-3 4-4 7 2q3 4 5 4 2-1 6-1l4 4Z",
    "data-name": "Path 2203",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m123 122 1-1",
    "data-name": "Line 260"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m114 122-4-6",
    "data-name": "Line 261"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M112 116v2l-3-1",
    "data-name": "Path 2204"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m115 118-2 3-3-1",
    "data-name": "Path 2205"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M147 15s9 0 11 12-4 15 5 21 9 11 5 14-7 6-1 11 6 11-13 16-33-7-34-14 6-12 6-18-12-11-11-20 15-5 19-11 4-11 13-11",
    "data-name": "Path 2206"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M147 15s9 0 11 12-4 15 5 21 9 11 5 14-7 6-1 11 6 11-13 16-33-7-34-14 6-12 6-18-12-11-11-20 15-5 19-11 4-11 13-11",
    "data-name": "Path 2207",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M154 133h-3l-5-76-4-11 4 7v-7l-7-12 7 8V24l1 11 3-2-3 4 1 13 3-3-2 6Z",
    "data-name": "Path 2208"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M64 22s9 0 11 12-4 16 3 22 9 11 5 14-6 6-1 10 5 12-14 16-32-7-33-14 6-12 7-18-12-12-10-20 15-5 19-11 4-11 13-11",
    "data-name": "Path 2209"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 89",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64 22s9 0 11 12-4 16 3 22 9 11 5 14-6 6-1 10 5 12-14 16-32-7-33-14 6-12 7-18-12-12-10-20 15-5 19-11 4-11 13-11",
    "data-name": "Path 2210"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M67 126h-4l-2-62-4-11 4 7v-6l-7-13 7 8 1-18 1 11 3-1-3 3v13l3-3-2 6Z",
    "data-name": "Path 2211"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M10 124q1-5 4-8c3-2 8 1 11 0s-4-18 6-19 13 15 17 17 6-4 12-5c6 0 16 12 18 15Z",
    "data-name": "Path 2212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M114 125q-1-4 2-8c3-3 8 2 10 2s1-3 5-5 8 0 11 0-2-12 5-12 9 14 14 14 6-2 11 0q6 5 7 9Z",
    "data-name": "Path 2213"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M114 125q-1-4 2-8c3-3 8 2 10 2s1-3 5-5 8 0 11 0-2-12 5-12 9 14 14 14 6-2 11 0q6 5 7 9Z",
    "data-name": "Path 2214",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m165 124 5-6",
    "data-name": "Line 262"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m150 124-2-18",
    "data-name": "Line 263"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m137 124-2-7",
    "data-name": "Line 264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m122 124-2-5",
    "data-name": "Line 265"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m165 118 2 3 5-1",
    "data-name": "Path 2215"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m151 107-2 4-4-3",
    "data-name": "Path 2216"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m153 114-4 3-3-2",
    "data-name": "Path 2217"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m136 120-4-2",
    "data-name": "Line 266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m137 121 2-5",
    "data-name": "Line 267"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m121 122 1-3",
    "data-name": "Line 268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m121 122-3-1",
    "data-name": "Line 269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m99 38 6-7a16 16 0 0 1 12-3c9 1 11 10 14 16 6 14 13 34-9 40-10 3-23 0-27-8q-5-12-2-24z",
    "data-name": "Path 2218"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M118 133h-4l-2-60-4-11 5 7-1-7-7-12 7 8V39l1 12 4-2-3 4v13l3-4-2 7Z",
    "data-name": "Path 2219"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M113 95v-1h1z",
    "data-name": "Path 2220"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m114 75-1 1-1-2z",
    "data-name": "Path 2221"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m114 83-1 1v-2z",
    "data-name": "Path 2222"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m113 64 1-1v2z",
    "data-name": "Path 2223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m116 123-2 1v-2z",
    "data-name": "Path 2224"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M114 57v2l-1-1z",
    "data-name": "Path 2225"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m113 52-1 1v-2z",
    "data-name": "Path 2226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m114 111 3-1v3z",
    "data-name": "Path 2227"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m114 114 2 1-2 1z",
    "data-name": "Path 2228"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m115 100-2 2v-3z",
    "data-name": "Path 2229"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M116 97v2l-1-1z",
    "data-name": "Path 2230"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M115 78v2z",
    "data-name": "Path 2231"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M115 107h1l1 2z",
    "data-name": "Path 2232"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m31 10 6-6a16 16 0 0 1 12-4c9 1 11 10 14 16 6 14 13 35-9 41-10 2-23 0-27-9q-4-12-1-24z",
    "data-name": "Path 2233"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m31 10 6-6a16 16 0 0 1 12-4c9 1 11 10 14 16 6 14 13 35-9 41-10 2-23 0-27-9q-4-12-1-24z",
    "data-name": "Path 2234",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M50 123h-3l-3-78-4-11 4 7v-7l-8-12 7 8 1-18 1 11 3-2-3 4 1 13 3-3-3 6Z",
    "data-name": "Path 2235"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M46 52zv2z",
    "data-name": "Path 2236"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M48 83v3l-1-2q-1-1 1-1",
    "data-name": "Path 2237"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m45 29 1 3-2-2z",
    "data-name": "Path 2238"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M46 59zl-1-1q0-2 2-2v5z",
    "data-name": "Path 2239"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M43 23v-2a1 1 0 0 1 2 1z",
    "data-name": "Path 2240"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m47 40-1-1zl-2-2 2-1v1h1Z",
    "data-name": "Path 2241"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m45 34-1 2-1-1v-2z",
    "data-name": "Path 2242"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m49 99-2-2q0-1 2-1Z",
    "data-name": "Path 2243"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m46 79-1 1z",
    "data-name": "Path 2244"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m45 61 2 1-1 2-1 1Z",
    "data-name": "Path 2245"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m45 53-1 1z",
    "data-name": "Path 2246"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M44 41zl2 2q0 2-2 3z",
    "data-name": "Path 2247"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m47 87-1 2v-3z",
    "data-name": "Path 2248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M46 103v-2l3-1v5z",
    "data-name": "Path 2249"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M47 117zl-1 1Z",
    "data-name": "Path 2250"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "m48 107-2 2v-3z",
    "data-name": "Path 2251"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M146 48a18 18 0 0 1 11 9c4 7-2 13 1 20s11 10 4 16-17-4-22-3-5 8-19 5-9-13-4-17 1-12 5-22c2-7 15-11 24-8",
    "data-name": "Path 2252"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M146 48a18 18 0 0 1 11 9c4 7-2 13 1 20s11 10 4 16-17-4-22-3-5 8-19 5-9-13-4-17 1-12 5-22c2-7 15-11 24-8",
    "data-name": "Path 2253",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m142 138-3-56 16-9-16 7v-8l4-4-4 3-2-11v16l-12-5 11 8 1 10-9-3 9 5 1 47Z",
    "data-name": "Path 2254"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M141 116v2l-2-1z",
    "data-name": "Path 2256"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M140 101v2l-1-1z",
    "data-name": "Path 2257"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m141 109-2-1 1-1v1Z",
    "data-name": "Path 2258"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M139 77zh1Z",
    "data-name": "Path 2259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M138 105z",
    "data-name": "Path 2261"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M139 100h-2v-3q3 2 2 3",
    "data-name": "Path 2262"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M139 112h-1v-2q2 0 1 2",
    "data-name": "Path 2263"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M138 116v-1l1 1z",
    "data-name": "Path 2264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M140 94v2l-1-1q-1-1 1-1",
    "data-name": "Path 2265"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m100 133 1-1 3-1 1-2a5 5 0 0 1 4-5l7 2q3 4 4 4h6l4 3Z",
    "data-name": "Path 2266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m100 133 1-1 3-1 1-2a5 5 0 0 1 4-5l7 2q3 4 4 4h6l4 3Z",
    "data-name": "Path 2267",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m123 133 2-1",
    "data-name": "Line 270"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m115 133-4-6",
    "data-name": "Line 271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m113 127-1 3-3-2",
    "data-name": "Path 2268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m115 130-1 2-3-1",
    "data-name": "Path 2269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m123 138 3-3q3-1 6-1 3-3 2-7a11 11 0 0 1 9-9q9-1 16 3c6 6 5 10 10 10s6-4 14-1q6 3 7 8Z",
    "data-name": "Path 2270"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m176 138 3-2",
    "data-name": "Line 272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m157 138-9-14",
    "data-name": "Line 273"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m135 138-3-2",
    "data-name": "Line 274"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m153 125-1 4-7-3",
    "data-name": "Path 2271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m158 130-4 5-6-2",
    "data-name": "Path 2272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M176 135v3l3-1",
    "data-name": "Path 2273"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M134 137v-1",
    "data-name": "Line 275"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0.4,
    fill: "#263238",
    "data-name": "Ellipse 33",
    rx: 0.5,
    ry: 0.4,
    transform: "translate(152 124)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M148 124z",
    "data-name": "Path 2274"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0.4,
    fill: "#263238",
    "data-name": "Ellipse 34",
    rx: 0.5,
    ry: 0.4,
    transform: "translate(144 126)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M147 133z",
    "data-name": "Path 2275"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0.4,
    fill: "#263238",
    "data-name": "Ellipse 35",
    rx: 0.5,
    ry: 0.4,
    transform: "translate(157 129)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0.4,
    fill: "#263238",
    "data-name": "Ellipse 36",
    rx: 0.5,
    ry: 0.4,
    transform: "translate(134 136)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M132 136z",
    "data-name": "Path 2276"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0.4,
    fill: "#263238",
    "data-name": "Ellipse 37",
    rx: 0.5,
    ry: 0.4,
    transform: "translate(175 135)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M178 135z",
    "data-name": "Path 2277"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0.4,
    fill: "#263238",
    "data-name": "Ellipse 38",
    rx: 0.5,
    ry: 0.4,
    transform: "translate(179 137)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M38 93s7 1 17-8-10-37-18-43-24 34-18 42 13 9 19 9",
    "data-name": "Path 2280"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m41 126-1-42 4-4-5 2v-8l7-6-6 4v-5l-1 2-2-15v23l-13-6 13 9v47",
    "data-name": "Path 2281"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m37 108 3-1v2z",
    "data-name": "Path 2282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m36 91 3 1-3 1Z",
    "data-name": "Path 2283"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M37 96h2v2z",
    "data-name": "Path 2284"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m37 88 2-1v2z",
    "data-name": "Path 2285"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M40 117zv1l-3-1z",
    "data-name": "Path 2286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M39 103h-3v-2q3 1 3 2",
    "data-name": "Path 2287"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m39 83-3 1v-2z",
    "data-name": "Path 2288"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m41 71 2 1-2 1Z",
    "data-name": "Path 2289"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M36 111q3 0 3 2h-3Z",
    "data-name": "Path 2290"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M39 76v2l-2-1z",
    "data-name": "Path 2291"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M13 126q1-4 6-5 3 2 8 0l2-5 2-5 6-2c4 2 4 8 9 9q4-1 9-1 5 2 8 5l7 4Z",
    "data-name": "Path 2292"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13 126q1-4 6-5 3 2 8 0l2-5 2-5 6-2c4 2 4 8 9 9q4-1 9-1 5 2 8 5l7 4Z",
    "data-name": "Path 2293",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m48 126 2-6",
    "data-name": "Line 276"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m39 126-4-11",
    "data-name": "Line 277"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m22 126-3-2",
    "data-name": "Line 278"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m48 125-1-4",
    "data-name": "Line 279"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m48 124 6-1",
    "data-name": "Line 280"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m39 119 2-2",
    "data-name": "Line 281"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m40 122-5-3",
    "data-name": "Line 282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m39 125-5-1",
    "data-name": "Line 283"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m38 124 3-5",
    "data-name": "Line 284"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M37 115zv-1z",
    "data-name": "Path 2294"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M37 117z",
    "data-name": "Path 2295"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0.4,
    fill: "#263238",
    "data-name": "Ellipse 39",
    rx: 0.5,
    ry: 0.4,
    transform: "translate(32 119)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0.4,
    fill: "#263238",
    "data-name": "Ellipse 40",
    rx: 0.5,
    ry: 0.4,
    transform: "translate(41 119)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0.4,
    fill: "#263238",
    "data-name": "Ellipse 41",
    rx: 0.5,
    ry: 0.4,
    transform: "translate(34 124)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0.4,
    fill: "#263238",
    "data-name": "Ellipse 42",
    rx: 0.5,
    ry: 0.4,
    transform: "translate(19 124)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M49 120zv-1z",
    "data-name": "Path 2296"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0.4,
    fill: "#263238",
    "data-name": "Ellipse 43",
    rx: 0.5,
    ry: 0.4,
    transform: "translate(46 121)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0.4,
    fill: "#263238",
    "data-name": "Ellipse 44",
    rx: 0.5,
    ry: 0.4,
    transform: "translate(53 122)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "m0 132 2-2 3-1 1-3a6 6 0 0 1 5-5 10 10 0 0 1 9 2q3 4 5 5c2 1 4-2 8-1l4 5Z",
    "data-name": "Path 2297"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m29 132 2-1",
    "data-name": "Line 285"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m18 132-5-8",
    "data-name": "Line 286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m16 124-1 3-3-2",
    "data-name": "Path 2298"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m19 127-2 3-4-1",
    "data-name": "Path 2299"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M0 0h634v83H0z",
    "data-name": "Rectangle 435",
    transform: "translate(23 202)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m594 190 12-2 1 47-22-6 8-18z",
    "data-name": "Path 2550"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m554 77-13-12 14-1 9 23 15 9-1 20-6 7Z",
    "data-name": "Path 2551"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m81 163-19-39-13-16v-5l12 14 2-19 3-2-3 23 9 16 2-29 3 3v33l7 16 3 4-10 22-5 13-1 12 3 19-11 3v-24l6-19Z",
    "data-name": "Path 2552"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "m602 246-3-2-4 2-3-2-4 2-3-2-4 2-4-2-3 2-4-2-3 2-4-2-3 2-4-2-4 2-3-2-4 2-3-2-4 2v3h71v-3l-3-2Z",
    "data-name": "Path 235",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "m477 246-3-2-4 2-3-2-4 2-4-2-3 2-4-2-3 2-4-2-3 2v3l35-1Z",
    "data-name": "Path 2129",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    d: "m442 246 4-2 3 2 4-2 3 2 4-2 3 2 4-2 4 2 3-2",
    "data-name": "Path 2130",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 85",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 82"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "freepik--Tree--inject-758"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m579 243 13-29a99 99 0 0 0 0-46q-3-12-17-40c-14-28-17-43-21-50s-36-28-43-32l-7-5",
    "data-name": "Path 222"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(0,0,0,0)",
    d: "m629 28-23 29c-8 12-28 58-28 58l18 36q10 20 11 45v38l2 9",
    "data-name": "Path 223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m586 31-1 54v1l-12 22-7-16c-6-13-14-35-13-38s21-27 22-29",
    "data-name": "Path 224"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m508 40 41 25c3 0-14-35-14-35",
    "data-name": "Path 225"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m539 29 11 18c1 2 22-23 22-23",
    "data-name": "Path 226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m606 15 4 30 19-22",
    "data-name": "Path 227"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m589 27 3 45 14-26-2-35",
    "data-name": "Path 228"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m601 243 1-13a139 139 0 0 0 3-37",
    "data-name": "Path 229"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M602 201v17",
    "data-name": "Path 230"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m600 215-2 13-3 10",
    "data-name": "Path 231"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m600 168 4 17",
    "data-name": "Path 232"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m601 187 1 9",
    "data-name": "Path 233"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m594 150-10-21",
    "data-name": "Line 83"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m586 137-9-16",
    "data-name": "Line 84"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "freepik--Leaves--inject-758"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m512 121 2 2 5-1-4-3z",
    "data-name": "Path 296"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M530 66s-2-2-5-1-6 5-6 5h7q4-3 4-4",
    "data-name": "Path 297"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M568 157s-2-3-5-2-6 5-6 5l7 1q4-3 4-4",
    "data-name": "Path 298"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m509 60-3 5q0 6 1 8l4-7z",
    "data-name": "Path 299"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m525 181-3 4q0 7 1 8l4-7z",
    "data-name": "Path 300"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m562 60 2 2q4 0 4-1l-4-2z",
    "data-name": "Path 301"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m538 54 2 2q4 0 4-1l-3-2z",
    "data-name": "Path 302"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m488 180 3 2q3 0 4-1l-4-2z",
    "data-name": "Path 303"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M572 43s1 4 4 5 7-2 7-2l-6-4q-5 0-5 1",
    "data-name": "Path 304"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M527 36s1 3 4 4 7-1 7-1l-6-5c-3-2-5 2-5 2",
    "data-name": "Path 305"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m593 29 2 5c2 2 7 2 7 2l-4-7z",
    "data-name": "Path 306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M490 94s0-4-3-5-7 1-7 1l5 5c3 2 5-1 5-1",
    "data-name": "Path 307"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M581 27s-1-3-3-5-8 1-8 1l6 5q5 0 5-1",
    "data-name": "Path 308"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M489 65s0-3-3-5-8 1-8 1l6 5q5 0 5-1",
    "data-name": "Path 309"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M489 65s0-3-3-5-8 1-8 1l6 5q5 0 5-1",
    "data-name": "Path 310",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M561 109s-1-3-4-4-7 1-7 1l5 4q5 0 6-1",
    "data-name": "Path 311"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M561 109s-1-3-4-4-7 1-7 1l5 4q5 0 6-1",
    "data-name": "Path 312",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M528 89h-5l-4 7q1 0 7-2c6-2 2-5 2-5",
    "data-name": "Path 313"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M528 89h-5l-4 7q1 0 7-2c6-2 2-5 2-5",
    "data-name": "Path 314",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M616 145h5q5-4 5-6-1-2-7 1c-6 3-3 5-3 5",
    "data-name": "Path 315"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M616 145h5q5-4 5-6-1-2-7 1c-6 3-3 5-3 5",
    "data-name": "Path 316",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M626 55h5q5-4 5-6-1-2-7 1c-6 3-3 5-3 5",
    "data-name": "Path 317"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M626 55h5q5-4 5-6-1-2-7 1c-6 3-3 5-3 5",
    "data-name": "Path 318",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M551 27a5 5 0 0 0-6 1l-4 6 7-1c3-1 3-6 3-6",
    "data-name": "Path 319"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M551 27a5 5 0 0 0-6 1l-4 6 7-1c3-1 3-6 3-6",
    "data-name": "Path 320",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M532 45a5 5 0 0 0-6 0l-4 7s5 0 7-2z",
    "data-name": "Path 321"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M532 45a5 5 0 0 0-6 0l-4 7s5 0 7-2z",
    "data-name": "Path 322",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m519 39-1 6q3 6 4 7l1-8a5 5 0 0 0-4-5",
    "data-name": "Path 323"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m519 39-1 6q3 6 4 7l1-8a5 5 0 0 0-4-5",
    "data-name": "Path 324",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M487 34s0 4 3 6 7 1 7 1l-5-6z",
    "data-name": "Path 325"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M487 34s0 4 3 6 7 1 7 1l-5-6z",
    "data-name": "Path 326",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m489 50 5-2c2-2 3-7 3-7l-7 3q-2 5-1 6",
    "data-name": "Path 327"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m489 50 5-2c2-2 3-7 3-7l-7 3q-2 5-1 6",
    "data-name": "Path 328",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m607 66 3-5q-1-7-3-8l-2 8z",
    "data-name": "Path 329"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m607 66 3-5q-1-7-3-8l-2 8z",
    "data-name": "Path 330",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M618 57s-1-4-4-5-7 1-7 1l6 5q5 0 5-1",
    "data-name": "Path 331"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M618 57s-1-4-4-5-7 1-7 1l6 5q5 0 5-1",
    "data-name": "Path 332",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M593 36s0 4 2 6 7 1 7 1l-4-7z",
    "data-name": "Path 333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M593 36s0 4 2 6 7 1 7 1l-4-7z",
    "data-name": "Path 334",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m595 52 5-2c2-2 2-7 2-7l-6 3q-2 5-1 6",
    "data-name": "Path 335"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m595 52 5-2c2-2 2-7 2-7l-6 3q-2 5-1 6",
    "data-name": "Path 336",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M538 58s0 3 3 5 7 1 7 1l-4-6a5 5 0 0 0-6 0",
    "data-name": "Path 337"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M538 58s0 3 3 5 7 1 7 1l-4-6a5 5 0 0 0-6 0",
    "data-name": "Path 338",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m540 73 5-1q4-6 3-8l-6 4q-3 4-2 5",
    "data-name": "Path 339"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m540 73 5-1q4-6 3-8l-6 4q-3 4-2 5",
    "data-name": "Path 340",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M566 65s0-3-3-4-8 1-8 1l6 5c2 2 5-2 5-2",
    "data-name": "Path 341"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M566 65s0-3-3-4-8 1-8 1l6 5c2 2 5-2 5-2",
    "data-name": "Path 342",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m561 51-5 3-1 8 6-5z",
    "data-name": "Path 343"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m561 51-5 3-1 8 6-5z",
    "data-name": "Path 344",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M556 46s-1-3-4-4-7 1-7 1l6 4q5 0 5-1",
    "data-name": "Path 345"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M556 46s-1-3-4-4-7 1-7 1l6 4q5 0 5-1",
    "data-name": "Path 346",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m551 32-5 3-1 8 6-5z",
    "data-name": "Path 347"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m551 32-5 3-1 8 6-5z",
    "data-name": "Path 348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M576 77s0 3 3 5 7 1 7 1l-5-6z",
    "data-name": "Path 349"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M576 77s0 3 3 5 7 1 7 1l-5-6z",
    "data-name": "Path 350",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m578 92 5-1 3-8-7 4q-2 4-1 5",
    "data-name": "Path 351"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m578 92 5-1 3-8-7 4q-2 4-1 5",
    "data-name": "Path 352",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m616 106-5 1c-3 1-4 6-4 6l7-2q3-4 2-5",
    "data-name": "Path 353"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m616 106-5 1c-3 1-4 6-4 6l7-2q3-4 2-5",
    "data-name": "Path 354",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m603 101-1 6q3 5 5 6v-8z",
    "data-name": "Path 355"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m603 101-1 6q3 5 5 6v-8z",
    "data-name": "Path 356",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m582 60 3 8-7-4-1-6zm-5 8q-3 3-3 5a5 5 0 0 0 6 1l5-6z",
    "data-name": "Path 357"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M595 64h-7q1-2 6-5l5 1s-1 4-4 4m-4-8-3-5-2 5 2 8z",
    "data-name": "Path 358"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m564 34-5 6s-1-5 0-8l4-4zm-9-1-5-1 2 6q6 3 7 2 0-2-4-7",
    "data-name": "Path 359"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m539 53-5 6s-1-5 0-9l4-3zm-9-1-5-1 2 5c2 3 7 3 7 3z",
    "data-name": "Path 360"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M506 36c2 2 2 7 2 7s-4-1-6-4l-1-6zm-5 8q-4 3-3 4l5 1c3-1 5-6 5-6z",
    "data-name": "Path 361"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M595 85v-8s4 3 5 6l-1 6zm7-6q4-1 4-3 0-3-4-3c-4 0-7 4-7 4z",
    "data-name": "Path 362"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m517 42-6-3q1-1 6-3c5-2 5 3 5 3s-2 3-5 3m-2-10-1-6-4 4q0 7 1 9z",
    "data-name": "Path 363"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M459 98h7q0 2-5 5l-5-1s0-3 3-4m5 8 3 5 3-6-4-7z",
    "data-name": "Path 364"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m622 27-2 8s-3-4-3-7l2-6zm-8 4q-5 0-5 2 0 3 4 4 6 0 7-2 0-3-6-4",
    "data-name": "Path 365"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m477 123-3 3v5l3-4z",
    "data-name": "Path 366"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m477 123-3 3v5l3-4z",
    "data-name": "Path 367",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m570 136-3 2v5l3-3z",
    "data-name": "Path 368"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m570 136-3 2v5l3-3z",
    "data-name": "Path 369",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m462 187-3 2v5l3-3z",
    "data-name": "Path 370"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m462 187-3 2v5l3-3z",
    "data-name": "Path 371",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m575 80-3 1-3 4 4-1z",
    "data-name": "Path 372"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m575 80-3 1-3 4 4-1z",
    "data-name": "Path 373",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Flying kite-bro"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#eceff1",
    "data-name": "freepik--Plants--inject-122"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m421 237 2-1h-1l-2-1a1 1 0 0 0 0 2z",
    "data-name": "Path 2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432 231zl-1-1h-1v1l1 1z",
    "data-name": "Path 2028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433 248zv-1h2v3-4h2v-2h-1l-1 2v-2q0-1 0 0l-1-1 2-1 1-1-1-1-2 2v1-1l-1-2v-1h2v-2l-2 1v1-1l-1-2 2-1v-2l-2 2v1-3l1-1 1-1v-1l-2 2v-2l1-1 1-2h-1l-1 2v7-1l-2-1h-1v1l1 1h2v2l1 1-2-1h-1v1l1 1 2-1v1l1 3v-1l-2-1v1l1 1h1v1l1 2v1l-1-1-1-1v-1h-1v3h1-1v-1h-1l-1-1 1-2v-1h-1v3-1l-2-1h-1l1-2 1-1-1-1h-1v4l-1-1-1-1 1-2v-2h-1v3l-1-1-1-1 2-1v-2h-1l-1 2v1-2l-1-1 1-1-1-2h-1l1 3v1l1 1 1 2 1 2-1-1h-2v2a1 1 0 0 0 2 0l1-1 1 1 1 1v-1l-2 1v1h1l2-1 1 1 1 1h-2v1h1l1-1 1 1 1 1v1-1h-2v1l1 1 1-1z",
    "data-name": "Path 2029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m567 235-1-1 1-1h2v1a1 1 0 0 1-2 1",
    "data-name": "Path 2030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 229zl1-2h1v1l-1 1z",
    "data-name": "Path 2031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557 243v1h-1zh-2v2h-1l1-3h-2v-2h1l1 2v-3h-1l-1-1v-1h1l1 1v1l1-1v-2h-1l-1-1 1-1 1 1v1l1-1v-2h-1l-1-1v-1h1l1 1v1-3h-1l-1-1 1-1 1 2v-2l-1-1v-2h1v5l1 1-1 2 1-1 1-1 1 1-1 1h-2v3l1-1h1v1h-2l-1 1v2l1-1h1v1l-1 1h-2v2l1-1 1-1v3l1-1 1-1-1-1v-2h1v3-1l2-1-1-1v-1l1-1 1 2-1 1 1-1 1-1v-1l-1-1 1-1 1 2-1 1 1-1 1-1-1-1v-2h1v3-1l1-1-1-2 1-1h1l-1 2v1l-1 1v2l-1 1h2v1h-1l-1-1-2 1v1h2v1h-2l-1-1v1l-1 1h-1 2v1h-1l-1-1-1 1-1 1h2l1 1h-4",
    "data-name": "Path 2032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m471 237-2-1 1-1h3v1z",
    "data-name": "Path 2033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455 230zl2-2 1 1v1l-1 1z",
    "data-name": "Path 2034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390 237 2-1-1-1h-3a1 1 0 0 0 0 2z",
    "data-name": "Path 2036"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401 231-1-1-2-2v1l1 1z",
    "data-name": "Path 2037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396 247 1 1zv-1h2v3h1v-2l-1-1 2-1 1-1-1-1-2 2v1-4h1l1-2-1-1-1 2v1l-1-1v-2l-1-1h2l1-1-1-1-2 1v1-1l-1-2h2l1-2h-1v-1l-2 2v1-3l2-1 1-1-1-1-2 2v-2l2-1v-3h-1l-1 3v7-1l-2-1-1 1 1 1h2l1 2v1l-2-1h-1v1l1 1h2l1 2v1l-2-1v1l1 1h1l1 1q1 1 0 0v2-1l-1-1h-2v2zh-1v-1h-1v-1l-1-1 1-1v-2h-1v3h-1l-1-1-1-1 1-1v-2h-1v3l-1-1-1-1 1-2v-1l-1-1-1 3 1 1-2-2v-1l1-1v-2h-1v3l-1-2v-4h-1v3h1v1l1 2v1l2 2-1-1-2 1v1h1l2-1 1 1 1 1h-3v1l1 1h1l1-2 1 1 1 1h1l-3 1 1 1h1l1-1h1v1h1v1h-3l1 1h1z",
    "data-name": "Path 2038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m616 246-1 1zv-1h-2v3h-1l1-3-2-1v-2l2 2v1-4h-1l-1-2 1-1 1 2 1 1v-1l1-2v-1h-2l-1-1 1-1 2 1v1-1l1-2-2-1-1-1 1-1 2 2v1-3l-2-1v-2l2 2v-2l-2-2v-1l1-1 1 3v7-1l2-1h1v1l-1 1h-2v2l-1 1 2-1h1v1l-1 1h-2l-1 2v1q0-2 2-1v1l-1 1h-1l-1 1v2-1l2-1h1v2l-1 1h1v-1l1-1 1-1-1-1v-2h1v3h1l1-2h1l-1-1v-2h1v3l1-1 1-1-1-2v-1l1-1 1 3-1 1 2-2v-1l-1-1v-2h1v3-1l1-1v-4h1v3h-1v3l-1 1-1 2v-1l2 1h1l-1 1h-1l-2-1-1 1-1 1h3v1h-2l-1-1-1 1-1 1h-1l3 1-1 1h-1l-1-1h-1v1l-1 1h3l-1 1h-1z",
    "data-name": "Path 2127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404 241-1-1v-1h2z",
    "data-name": "Path 2042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m397 236 1-2v1h1z",
    "data-name": "Path 2043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m474 238-2-1h3v1z",
    "data-name": "Path 2045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 228v-1l2-2v1l-1 1z",
    "data-name": "Path 2046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m450 243-1 1h-1zh1l-1-1h-1v3h-1l1-2v-1l-2-1v-2h1l1 2v1-4h-1l-1-1v-1h1l1 1v1l1-1v-2h1l-2-1-1-1h1v-1l1 2 1 1v-3l-1-1-1-1v-1h1l1 2v1h1v-3l-2-1-1-1h1v-1l2 2v-1l-1-1-1-1v-2h1l1 2-1 1 1 1v5-1l2-1v1l-1 1h-1l-1 2v1-1l2-1v1l-1 1h-1l-1 3 2-1v1l-1 1h-2v3-1l1-1 1-1v3l1-1h1v-1l-1-1v-2h1l1 2-1 1h1l2-2-1-1v-2h1v3l1-1 1-1-1-1v-2h1l1 2-1 1 1-2h1l-1-2v-2l1 1v2l1-1v-1l-1-2 1-1h1v2l-1 1v1l-1 1-1 1-1 2h3v1h-1l-2-1-1 1-1 1h3v1h-2l-1-1-2 2h2v2a1 1 0 0 1-2 0l-1-1h-1v1l-1 1 1-1h2v2a1 1 0 0 1-2 0z",
    "data-name": "Path 2047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 240h-1zh2v1z",
    "data-name": "Path 2048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m412 236 1-1 1-2v1h1l-1 1z",
    "data-name": "Path 2049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411 248zl1-1-1-1h-1zv1-2h-1l-1-1v-1h1l1 1v1-3h-1v-2l1 2h1v-2l-1-1v-2l1 2 1-1v-1h-1l-1-1 1-1 1 1v1-2l-1-1v-1l1 1v-2l-1-1v-1h1v7l1-1 1-1v2h-2v2l1-1 1 1-1 1h-2v2l1-1h1v1l-1 1h-2v1q0 1 0 0v1q0 1 0 0l1-1 1-1v3-1h1v-1h1l-1-1v-2h1v3-1l1-1h1l-1-1v-1h1v2l1-1 1-1-1-1v-1h1v2-1h1l-1-1v-2h1v2l1-1-1-2 1-1h1l-1 2v1l-1 1v1l-1 1h2v1h-2l-1 1h-1 2v1h-1l-1-1-1 1-1 1h2v1h-2v-1l-1 1-1 1h2v1h-1z",
    "data-name": "Path 2050"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#eceff1",
    "data-name": "freepik--Plants--inject-122"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m231 234-1-1v-1h3v1z",
    "data-name": "Path 2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217 229 1-2 2-2 1 1v1l-1 1z",
    "data-name": "Path 2028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218 244 1 1h1zl-1-1 1-1h1v1l1 2v-3l1-1 1-2-1-1-1 3v1-2l-1-1q0-1 0 0v-2h2l1-2h-1v-1l-2 2v1-1l-1-2-1-1h2l1-2v-1h-1l-1 2-1 1v-1l-1-3h2l1-2v-1h-1l-2 2v1-3l2-1 1-1v-1h-1l-2 1v1-3l2-1v-3h-1l-1 3v8-1l-3-1v1l1 1h2l1 3v1l-2-2-1 1v1l1 1h2l1 3h1-1q0-2-2-1v1l1 1h2v4-1l-1-1v-1h-2v3l1 1-1-1-1-1-1-1 1-2v-2h-1v4l-1-1-2-1v-1l1-1v-2l-1-1v1l-1 2 1 1-2-1-1-1 1-2v-2h-1l-1 3 1 1-2-2v-1l1-2 1-1-1-1h-1v4-1l-1-2v-4h-2l1 3 1 1v2l1 2 2 2-1-1-3 1 1 1h1l2-1 1 1 1 1h-2l-1 1 1 1h1l2-1 3 2h-3v2h2l1-2 1 1v1l1 1zh-4l1 1h1z",
    "data-name": "Path 2029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52 230 2-1-1-1-3-1a1 1 0 0 0 0 2z",
    "data-name": "Path 2030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 226v-2l-3-2-1 1v1l2 1z",
    "data-name": "Path 2031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 243v1h1zl-1-1 1-1h2v4h1l-1-4 2-1 1-2v-1h-1l-2 3v1-3l-1-2 2-1 1-1v-1l-1-1-2 3v1-1l-1-3v-1h2l1-2v-1h-1l-2 2v1l-1-2-1-2 2-1 1-2-1-1-1 2-1 2v-5h2l1-1v-1l-1-1-2 2v1-2l1-1 1-2 1-2-1-1h-1l-1 3v10-1l-3-2v2l1 1h2l1 2v2-1l-2-1-1 1v1l1 1h3l1 3v1l-3-2v2l1 1h2v1l1 1v2-1l-2-1v-1h-1l-1 3 1 1-1-1-1-1-1-1 1-2v-3h-1l-1 4 1 1-1-1-2-2h-1l1-2 1-2-1-1-1 1v4l-1-1-2-2 1-2v-2h-1l-1 3 1 1-2-2v-1l1-2v-3h-1l-1 3v1l-1-2v-1l1-2-1-2h-1v3l1 1 1 3 1 2 2 2h-4v2h2l2-2 1 2 2 1h-4v1l1 1h2l1-2 1 1 2 1v1h-3v1l1 1h1l2-2 1 1v1l1 1 1 1-1-1h-3v2h2l2-1z",
    "data-name": "Path 2032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163 237 2-1-1-1h-2v1z",
    "data-name": "Path 2033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178 230zl-2-2v2l1 1z",
    "data-name": "Path 2034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104 244 1 1h1zl1-1h1v3h1v-2l-1-1 2-1v-1h-1l-1 1v1-3l1-1 1-1-1-1-1 2v1l-1-1v-3h1l1-1-1-1-1 2-1-1v-2h1l1-1v-1h-1l-1 2-1-1v-1l2-1 1-1-1-1-1 2h-1l1-1v-1l1-1v-2h-1v4l-1 1v3q0-2-2-1v1l1 1 1-1 1 2v1l-2-1v1l1 1h2v3-1l-1-1-1 1v1h3v3l-1-2h-1v3l-1-1v-1h-1l1-2v-1h-1v2h-1l-1-1h-1l1-2v-1h-1v3l-1-1-1-1 1-2v-1h-1v3l-1-2v-1l1-1v-2h-1l-1 3h1-1v-5h-1v2l1 1v2l1 1 1 2-1-1h-1l-1 1 1 1h1l1-1 1 1 1 1v-1l-2 1v1h1l1-1h1l1 1 1 1-1-1-1 1h-1l1 1h1l1-1 1 1 1 1q1 1 0 0h-3l1 1h1z",
    "data-name": "Path 2035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262 237 1-1v-1h-3a1 1 0 0 0 0 2z",
    "data-name": "Path 2036"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276 231-1-1-1-2h-1v1l1 1z",
    "data-name": "Path 2037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271 236 2-2v1l-1 1z",
    "data-name": "Path 2043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271 248zl-1-1h-1zv-2h-1v-2l1 2v-2h1l-2-1v-1l1 1 1 1v-3h-1v-2l1 2 1-1v-1h-1l-1-1 1-1 1 1v1-2l-1-1h-1l1-1 1 1v-1l-1-1v-2h1v7-1h2l-1 1h-1v2l1-1v2l-1-1-1 1v2-1h1v1h-1v1h-1v1l1-1h1v2-1h1v-3l1 2h-1 1l1-1v-3l1 2-1 1 1-1 1-1-1-1v-1h1v2l1-1v-1l-1-1v-1h1v2l1-1v-3h1l-1 2v2l-1 1-1 1h2v1h-1l-1-1-1 1v1-1l1 1v1h-1l-1-1-1 1h1v1h-1l-1-1v1l-1 1h2v1h-1z",
    "data-name": "Path 2044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160 238 1-1h-3v1z",
    "data-name": "Path 2045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 233v-1l-2-2v1l1 1z",
    "data-name": "Path 2046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 244zh-2v2h-1v-2h1l-2-1v-2h1l1 2v-3h-1l-1-1h1v-1l1 2 1-2-1-1-1-1h1l1 1v1l1-1v-2h-1l-1-1v-1h1l1 1v1-3h-1l-1-1h1l1 1v-2l-1-1v-1l1 1v6-1l2-1v1l-1 1h-1v2l1-1v2h-2v2l1-1v2h-2v2l1-1v-1l1 1v2-1h1l1-1-1-1v-2l1 1v2l1-1 1-1-1-1v-1h1v2h1l1-1-1-2v-1h1v2l1-1-1-1v-2h1v2l1-1v-3h1l-1 2v1l-1 1v1l-1 2v-1l2 1v1h-1l-1-1-1 1h-1 2v1h-2l-2 1h2v1h-3v1h-1 2v1h-3",
    "data-name": "Path 2047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233 237 1-1-1-1h-1v1z",
    "data-name": "Path 2048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 232zl-2-1v1l1 1z",
    "data-name": "Path 2049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 244zh2v2-2l1-1v-2l-1 2v-1h-1v-1l1-1 1-1h-1l-1 1-1-2h1l1-1v-1h-1l-1 1v1-1l-1-2h2v-2l-2 2v-2h1l1-1v-1l-2 1v1-2l1-1 1-1-1-1-1 2v5l-2-1v1h2l1 2v1-1h-2v1h2l1 2v1-1l-2-1v1l1 1h1v1q0 1 0 0v2-1l-1-1h-1v2zh-1v-1l-1-1 1-1v-1h-1v2h-1l-1-1v-1l1-1v-1h-1v2h-1l-1-1 1-1v-1l-1-1v3l-1-1v-1l1-1v-1l-1-1v1l-1 1 1 1-1-1v-3l-1-1v2l1 1v1l1 2 1 1h-2v1h1l1-1 1 1h1-1l-1 1v1h1l1-1 1 1h1-2v1h3v1zh-1l-1 1h3Z",
    "data-name": "Path 2050"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "freepik--Floor--inject-122"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M303 249h185",
    "data-name": "Line 254"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    "data-name": "freepik--Floor--inject-122"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283 249h11",
    "data-name": "Path 2555"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M193 249h56",
    "data-name": "Line 310"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 249h203",
    "data-name": "Path 62422"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "freepik--Floor--inject-122"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M500 249h188",
    "data-name": "Line 254"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 87"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "m201 246 2-2 4 2 3-2 3 2 3-2 3 2 3-2 3 2 4-2 3 2 3-2 3 2 3-2 3 2 3-2 3 3v1h-54Z",
    "data-name": "Path 2125",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "M115 248H53l5-2 3-2 3 2 3-2 3 2 3-2 4 2 3-2 3 2 3-2 3 2 3-2 3 2 4-2 3 2 3-2 3 2 3-2 3 2 3-2 3 2 2-2 4 2 3-2 3 2 3-2 3 2 3-2 3 2 4-2 3 2 3-2 3 2 3-2 3 2 3-2 4 2 3-2 3 2 3-2 3 2v2z",
    "data-name": "Union 95",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "m327 246 3-3 4 3 4-3 4 3 3-3 4 3 4-3 3 3 4-3 4 3 4-3 3 3 4-3 4 3 3-3 4 4v1h-64Z",
    "data-name": "Path 2553",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    d: "m124 244-3 2-4-2-3 2-3-2-3 2-3-2-3 2-3-2-4 2-3-2-3 2-3-2-3 2-3-2-3 2-4-2-3 2-3-2-3 2-3-2-3 2-3-2-4 2",
    "data-name": "Path 2123",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    d: "m247 244-3 2-3-2-3 2-3-2-3 2-3-2-4 2-3-2-3 2-3-2-3 2-3-2-3 2-4-2-3 2-3-2-3 2",
    "data-name": "Path 2126",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    d: "m124 244 3 2 3-2 3 2 3-2 3 2 3-2 4 2 3-2 3 2 3-2 3 2 3-2 3 2 3-2 4 2 3-2 3 2",
    "data-name": "Path 70596",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    d: "m382 243-3 3-4-3-4 3-3-3-4 3-4-3-4 3-3-3-4 3-4-3-3 3-4-3-4 3-4-3-3 3-4-3-4 3",
    "data-name": "Path 2554",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 86",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "freepik--Tree--inject-758"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "m81 243-8-18a64 64 0 0 1 0-30q2-8 11-26 12-26 13-32c1-6 24-18 28-21l5-3",
    "data-name": "Path 222"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "m49 105 15 18c5 7 18 38 18 38l-11 23q-6 13-7 29l-1 24-1 7",
    "data-name": "Path 223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "M77 106v35l1 1 7 14 5-10c3-9 9-23 8-25l-14-19",
    "data-name": "Path 224"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "m127 112-26 16c-2 0 9-23 9-23",
    "data-name": "Path 225"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "m107 105-7 11-14-14",
    "data-name": "Path 226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "m64 96-2 19-13-14",
    "data-name": "Path 227"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "m75 103-2 30-9-17 1-23",
    "data-name": "Path 228"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "m67 245-1-9-1-24",
    "data-name": "Path 229"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "m66 216 1 11",
    "data-name": "Path 230"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "m68 225 1 9 2 6",
    "data-name": "Path 231"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "m68 195-3 11",
    "data-name": "Path 232"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(232,24,24,0)",
    d: "M67 207v6",
    "data-name": "Path 233"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m72 183 6-13",
    "data-name": "Line 83"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m77 175 6-10",
    "data-name": "Line 84"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "freepik--Leaves--inject-758"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m125 164-2 2-3-1 3-1z",
    "data-name": "Path 296"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m113 129 3-1 4 3-4 1z",
    "data-name": "Path 297"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m89 188 3-1q4 2 4 3h-5z",
    "data-name": "Path 298"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m126 125 3 3-1 5-3-4z",
    "data-name": "Path 299"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m116 203 2 3-1 5-2-4z",
    "data-name": "Path 300"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m93 125-2 2-3-1 3-1z",
    "data-name": "Path 301"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m108 121-1 2-3-1 2-1z",
    "data-name": "Path 302"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m140 203-2 1h-2l2-2z",
    "data-name": "Path 303"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m86 114-3 3q-3 0-4-1l4-3z",
    "data-name": "Path 304"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m115 109-2 3q-4 0-5-1l4-2z",
    "data-name": "Path 305"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m73 105-2 3q-3 3-4 2l2-5z",
    "data-name": "Path 306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m139 147 2-3h5l-4 3z",
    "data-name": "Path 307"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m80 104 2-3h5l-4 3z",
    "data-name": "Path 308"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m140 128 2-3 4 1-3 3z",
    "data-name": "Path 309"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m140 128 2-3 4 1-3 3z",
    "data-name": "Path 310",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m93 157 3-3q4 0 4 1l-3 3z",
    "data-name": "Path 311"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m93 157 3-3q4 0 4 1l-3 3z",
    "data-name": "Path 312",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M114 144h4l2 4-4-1z",
    "data-name": "Path 313"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M114 144h4l2 4-4-1z",
    "data-name": "Path 314",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57 180h-3l-3-4 5 1z",
    "data-name": "Path 315"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M57 180h-3l-3-4 5 1z",
    "data-name": "Path 316",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51 122h-4l-3-4h5z",
    "data-name": "Path 317"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M51 122h-4l-3-4h5z",
    "data-name": "Path 318",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M100 104h3l3 4-5-1z",
    "data-name": "Path 319"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M100 104h3l3 4-5-1z",
    "data-name": "Path 320",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M112 115h3l3 5-4-1z",
    "data-name": "Path 321"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M112 115h3l3 5-4-1z",
    "data-name": "Path 322",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m120 112 1 4-3 4v-6z",
    "data-name": "Path 323"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m120 112 1 4-3 4v-6z",
    "data-name": "Path 324",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m141 109-2 3-5 1 4-4z",
    "data-name": "Path 325"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m141 109-2 3-5 1 4-4z",
    "data-name": "Path 326",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M140 119a3 3 0 0 1-4-2l-1-4 4 2z",
    "data-name": "Path 327"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M140 119a3 3 0 0 1-4-2l-1-4 4 2z",
    "data-name": "Path 328",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m63 129-2-3 2-5 2 4z",
    "data-name": "Path 329"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m63 129-2-3 2-5 2 4z",
    "data-name": "Path 330",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m56 123 2-3q4 0 5 1l-4 3z",
    "data-name": "Path 331"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m56 123 2-3q4 0 5 1l-4 3z",
    "data-name": "Path 332",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m73 110-2 3-5 1 3-4z",
    "data-name": "Path 333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m73 110-2 3-5 1 3-4z",
    "data-name": "Path 334",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m71 120-3-1-2-5 4 2z",
    "data-name": "Path 335"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m71 120-3-1-2-5 4 2z",
    "data-name": "Path 336",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m108 124-2 3-5 1 3-4z",
    "data-name": "Path 337"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m108 124-2 3-5 1 3-4z",
    "data-name": "Path 338",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m106 134-3-1-2-5 4 2z",
    "data-name": "Path 339"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m106 134-3-1-2-5 4 2z",
    "data-name": "Path 340",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m90 128 2-2h5l-4 3z",
    "data-name": "Path 341"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m90 128 2-2h5l-4 3z",
    "data-name": "Path 342",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m93 119 3 2 1 5-4-3z",
    "data-name": "Path 343"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m93 119 3 2 1 5-4-3z",
    "data-name": "Path 344",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m96 116 3-3 4 1-4 3z",
    "data-name": "Path 345"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m96 116 3-3 4 1-4 3z",
    "data-name": "Path 346",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m100 107 3 2v5l-3-3z",
    "data-name": "Path 347"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m100 107 3 2v5l-3-3z",
    "data-name": "Path 348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m83 136-1 3q-4 2-5 1l3-4z",
    "data-name": "Path 349"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m83 136-1 3q-4 2-5 1l3-4z",
    "data-name": "Path 350",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m82 146-3-1q-3-4-2-5l4 2z",
    "data-name": "Path 351"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m82 146-3-1q-3-4-2-5l4 2z",
    "data-name": "Path 352",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57 155h4l2 5-4-2z",
    "data-name": "Path 353"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M57 155h4l2 5-4-2z",
    "data-name": "Path 354",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M66 152v3l-3 5v-6z",
    "data-name": "Path 355"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M66 152v3l-3 5v-6z",
    "data-name": "Path 356",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m79 125-1 5 4-3v-3zm3 5 2 3-3 1-3-4z",
    "data-name": "Path 357"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m71 128 4-1-3-3-4 1zm3-6 1-3 2 3-2 5z",
    "data-name": "Path 358"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m91 108 3 4v-5l-3-2zm6 0 3-1-1 4-5 1z",
    "data-name": "Path 359"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m108 120 3 4v-5l-3-2zm5 0 3-1-1 4-4 1z",
    "data-name": "Path 360"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m129 109-2 5 4-2 1-4zm3 6 2 3h-4l-3-4z",
    "data-name": "Path 361"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M71 141v-5l-3 4 1 4zm-5-4-2-2 3-1 4 2z",
    "data-name": "Path 362"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m121 113 5-2-5-1-3 2zm2-6v-4l3 3v5z",
    "data-name": "Path 363"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m159 150-5-1 4 4 3-1zm-4 5-1 3-2-4 2-5z",
    "data-name": "Path 364"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m54 104 1 5 2-5-1-3zm5 2 3 1-2 3-5-1z",
    "data-name": "Path 365"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m147 166 2 1v4l-2-2z",
    "data-name": "Path 366"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m147 166 2 1v4l-2-2z",
    "data-name": "Path 367",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m87 174 2 2v3l-2-2z",
    "data-name": "Path 368"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m87 174 2 2v3l-2-2z",
    "data-name": "Path 369",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m157 207 2 1v4l-2-2z",
    "data-name": "Path 370"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m157 207 2 1v4l-2-2z",
    "data-name": "Path 371",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M84 138h2l2 3-3-1z",
    "data-name": "Path 372"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M84 138h2l2 3-3-1z",
    "data-name": "Path 373",
    opacity: 0.3
  })))), /*#__PURE__*/React.createElement("g", {
    stroke: "#263238",
    "data-name": "freepik--Streetlight--inject-734",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M439 246h-3l1-99h2Z",
    "data-name": "Path 24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M440 147h-5l-1-9h7Z",
    "data-name": "Path 25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M440 147h-5v-9h5Z",
    "data-name": "Path 26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M434 137h8v1h-8z",
    "data-name": "Rectangle 5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M434 146h7v2h-7z",
    "data-name": "Rectangle 6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M435 136h5v1z",
    "data-name": "Rectangle 7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M437 134h1v2h-1z",
    "data-name": "Rectangle 8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M435 240h6v8h-6z",
    "data-name": "Rectangle 9"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "M124 26s1-5-1-7-5-1-8-2 1-4-4-7-7 0-8 3-1 4-3 3a3 3 0 0 0-5 3q1 4-2 4l-6 1q2 2-1 2l-7 1-5 2h-2 57l-1-2z",
    "data-name": "Path 1052",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "M382 26s0-4-1-7-4-1-7-1 1-4-3-7-6 0-6 3-1 4-3 3-4 0-4 2 0 4-2 4-4 0-5 2 2 1-1 1l-5 1-4 2h-2 47l-1-2z",
    "data-name": "Path 2128",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ecf0f1",
    "data-name": "freepik--Cloud--inject-587",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M487 21s0-6-2-9-6-1-9-2 1-5-5-9-9 1-10 4-1 5-4 4a4 4 0 0 0-6 3q1 5-2 5-6 0-7 2c-1 2 3 2-2 2s-7 1-8 2l-6 1-3 1h70l-2-3z",
    "data-name": "Path 959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487 21s0-6-2-9-6-1-9-2 1-5-5-9-9 1-10 4-1 5-4 4a4 4 0 0 0-6 3q1 5-2 5-6 0-7 2c-1 2 3 2-2 2s-7 1-8 2l-6 1-3 1h70l-2-3z",
    "data-name": "Path 960",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    d: "m538 246 4-2 3 2 4-2 3 2 4-2 4 2 3-2 4 2 3-2 4 2 3-2 4 2 4-2 3 2 4-2 3 2 4-2 4 2 3-2 4 2",
    "data-name": "Path 236",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    d: "m502 246 4-2 4 2 3-2 4 2 3-2",
    "data-name": "Path 62424",
    opacity: 0.7
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    "data-name": "freepik--Window--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M300 362h288v300H300z",
    "data-name": "Rectangle 9416"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m551 422 8 9",
    "data-name": "Path 71993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m354 465 5 5",
    "data-name": "Path 71994"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m515 386 22 24",
    "data-name": "Line 1624"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m314 425 22 24",
    "data-name": "Line 1726"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m537 401 21 23",
    "data-name": "Line 1626"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m336 439 21 23",
    "data-name": "Line 1727"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M294 356h300v313H294z",
    "data-name": "Rectangle 9436"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57379"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    d: "M492 362h5v300h-5z",
    "data-name": "Rectangle 9437"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57378"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    d: "M390 362h5v300h-5z",
    "data-name": "Rectangle 9458"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 194.7,
    cy: 22.3,
    fill: "#627680",
    stroke: "#707070",
    "data-name": "Ellipse 1418",
    opacity: 0.1,
    rx: 194.7,
    ry: 22.3,
    transform: "translate(120 767)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57406"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "Group 57349"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#627680",
    d: "M367 629h65v3h-65z",
    "data-name": "Rectangle 9448"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d3dade",
    d: "m409 572-15 60h49l14-58Z",
    "data-name": "Path 70408"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m279 701 19 73 1 1 1-1-12-75Z",
    "data-name": "Path 70584",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M294 684s6 4 15 28l20 56q1 6 5 7c4 1 11-12 10-13l-6-7-4-46c-1-10 2-23-4-31s-29 0-29 0Z",
    "data-name": "Path 70553"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m340 755-2 3 3 6s-5 5-8 5l-6 2 4 5 5 9q1 2 5 1c4-1 10-7 13-9l17-6c2-1 8-11 5-12s-3 0-7 1-13 0-18-2l-7-1Z",
    "data-name": "Path 70554"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M336 784zq1 2 5 1c4-1 10-7 13-9l17-6c2-1 8-11 5-12l-1-1v1q0 5-4 9c-4 4-11 2-21 7z",
    "data-name": "Path 70555"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M341 752c0-7-7-40-7-43 0-11 2-23-4-31s-29 0-29 0l-7 6s6 4 15 28l13 47Z",
    "data-name": "Path 70556"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m322 539 1 6-3 4-1-4v-1l-2 2-4 2q-1-1 1-5 3-6 8-4",
    "data-name": "Path 70557"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M328 546c-3-2-7 4-13 2v-4q3-4 8-6c5-2 3-3 3-4l-5 2-5 2h-1l-7 2q-3 5-4 9l-2 4c-2 3-38 29-38 29l2 22 41-46 4-2 10-4 7-4q2-1 0-2",
    "data-name": "Path 70558"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m285 567-21 15 2 23 26-29Z",
    "data-name": "Path 70559"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M272 652s18-1 44 3 36 9 35 14c-3 21-51 88-51 88l1 10s-2 2-8 2-13-8-13-8 7-7 9-15l23-61s-27 6-56 1 16-34 16-34",
    "data-name": "Path 70560"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M316 655c-26-4-44-3-44-3s-46 29-16 34 56-1 56-1l-27 65 20 7c14-21 44-76 46-88q3-8-35-14",
    "data-name": "Path 70561"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m300 757-2 3-2 4-9-3-6-3s-3 0-3 2l-1 7-3 9 1 3 22 5c11 4 23 2 25 2s7-4 4-6-17-8-20-12z",
    "data-name": "Path 70562"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M325 779q1 5-6 6c-7 1-12-1-23-5l-21-7-1 3 1 3 22 5c11 4 23 2 25 2s7-4 4-6z",
    "data-name": "Path 70563"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m215 586-3 29 5 53q1 14 10 18c9 4 23 4 30 2s15-18 18-24 4-10 3-11l-4-5-8-58c-2-12 0-13-6-18s-35-8-45 14",
    "data-name": "Path 70564"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m256 671-3 2",
    "data-name": "Path 70565"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M273 650a71 71 0 0 1-15 19",
    "data-name": "Path 70566"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M269 651s-9 8-18 13",
    "data-name": "Path 70567"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m276 510 3 9q1 6 3 8 4 1 5 3c1 2-4 5-4 5v15c-1 2-14 2-14 2l-9 19-21-11 4-14s-7-12-7-18 12-16 20-18 20 0 20 0",
    "data-name": "Path 70568"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m269 552-7-2 2 10Z",
    "data-name": "Path 70569"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M278 524v3l-2-2q-1-2 1-3 2 0 1 2",
    "data-name": "Path 70570"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M274 538s3 2 6 1",
    "data-name": "Path 70571"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M275 505s3 6 1 10-9 6-12 10l-7 11c-2 1-5-7-7-7s-6 6-3 12a10 10 0 0 0 9 5s-9 5-11 5-7-3-10-6-11-12-12-18 9-16 9-16-11-1-8-5 12-7 12-7-1-6 1-7 18 4 18 4-4-6 2-6 17 7 18 15",
    "data-name": "Path 70572"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m254 533 33-14",
    "data-name": "Line 1698"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M278 518a6 6 0 0 1 5 10",
    "data-name": "Path 70573"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M266 578s0-8-2-10-17-10-24-12-14 1-19 2-7 6-9 16-2 15 2 15 9-11 21-13 23 0 25 1z",
    "data-name": "Path 70574"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m228 570-4 1",
    "data-name": "Path 70575"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m266 578-22-11q-5-1-13 2",
    "data-name": "Path 70576"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m342 619-1 6-1-5-2 4c-1 1-1-3-1-3l1-4Z",
    "data-name": "Path 70577"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M332 614h7l3 2 1 3-12-3Z",
    "data-name": "Path 70578"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M334 616h12l1 9h-1l-3-6-8 1s-2-2-1-4",
    "data-name": "Path 70579"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M243 583s-6 5-4 18 19 46 20 49 8 3 11 3 56-22 56-22l7-3 6-7h11c2-1-2-1-4-2l-14-5-4 1-10 9c-1 2-43 9-43 9s-10-46-14-50-10-3-10-3",
    "data-name": "Path 70580"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m298 642 28-11 7-3 6-7h11c2-1-2-1-4-2l-14-5-4 1-10 9-23 5Z",
    "data-name": "Path 70581"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m237 702-26 77h-1q0 0 0 0l17-79Z",
    "data-name": "Path 70598",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m264 701 21 94 1 1 1-1-12-96Z",
    "data-name": "Path 70585"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m223 703-29 94h-2l20-96Z",
    "data-name": "Path 70599"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M262 684s-24-6-31-24-9-64-17-68-20 9-21 38 1 62 8 69c6 7 13 8 46 9 30 0 43-3 47-6s9-16 3-16-28 0-35-2",
    "data-name": "Path 70586"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57394"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#627680",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M331 639h277v9H331z",
    "data-name": "Rectangle 9414"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M323 632h293v7H323z",
    "data-name": "Rectangle 9415"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57407"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57323"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#627680",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M355 802h-6l-2-154h11Z",
    "data-name": "Path 70417"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#627680",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M590 802h-5l-3-154h11Z",
    "data-name": "Path 70418"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessWelcomeBannerTabletOffice);
export default __webpack_public_path__ + "static/media/business-welcome-banner-tablet-office.3b5d2d4e19829ba4b03aae40ac644658.svg";
export { ForwardRef as ReactComponent };